(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', 'kotlin', 'snabbdom', 'snabbdom-kotlin-jsLegacy', 'snabbdom', 'jquery', 'jquery-kotlin-jsLegacy', 'kvision-kvision-common-types-jsLegacy', 'kotlinx-serialization-kotlinx-serialization-core-jsLegacy', 'kotlinx-serialization-kotlinx-serialization-json-jsLegacy'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('kotlin'), require('snabbdom'), require('snabbdom-kotlin-jsLegacy'), require('snabbdom'), require('jquery'), require('jquery-kotlin-jsLegacy'), require('kvision-kvision-common-types-jsLegacy'), require('kotlinx-serialization-kotlinx-serialization-core-jsLegacy'), require('kotlinx-serialization-kotlinx-serialization-json-jsLegacy'));
  else {
    if (typeof kotlin === 'undefined') {
      throw new Error("Error loading module 'kvision-jsLegacy'. Its dependency 'kotlin' was not found. Please, check whether 'kotlin' is loaded prior to 'kvision-jsLegacy'.");
    }if (typeof Snabbdom === 'undefined') {
      throw new Error("Error loading module 'kvision-jsLegacy'. Its dependency 'snabbdom' was not found. Please, check whether 'snabbdom' is loaded prior to 'kvision-jsLegacy'.");
    }if (typeof this['snabbdom-kotlin-jsLegacy'] === 'undefined') {
      throw new Error("Error loading module 'kvision-jsLegacy'. Its dependency 'snabbdom-kotlin-jsLegacy' was not found. Please, check whether 'snabbdom-kotlin-jsLegacy' is loaded prior to 'kvision-jsLegacy'.");
    }if (typeof snabbdom === 'undefined') {
      throw new Error("Error loading module 'kvision-jsLegacy'. Its dependency 'snabbdom' was not found. Please, check whether 'snabbdom' is loaded prior to 'kvision-jsLegacy'.");
    }if (typeof jQuery === 'undefined') {
      throw new Error("Error loading module 'kvision-jsLegacy'. Its dependency 'jquery' was not found. Please, check whether 'jquery' is loaded prior to 'kvision-jsLegacy'.");
    }if (typeof this['jquery-kotlin-jsLegacy'] === 'undefined') {
      throw new Error("Error loading module 'kvision-jsLegacy'. Its dependency 'jquery-kotlin-jsLegacy' was not found. Please, check whether 'jquery-kotlin-jsLegacy' is loaded prior to 'kvision-jsLegacy'.");
    }if (typeof this['kvision-kvision-common-types-jsLegacy'] === 'undefined') {
      throw new Error("Error loading module 'kvision-jsLegacy'. Its dependency 'kvision-kvision-common-types-jsLegacy' was not found. Please, check whether 'kvision-kvision-common-types-jsLegacy' is loaded prior to 'kvision-jsLegacy'.");
    }if (typeof this['kotlinx-serialization-kotlinx-serialization-core-jsLegacy'] === 'undefined') {
      throw new Error("Error loading module 'kvision-jsLegacy'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core-jsLegacy' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core-jsLegacy' is loaded prior to 'kvision-jsLegacy'.");
    }if (typeof this['kotlinx-serialization-kotlinx-serialization-json-jsLegacy'] === 'undefined') {
      throw new Error("Error loading module 'kvision-jsLegacy'. Its dependency 'kotlinx-serialization-kotlinx-serialization-json-jsLegacy' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-json-jsLegacy' is loaded prior to 'kvision-jsLegacy'.");
    }root['kvision-jsLegacy'] = factory(typeof this['kvision-jsLegacy'] === 'undefined' ? {} : this['kvision-jsLegacy'], kotlin, Snabbdom, this['snabbdom-kotlin-jsLegacy'], snabbdom, jQuery, this['jquery-kotlin-jsLegacy'], this['kvision-kvision-common-types-jsLegacy'], this['kotlinx-serialization-kotlinx-serialization-core-jsLegacy'], this['kotlinx-serialization-kotlinx-serialization-json-jsLegacy']);
  }
}(this, function (_, Kotlin, $module$snabbdom, $module$snabbdom_kotlin_jsLegacy, $module$snabbdom_0, $module$jquery, $module$jquery_kotlin_jsLegacy, $module$kvision_kvision_common_types_jsLegacy, $module$kotlinx_serialization_kotlinx_serialization_core_jsLegacy, $module$kotlinx_serialization_kotlinx_serialization_json_jsLegacy) {
  'use strict';
  var $$importsForInline$$ = _.$$importsForInline$$ || (_.$$importsForInline$$ = {});
  var Unit = Kotlin.kotlin.Unit;
  var Kind_CLASS = Kotlin.Kind.CLASS;
  var emptyMap = Kotlin.kotlin.collections.emptyMap_q3lmfv$;
  var clear = Kotlin.kotlinx.dom.clear_asww5s$;
  var Throwable = Error;
  var snabbdom = $module$snabbdom_kotlin_jsLegacy.com.github.snabbdom;
  var Kind_OBJECT = Kotlin.Kind.OBJECT;
  var Kind_INTERFACE = Kotlin.Kind.INTERFACE;
  var asList = Kotlin.kotlin.collections.asList_us0mfu$;
  var Enum = Kotlin.kotlin.Enum;
  var throwISE = Kotlin.throwISE;
  var toString = Kotlin.toString;
  var joinToString = Kotlin.kotlin.collections.joinToString_fmv235$;
  var Object_init = Object;
  var PropertyMetadata = Kotlin.PropertyMetadata;
  var defineInlineFunction = Kotlin.defineInlineFunction;
  var wrapFunction = Kotlin.wrapFunction;
  var ArrayList_init = Kotlin.kotlin.collections.ArrayList_init_287e2$;
  var to = Kotlin.kotlin.to_ujzrz7$;
  var Pair = Kotlin.kotlin.Pair;
  var ensureNotNull = Kotlin.ensureNotNull;
  var h = $module$snabbdom_0.h;
  var equals = Kotlin.equals;
  var toMap = Kotlin.kotlin.collections.toMap_6hr0sd$;
  var toMutableMap = Kotlin.kotlin.collections.toMutableMap_abgq59$;
  var first = Kotlin.kotlin.collections.first_7wnvza$;
  var throwCCE = Kotlin.throwCCE;
  var getCallableRef = Kotlin.getCallableRef;
  var iterator = Kotlin.kotlin.js.iterator_s8jyvk$;
  var mutableMapOf = Kotlin.kotlin.collections.mutableMapOf_qfcya0$;
  var toMutableSet = Kotlin.kotlin.collections.toMutableSet_7wnvza$;
  var setOf = Kotlin.kotlin.collections.setOf_mh5how$;
  var toSet = Kotlin.kotlin.collections.toSet_us0mfu$;
  var intersect = Kotlin.kotlin.collections.intersect_q4559j$;
  var split = Kotlin.kotlin.text.split_ip8yn$;
  var toSet_0 = Kotlin.kotlin.collections.toSet_7wnvza$;
  var mapOf = Kotlin.kotlin.collections.mapOf_qfcya0$;
  var collectionSizeOrDefault = Kotlin.kotlin.collections.collectionSizeOrDefault_ba2ldo$;
  var ArrayList_init_0 = Kotlin.kotlin.collections.ArrayList_init_ww73n8$;
  var LinkedHashMap_init = Kotlin.kotlin.collections.LinkedHashMap_init_q3lmfv$;
  var copyToArray = Kotlin.kotlin.collections.copyToArray;
  var LinkedHashSet_init = Kotlin.kotlin.collections.LinkedHashSet_init_287e2$;
  var emptySet = Kotlin.kotlin.collections.emptySet_287e2$;
  var IllegalStateException_init = Kotlin.kotlin.IllegalStateException_init_pdl1vj$;
  var getKClass = Kotlin.getKClass;
  var List = Kotlin.kotlin.collections.List;
  var mapCapacity = Kotlin.kotlin.collections.mapCapacity_za3lpa$;
  var coerceAtLeast = Kotlin.kotlin.ranges.coerceAtLeast_dqglrj$;
  var LinkedHashMap_init_0 = Kotlin.kotlin.collections.LinkedHashMap_init_bwtc7$;
  var setOf_0 = Kotlin.kotlin.collections.setOf_i5x0yv$;
  var numberToInt = Kotlin.numberToInt;
  var mapOf_0 = Kotlin.kotlin.collections.mapOf_x2b85n$;
  var throwUPAE = Kotlin.throwUPAE;
  var listOf = Kotlin.kotlin.collections.listOf_mh5how$;
  var checkIndexOverflow = Kotlin.kotlin.collections.checkIndexOverflow_za3lpa$;
  var startsWith = Kotlin.kotlin.text.startsWith_7epoxm$;
  var toIntOrNull = Kotlin.kotlin.text.toIntOrNull_pdl1vz$;
  var plus_0 = Kotlin.kotlin.collections.plus_mydzjv$;
  var get_indices = Kotlin.kotlin.collections.get_indices_gzk92b$;
  var MutableList = Kotlin.kotlin.collections.MutableList;
  var MutableIterator = Kotlin.kotlin.collections.MutableIterator;
  var MutableListIterator = Kotlin.kotlin.collections.MutableListIterator;
  var toMutableList = Kotlin.kotlin.collections.toMutableList_us0mfu$;
  var MutableSet = Kotlin.kotlin.collections.MutableSet;
  var listOf_0 = Kotlin.kotlin.collections.listOf_i5x0yv$;
  var KSerializer = $module$kotlinx_serialization_kotlinx_serialization_core_jsLegacy.kotlinx.serialization.KSerializer;
  var HashMap_init = Kotlin.kotlin.collections.HashMap_init_q3lmfv$;
  var MutableMap = Kotlin.kotlin.collections.MutableMap;
  var toList = Kotlin.kotlin.collections.toList_us0mfu$;
  var get_js = Kotlin.kotlin.js.get_js_1yb8b7$;
  var matches = Kotlin.kotlin.text.matches_rjktp$;
  var Regex_init = Kotlin.kotlin.text.Regex_init_61zpoe$;
  var drop = Kotlin.kotlin.text.drop_6ic1pp$;
  var StringBuilder_init = Kotlin.kotlin.text.StringBuilder_init_za3lpa$;
  UNIT.prototype = Object.create(Enum.prototype);
  UNIT.prototype.constructor = UNIT;
  BorderStyle.prototype = Object.create(Enum.prototype);
  BorderStyle.prototype.constructor = BorderStyle;
  Display.prototype = Object.create(Enum.prototype);
  Display.prototype.constructor = Display;
  Easing.prototype = Object.create(Enum.prototype);
  Easing.prototype.constructor = Easing;
  Widget.prototype = Object.create(StyledComponent.prototype);
  Widget.prototype.constructor = Widget;
  BasicPanel.prototype = Object.create(Widget.prototype);
  BasicPanel.prototype.constructor = BasicPanel;
  SimplePanel.prototype = Object.create(BasicPanel.prototype);
  SimplePanel.prototype.constructor = SimplePanel;
  Canvas.prototype = Object.create(Widget.prototype);
  Canvas.prototype.constructor = Canvas;
  TextNode.prototype = Object.create(Widget.prototype);
  TextNode.prototype.constructor = TextNode;
  ContainerType.prototype = Object.create(Enum.prototype);
  ContainerType.prototype.constructor = ContainerType;
  Root.prototype = Object.create(SimplePanel.prototype);
  Root.prototype.constructor = Root;
  function KVManager() {
    KVManager_instance = this;
    try {
      require('kvision-kvision-bootstrap-css-jsLegacy').io.kvision.KVManagerBootstrapCss;
    } catch (e) {
      if (!Kotlin.isType(e, Throwable))
        throw e;
    }
    try {
      require('kvision-kvision-bootstrap-jsLegacy').io.kvision.KVManagerBootstrap;
    } catch (e) {
      if (!Kotlin.isType(e, Throwable))
        throw e;
    }
    try {
      require('kvision-kvision-fontawesome-jsLegacy').io.kvision.KVManagerFontAwesome;
    } catch (e) {
      if (!Kotlin.isType(e, Throwable))
        throw e;
    }
    try {
      require('kvision-kvision-onsenui-css-jsLegacy').io.kvision.KVManagerOnsenuiCss;
    } catch (e) {
      if (!Kotlin.isType(e, Throwable))
        throw e;
    }
    require('kvision-assets/css/style.css');
    require('jquery-resizable-dom');
    this.fecha_8be2vx$ = require('fecha').default;
    this.sdPatch_0 = $module$snabbdom.init([snabbdom.classModule, snabbdom.attributesModule, snabbdom.propsModule, snabbdom.styleModule, snabbdom.eventListenersModule, snabbdom.datasetModule]);
    this.sdVirtualize_0 = require('snabbdom-virtualize/strings').default;
  }
  KVManager.prototype.patch_cdbjll$ = function (id, vnode) {
    var container = document.getElementById(id);
    container != null ? (clear(container), Unit) : null;
    return this.sdPatch_0(container, vnode);
  };
  KVManager.prototype.patch_8hysnl$ = function (element, vnode) {
    return this.sdPatch_0(element, vnode);
  };
  KVManager.prototype.patch_aevwwv$ = function (oldVNode, newVNode) {
    return this.sdPatch_0(oldVNode, newVNode);
  };
  KVManager.prototype.virtualize_61zpoe$ = function (html) {
    return this.sdVirtualize_0(html);
  };
  KVManager.$metadata$ = {kind: Kind_OBJECT, simpleName: 'KVManager', interfaces: []};
  var KVManager_instance = null;
  function KVManager_getInstance() {
    if (KVManager_instance === null) {
      new KVManager();
    }return KVManager_instance;
  }
  function AttributeSetBuilder() {
  }
  AttributeSetBuilder.prototype.add_puj7f4$ = function (name, value, callback$default) {
    if (value === void 0)
      value = name;
    callback$default ? callback$default(name, value) : this.add_puj7f4$$default(name, value);
  };
  AttributeSetBuilder.prototype.addAll_y0zsll$ = function (attributes) {
    var tmp$;
    tmp$ = attributes.entries.iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      var key = element.key;
      var value = element.value;
      this.add_puj7f4$(key, value);
    }
  };
  AttributeSetBuilder.prototype.add_lcqont$ = function (attribute) {
    if (attribute != null) {
      this.add_puj7f4$(attribute.attributeName, attribute.attributeValue);
    }};
  AttributeSetBuilder.$metadata$ = {kind: Kind_INTERFACE, simpleName: 'AttributeSetBuilder', interfaces: []};
  function AttributeSetBuilderImpl() {
    this._attributes_0 = {};
  }
  Object.defineProperty(AttributeSetBuilderImpl.prototype, 'attributes', {configurable: true, get: function () {
    return Object.assign({}, this._attributes_0);
  }});
  AttributeSetBuilderImpl.prototype.add_puj7f4$$default = function (name, value) {
    this._attributes_0[name] = value;
  };
  AttributeSetBuilderImpl.$metadata$ = {kind: Kind_CLASS, simpleName: 'AttributeSetBuilderImpl', interfaces: [AttributeSetBuilder]};
  function buildAttributeSet(delegate) {
    var $receiver = new AttributeSetBuilderImpl();
    delegate($receiver);
    return $receiver.attributes;
  }
  function ClassSetBuilder() {
  }
  ClassSetBuilder.prototype.add_vqcfem$ = function (value) {
    if (value != null) {
      this.add_61zpoe$(value.className);
    }};
  ClassSetBuilder.$metadata$ = {kind: Kind_INTERFACE, simpleName: 'ClassSetBuilder', interfaces: []};
  function ClassSetBuilderImpl() {
    this._classes_0 = {};
  }
  Object.defineProperty(ClassSetBuilderImpl.prototype, 'classes', {configurable: true, get: function () {
    return Object.assign({}, this._classes_0);
  }});
  ClassSetBuilderImpl.prototype.add_61zpoe$ = function (value) {
    if (value.length > 0) {
      this._classes_0[value] = true;
    }};
  ClassSetBuilderImpl.prototype.addAll_jfy1ql$ = function (values) {
    var tmp$;
    tmp$ = values.iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      this.add_61zpoe$(element);
    }
  };
  ClassSetBuilderImpl.$metadata$ = {kind: Kind_CLASS, simpleName: 'ClassSetBuilderImpl', interfaces: [ClassSetBuilder]};
  function buildClassSet(delegate) {
    var $receiver = new ClassSetBuilderImpl();
    delegate($receiver);
    return $receiver.classes;
  }
  function Component() {
  }
  Component.prototype.focus = function () {
    var tmp$;
    (tmp$ = this.getElementJQuery()) != null ? tmp$.focus() : null;
  };
  Component.prototype.blur = function () {
    var tmp$;
    (tmp$ = this.getElementJQuery()) != null ? tmp$.blur() : null;
  };
  Component.$metadata$ = {kind: Kind_INTERFACE, simpleName: 'Component', interfaces: []};
  function Container() {
  }
  Container.prototype.invoke_4h7hma$ = function (children) {
    return this.addAll_xquxs0$(asList(children));
  };
  Container.prototype.unaryPlus_pdl1vz$ = function ($receiver) {
    this.add_87eobz$(new TextNode($receiver));
  };
  Container.$metadata$ = {kind: Kind_INTERFACE, simpleName: 'Container', interfaces: [Component]};
  function UNIT(name, ordinal, unit) {
    Enum.call(this);
    this.unit_8be2vx$ = unit;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function UNIT_initFields() {
    UNIT_initFields = function () {
    };
    UNIT$px_instance = new UNIT('px', 0, 'px');
    UNIT$pt_instance = new UNIT('pt', 1, 'pt');
    UNIT$em_instance = new UNIT('em', 2, 'em');
    UNIT$cm_instance = new UNIT('cm', 3, 'cm');
    UNIT$mm_instance = new UNIT('mm', 4, 'mm');
    UNIT$in_instance = new UNIT('in', 5, 'in');
    UNIT$pc_instance = new UNIT('pc', 6, 'pc');
    UNIT$ch_instance = new UNIT('ch', 7, 'ch');
    UNIT$rem_instance = new UNIT('rem', 8, 'rem');
    UNIT$vw_instance = new UNIT('vw', 9, 'vw');
    UNIT$vh_instance = new UNIT('vh', 10, 'vh');
    UNIT$vmin_instance = new UNIT('vmin', 11, 'vmin');
    UNIT$vmax_instance = new UNIT('vmax', 12, 'vmax');
    UNIT$perc_instance = new UNIT('perc', 13, '%');
    UNIT$auto_instance = new UNIT('auto', 14, 'auto');
    UNIT$normal_instance = new UNIT('normal', 15, 'normal');
  }
  var UNIT$px_instance;
  function UNIT$px_getInstance() {
    UNIT_initFields();
    return UNIT$px_instance;
  }
  var UNIT$pt_instance;
  function UNIT$pt_getInstance() {
    UNIT_initFields();
    return UNIT$pt_instance;
  }
  var UNIT$em_instance;
  function UNIT$em_getInstance() {
    UNIT_initFields();
    return UNIT$em_instance;
  }
  var UNIT$cm_instance;
  function UNIT$cm_getInstance() {
    UNIT_initFields();
    return UNIT$cm_instance;
  }
  var UNIT$mm_instance;
  function UNIT$mm_getInstance() {
    UNIT_initFields();
    return UNIT$mm_instance;
  }
  var UNIT$in_instance;
  function UNIT$in_getInstance() {
    UNIT_initFields();
    return UNIT$in_instance;
  }
  var UNIT$pc_instance;
  function UNIT$pc_getInstance() {
    UNIT_initFields();
    return UNIT$pc_instance;
  }
  var UNIT$ch_instance;
  function UNIT$ch_getInstance() {
    UNIT_initFields();
    return UNIT$ch_instance;
  }
  var UNIT$rem_instance;
  function UNIT$rem_getInstance() {
    UNIT_initFields();
    return UNIT$rem_instance;
  }
  var UNIT$vw_instance;
  function UNIT$vw_getInstance() {
    UNIT_initFields();
    return UNIT$vw_instance;
  }
  var UNIT$vh_instance;
  function UNIT$vh_getInstance() {
    UNIT_initFields();
    return UNIT$vh_instance;
  }
  var UNIT$vmin_instance;
  function UNIT$vmin_getInstance() {
    UNIT_initFields();
    return UNIT$vmin_instance;
  }
  var UNIT$vmax_instance;
  function UNIT$vmax_getInstance() {
    UNIT_initFields();
    return UNIT$vmax_instance;
  }
  var UNIT$perc_instance;
  function UNIT$perc_getInstance() {
    UNIT_initFields();
    return UNIT$perc_instance;
  }
  var UNIT$auto_instance;
  function UNIT$auto_getInstance() {
    UNIT_initFields();
    return UNIT$auto_instance;
  }
  var UNIT$normal_instance;
  function UNIT$normal_getInstance() {
    UNIT_initFields();
    return UNIT$normal_instance;
  }
  UNIT.$metadata$ = {kind: Kind_CLASS, simpleName: 'UNIT', interfaces: [Enum]};
  function UNIT$values() {
    return [UNIT$px_getInstance(), UNIT$pt_getInstance(), UNIT$em_getInstance(), UNIT$cm_getInstance(), UNIT$mm_getInstance(), UNIT$in_getInstance(), UNIT$pc_getInstance(), UNIT$ch_getInstance(), UNIT$rem_getInstance(), UNIT$vw_getInstance(), UNIT$vh_getInstance(), UNIT$vmin_getInstance(), UNIT$vmax_getInstance(), UNIT$perc_getInstance(), UNIT$auto_getInstance(), UNIT$normal_getInstance()];
  }
  UNIT.values = UNIT$values;
  function UNIT$valueOf(name) {
    switch (name) {
      case 'px':
        return UNIT$px_getInstance();
      case 'pt':
        return UNIT$pt_getInstance();
      case 'em':
        return UNIT$em_getInstance();
      case 'cm':
        return UNIT$cm_getInstance();
      case 'mm':
        return UNIT$mm_getInstance();
      case 'in':
        return UNIT$in_getInstance();
      case 'pc':
        return UNIT$pc_getInstance();
      case 'ch':
        return UNIT$ch_getInstance();
      case 'rem':
        return UNIT$rem_getInstance();
      case 'vw':
        return UNIT$vw_getInstance();
      case 'vh':
        return UNIT$vh_getInstance();
      case 'vmin':
        return UNIT$vmin_getInstance();
      case 'vmax':
        return UNIT$vmax_getInstance();
      case 'perc':
        return UNIT$perc_getInstance();
      case 'auto':
        return UNIT$auto_getInstance();
      case 'normal':
        return UNIT$normal_getInstance();
      default:throwISE('No enum constant io.kvision.core.UNIT.' + name);
    }
  }
  UNIT.valueOf_61zpoe$ = UNIT$valueOf;
  function BorderStyle(name, ordinal, borderStyle) {
    Enum.call(this);
    this.borderStyle_8be2vx$ = borderStyle;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function BorderStyle_initFields() {
    BorderStyle_initFields = function () {
    };
    BorderStyle$NONE_instance = new BorderStyle('NONE', 0, 'none');
    BorderStyle$HIDDEN_instance = new BorderStyle('HIDDEN', 1, 'hidden');
    BorderStyle$DOTTED_instance = new BorderStyle('DOTTED', 2, 'dotted');
    BorderStyle$DASHED_instance = new BorderStyle('DASHED', 3, 'dashed');
    BorderStyle$SOLID_instance = new BorderStyle('SOLID', 4, 'solid');
    BorderStyle$DOUBLE_instance = new BorderStyle('DOUBLE', 5, 'double');
    BorderStyle$GROOVE_instance = new BorderStyle('GROOVE', 6, 'groove');
    BorderStyle$RIDGE_instance = new BorderStyle('RIDGE', 7, 'ridge');
    BorderStyle$INSET_instance = new BorderStyle('INSET', 8, 'inset');
    BorderStyle$OUTSET_instance = new BorderStyle('OUTSET', 9, 'outset');
    BorderStyle$INITIAL_instance = new BorderStyle('INITIAL', 10, 'initial');
    BorderStyle$INHERIT_instance = new BorderStyle('INHERIT', 11, 'inherit');
  }
  var BorderStyle$NONE_instance;
  function BorderStyle$NONE_getInstance() {
    BorderStyle_initFields();
    return BorderStyle$NONE_instance;
  }
  var BorderStyle$HIDDEN_instance;
  function BorderStyle$HIDDEN_getInstance() {
    BorderStyle_initFields();
    return BorderStyle$HIDDEN_instance;
  }
  var BorderStyle$DOTTED_instance;
  function BorderStyle$DOTTED_getInstance() {
    BorderStyle_initFields();
    return BorderStyle$DOTTED_instance;
  }
  var BorderStyle$DASHED_instance;
  function BorderStyle$DASHED_getInstance() {
    BorderStyle_initFields();
    return BorderStyle$DASHED_instance;
  }
  var BorderStyle$SOLID_instance;
  function BorderStyle$SOLID_getInstance() {
    BorderStyle_initFields();
    return BorderStyle$SOLID_instance;
  }
  var BorderStyle$DOUBLE_instance;
  function BorderStyle$DOUBLE_getInstance() {
    BorderStyle_initFields();
    return BorderStyle$DOUBLE_instance;
  }
  var BorderStyle$GROOVE_instance;
  function BorderStyle$GROOVE_getInstance() {
    BorderStyle_initFields();
    return BorderStyle$GROOVE_instance;
  }
  var BorderStyle$RIDGE_instance;
  function BorderStyle$RIDGE_getInstance() {
    BorderStyle_initFields();
    return BorderStyle$RIDGE_instance;
  }
  var BorderStyle$INSET_instance;
  function BorderStyle$INSET_getInstance() {
    BorderStyle_initFields();
    return BorderStyle$INSET_instance;
  }
  var BorderStyle$OUTSET_instance;
  function BorderStyle$OUTSET_getInstance() {
    BorderStyle_initFields();
    return BorderStyle$OUTSET_instance;
  }
  var BorderStyle$INITIAL_instance;
  function BorderStyle$INITIAL_getInstance() {
    BorderStyle_initFields();
    return BorderStyle$INITIAL_instance;
  }
  var BorderStyle$INHERIT_instance;
  function BorderStyle$INHERIT_getInstance() {
    BorderStyle_initFields();
    return BorderStyle$INHERIT_instance;
  }
  BorderStyle.$metadata$ = {kind: Kind_CLASS, simpleName: 'BorderStyle', interfaces: [Enum]};
  function BorderStyle$values() {
    return [BorderStyle$NONE_getInstance(), BorderStyle$HIDDEN_getInstance(), BorderStyle$DOTTED_getInstance(), BorderStyle$DASHED_getInstance(), BorderStyle$SOLID_getInstance(), BorderStyle$DOUBLE_getInstance(), BorderStyle$GROOVE_getInstance(), BorderStyle$RIDGE_getInstance(), BorderStyle$INSET_getInstance(), BorderStyle$OUTSET_getInstance(), BorderStyle$INITIAL_getInstance(), BorderStyle$INHERIT_getInstance()];
  }
  BorderStyle.values = BorderStyle$values;
  function BorderStyle$valueOf(name) {
    switch (name) {
      case 'NONE':
        return BorderStyle$NONE_getInstance();
      case 'HIDDEN':
        return BorderStyle$HIDDEN_getInstance();
      case 'DOTTED':
        return BorderStyle$DOTTED_getInstance();
      case 'DASHED':
        return BorderStyle$DASHED_getInstance();
      case 'SOLID':
        return BorderStyle$SOLID_getInstance();
      case 'DOUBLE':
        return BorderStyle$DOUBLE_getInstance();
      case 'GROOVE':
        return BorderStyle$GROOVE_getInstance();
      case 'RIDGE':
        return BorderStyle$RIDGE_getInstance();
      case 'INSET':
        return BorderStyle$INSET_getInstance();
      case 'OUTSET':
        return BorderStyle$OUTSET_getInstance();
      case 'INITIAL':
        return BorderStyle$INITIAL_getInstance();
      case 'INHERIT':
        return BorderStyle$INHERIT_getInstance();
      default:throwISE('No enum constant io.kvision.core.BorderStyle.' + name);
    }
  }
  BorderStyle.valueOf_61zpoe$ = BorderStyle$valueOf;
  var Col$ALICEBLUE_instance;
  var Col$ANTIQUEWHITE_instance;
  var Col$AQUA_instance;
  var Col$AQUAMARINE_instance;
  var Col$AZURE_instance;
  var Col$BEIGE_instance;
  var Col$BISQUE_instance;
  var Col$BLACK_instance;
  var Col$BLANCHEDALMOND_instance;
  var Col$BLUE_instance;
  var Col$BLUEVIOLET_instance;
  var Col$BROWN_instance;
  var Col$BURLYWOOD_instance;
  var Col$CADETBLUE_instance;
  var Col$CHARTREUSE_instance;
  var Col$CHOCOLATE_instance;
  var Col$CORAL_instance;
  var Col$CORNFLOWERBLUE_instance;
  var Col$CORNSILK_instance;
  var Col$CRIMSON_instance;
  var Col$CYAN_instance;
  var Col$DARKBLUE_instance;
  var Col$DARKCYAN_instance;
  var Col$DARKGOLDENROD_instance;
  var Col$DARKGRAY_instance;
  var Col$DARKGREEN_instance;
  var Col$DARKKHAKI_instance;
  var Col$DARKMAGENTA_instance;
  var Col$DARKOLIVEGREEN_instance;
  var Col$DARKORANGE_instance;
  var Col$DARKORCHID_instance;
  var Col$DARKRED_instance;
  var Col$DARKSALMON_instance;
  var Col$DARKSEAGREEN_instance;
  var Col$DARKSLATEBLUE_instance;
  var Col$DARKSLATEGRAY_instance;
  var Col$DARKTURQUOISE_instance;
  var Col$DARKVIOLET_instance;
  var Col$DEEPPINK_instance;
  var Col$DEEPSKYBLUE_instance;
  var Col$DIMGRAY_instance;
  var Col$DODGERBLUE_instance;
  var Col$FIREBRICK_instance;
  var Col$FLORALWHITE_instance;
  var Col$FORESTGREEN_instance;
  var Col$FUCHSIA_instance;
  var Col$GAINSBORO_instance;
  var Col$GHOSTWHITE_instance;
  var Col$GOLD_instance;
  var Col$GOLDENROD_instance;
  var Col$GRAY_instance;
  var Col$GREEN_instance;
  var Col$GREENYELLOW_instance;
  var Col$HONEYDEW_instance;
  var Col$HOTPINK_instance;
  var Col$INDIANRED_instance;
  var Col$INDIGO_instance;
  var Col$IVORY_instance;
  var Col$KHAKI_instance;
  var Col$LAVENDER_instance;
  var Col$LAVENDERBLUSH_instance;
  var Col$LAWNGREEN_instance;
  var Col$LEMONCHIFFON_instance;
  var Col$LIGHTBLUE_instance;
  var Col$LIGHTCORAL_instance;
  var Col$LIGHTCYAN_instance;
  var Col$LIGHTGOLDENRODYELLOW_instance;
  var Col$LIGHTGRAY_instance;
  var Col$LIGHTGREEN_instance;
  var Col$LIGHTPINK_instance;
  var Col$LIGHTSALMON_instance;
  var Col$LIGHTSEAGREEN_instance;
  var Col$LIGHTSKYBLUE_instance;
  var Col$LIGHTSLATEGRAY_instance;
  var Col$LIGHTSTEELBLUE_instance;
  var Col$LIGHTYELLOW_instance;
  var Col$LIME_instance;
  var Col$LIMEGREEN_instance;
  var Col$LINEN_instance;
  var Col$MAGENTA_instance;
  var Col$MAROON_instance;
  var Col$MEDIUMAQUAMARINE_instance;
  var Col$MEDIUMBLUE_instance;
  var Col$MEDIUMORCHID_instance;
  var Col$MEDIUMPURPLE_instance;
  var Col$MEDIUMSEAGREEN_instance;
  var Col$MEDIUMSLATEBLUE_instance;
  var Col$MEDIUMSPRINGGREEN_instance;
  var Col$MEDIUMTURQUOISE_instance;
  var Col$MEDIUMVIOLETRED_instance;
  var Col$MIDNIGHTBLUE_instance;
  var Col$MINTCREAM_instance;
  var Col$MISTYROSE_instance;
  var Col$MOCCASIN_instance;
  var Col$NAVAJOWHITE_instance;
  var Col$NAVY_instance;
  var Col$OLDLACE_instance;
  var Col$OLIVE_instance;
  var Col$OLIVEDRAB_instance;
  var Col$ORANGE_instance;
  var Col$ORANGERED_instance;
  var Col$ORCHID_instance;
  var Col$PALEGOLDENROD_instance;
  var Col$PALEGREEN_instance;
  var Col$PALETURQUOISE_instance;
  var Col$PALEVIOLETRED_instance;
  var Col$PAPAYAWHIP_instance;
  var Col$PEACHPUFF_instance;
  var Col$PERU_instance;
  var Col$PINK_instance;
  var Col$PLUM_instance;
  var Col$POWDERBLUE_instance;
  var Col$PURPLE_instance;
  var Col$REBECCAPURPLE_instance;
  var Col$RED_instance;
  var Col$ROSYBROWN_instance;
  var Col$ROYALBLUE_instance;
  var Col$SADDLEBROWN_instance;
  var Col$SALMON_instance;
  var Col$SANDYBROWN_instance;
  var Col$SEAGREEN_instance;
  var Col$SEASHELL_instance;
  var Col$SIENNA_instance;
  var Col$SILVER_instance;
  var Col$SKYBLUE_instance;
  var Col$SLATEBLUE_instance;
  var Col$SLATEGRAY_instance;
  var Col$SNOW_instance;
  var Col$SPRINGGREEN_instance;
  var Col$STEELBLUE_instance;
  var Col$TAN_instance;
  var Col$TEAL_instance;
  var Col$THISTLE_instance;
  var Col$TOMATO_instance;
  var Col$TURQUOISE_instance;
  var Col$VIOLET_instance;
  var Col$WHEAT_instance;
  var Col$WHITE_instance;
  var Col$WHITESMOKE_instance;
  var Col$YELLOW_instance;
  var Col$YELLOWGREEN_instance;
  var BgSize$COVER_instance;
  var BgSize$CONTAIN_instance;
  var BgRepeat$REPEAT_instance;
  var BgRepeat$REPEATX_instance;
  var BgRepeat$REPEATY_instance;
  var BgRepeat$NOREPEAT_instance;
  var BgAttach$SCROLL_instance;
  var BgAttach$FIXED_instance;
  var BgAttach$LOCAL_instance;
  var BgOrigin$PADDING_instance;
  var BgOrigin$BORDER_instance;
  var BgOrigin$CONTENT_instance;
  var BgClip$PADDING_instance;
  var BgClip$BORDER_instance;
  var BgClip$CONTENT_instance;
  function Display(name, ordinal, display) {
    Enum.call(this);
    this.display_8be2vx$ = display;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function Display_initFields() {
    Display_initFields = function () {
    };
    Display$INLINE_instance = new Display('INLINE', 0, 'inline');
    Display$BLOCK_instance = new Display('BLOCK', 1, 'block');
    Display$FLEX_instance = new Display('FLEX', 2, 'flex');
    Display$GRID_instance = new Display('GRID', 3, 'grid');
    Display$INLINEBLOCK_instance = new Display('INLINEBLOCK', 4, 'inline-block');
    Display$INLINEFLEX_instance = new Display('INLINEFLEX', 5, 'inline-flex');
    Display$INLINEGRID_instance = new Display('INLINEGRID', 6, 'inline-grid');
    Display$INLINETABLE_instance = new Display('INLINETABLE', 7, 'inline-table');
    Display$LISTITEM_instance = new Display('LISTITEM', 8, 'list-item');
    Display$RUNIN_instance = new Display('RUNIN', 9, 'run-in');
    Display$TABLE_instance = new Display('TABLE', 10, 'table');
    Display$TABLECAPTION_instance = new Display('TABLECAPTION', 11, 'table-caption');
    Display$TABLECOLUMNGROUP_instance = new Display('TABLECOLUMNGROUP', 12, 'table-column-group');
    Display$TABLEHEADERGROUP_instance = new Display('TABLEHEADERGROUP', 13, 'table-header-group');
    Display$TABLEFOOTERGROUP_instance = new Display('TABLEFOOTERGROUP', 14, 'table-footer-group');
    Display$TABLEROWGROUP_instance = new Display('TABLEROWGROUP', 15, 'table-row-group');
    Display$TABLECELL_instance = new Display('TABLECELL', 16, 'table-cell');
    Display$TABLECOLUMN_instance = new Display('TABLECOLUMN', 17, 'table-column');
    Display$TABLEROW_instance = new Display('TABLEROW', 18, 'table-row');
    Display$CONTENTS_instance = new Display('CONTENTS', 19, 'contents');
    Display$NONE_instance = new Display('NONE', 20, 'none');
    Display$INITIAL_instance = new Display('INITIAL', 21, 'initial');
    Display$INHERIT_instance = new Display('INHERIT', 22, 'inherit');
  }
  var Display$INLINE_instance;
  function Display$INLINE_getInstance() {
    Display_initFields();
    return Display$INLINE_instance;
  }
  var Display$BLOCK_instance;
  function Display$BLOCK_getInstance() {
    Display_initFields();
    return Display$BLOCK_instance;
  }
  var Display$FLEX_instance;
  function Display$FLEX_getInstance() {
    Display_initFields();
    return Display$FLEX_instance;
  }
  var Display$GRID_instance;
  function Display$GRID_getInstance() {
    Display_initFields();
    return Display$GRID_instance;
  }
  var Display$INLINEBLOCK_instance;
  function Display$INLINEBLOCK_getInstance() {
    Display_initFields();
    return Display$INLINEBLOCK_instance;
  }
  var Display$INLINEFLEX_instance;
  function Display$INLINEFLEX_getInstance() {
    Display_initFields();
    return Display$INLINEFLEX_instance;
  }
  var Display$INLINEGRID_instance;
  function Display$INLINEGRID_getInstance() {
    Display_initFields();
    return Display$INLINEGRID_instance;
  }
  var Display$INLINETABLE_instance;
  function Display$INLINETABLE_getInstance() {
    Display_initFields();
    return Display$INLINETABLE_instance;
  }
  var Display$LISTITEM_instance;
  function Display$LISTITEM_getInstance() {
    Display_initFields();
    return Display$LISTITEM_instance;
  }
  var Display$RUNIN_instance;
  function Display$RUNIN_getInstance() {
    Display_initFields();
    return Display$RUNIN_instance;
  }
  var Display$TABLE_instance;
  function Display$TABLE_getInstance() {
    Display_initFields();
    return Display$TABLE_instance;
  }
  var Display$TABLECAPTION_instance;
  function Display$TABLECAPTION_getInstance() {
    Display_initFields();
    return Display$TABLECAPTION_instance;
  }
  var Display$TABLECOLUMNGROUP_instance;
  function Display$TABLECOLUMNGROUP_getInstance() {
    Display_initFields();
    return Display$TABLECOLUMNGROUP_instance;
  }
  var Display$TABLEHEADERGROUP_instance;
  function Display$TABLEHEADERGROUP_getInstance() {
    Display_initFields();
    return Display$TABLEHEADERGROUP_instance;
  }
  var Display$TABLEFOOTERGROUP_instance;
  function Display$TABLEFOOTERGROUP_getInstance() {
    Display_initFields();
    return Display$TABLEFOOTERGROUP_instance;
  }
  var Display$TABLEROWGROUP_instance;
  function Display$TABLEROWGROUP_getInstance() {
    Display_initFields();
    return Display$TABLEROWGROUP_instance;
  }
  var Display$TABLECELL_instance;
  function Display$TABLECELL_getInstance() {
    Display_initFields();
    return Display$TABLECELL_instance;
  }
  var Display$TABLECOLUMN_instance;
  function Display$TABLECOLUMN_getInstance() {
    Display_initFields();
    return Display$TABLECOLUMN_instance;
  }
  var Display$TABLEROW_instance;
  function Display$TABLEROW_getInstance() {
    Display_initFields();
    return Display$TABLEROW_instance;
  }
  var Display$CONTENTS_instance;
  function Display$CONTENTS_getInstance() {
    Display_initFields();
    return Display$CONTENTS_instance;
  }
  var Display$NONE_instance;
  function Display$NONE_getInstance() {
    Display_initFields();
    return Display$NONE_instance;
  }
  var Display$INITIAL_instance;
  function Display$INITIAL_getInstance() {
    Display_initFields();
    return Display$INITIAL_instance;
  }
  var Display$INHERIT_instance;
  function Display$INHERIT_getInstance() {
    Display_initFields();
    return Display$INHERIT_instance;
  }
  Display.$metadata$ = {kind: Kind_CLASS, simpleName: 'Display', interfaces: [Enum]};
  function Display$values() {
    return [Display$INLINE_getInstance(), Display$BLOCK_getInstance(), Display$FLEX_getInstance(), Display$GRID_getInstance(), Display$INLINEBLOCK_getInstance(), Display$INLINEFLEX_getInstance(), Display$INLINEGRID_getInstance(), Display$INLINETABLE_getInstance(), Display$LISTITEM_getInstance(), Display$RUNIN_getInstance(), Display$TABLE_getInstance(), Display$TABLECAPTION_getInstance(), Display$TABLECOLUMNGROUP_getInstance(), Display$TABLEHEADERGROUP_getInstance(), Display$TABLEFOOTERGROUP_getInstance(), Display$TABLEROWGROUP_getInstance(), Display$TABLECELL_getInstance(), Display$TABLECOLUMN_getInstance(), Display$TABLEROW_getInstance(), Display$CONTENTS_getInstance(), Display$NONE_getInstance(), Display$INITIAL_getInstance(), Display$INHERIT_getInstance()];
  }
  Display.values = Display$values;
  function Display$valueOf(name) {
    switch (name) {
      case 'INLINE':
        return Display$INLINE_getInstance();
      case 'BLOCK':
        return Display$BLOCK_getInstance();
      case 'FLEX':
        return Display$FLEX_getInstance();
      case 'GRID':
        return Display$GRID_getInstance();
      case 'INLINEBLOCK':
        return Display$INLINEBLOCK_getInstance();
      case 'INLINEFLEX':
        return Display$INLINEFLEX_getInstance();
      case 'INLINEGRID':
        return Display$INLINEGRID_getInstance();
      case 'INLINETABLE':
        return Display$INLINETABLE_getInstance();
      case 'LISTITEM':
        return Display$LISTITEM_getInstance();
      case 'RUNIN':
        return Display$RUNIN_getInstance();
      case 'TABLE':
        return Display$TABLE_getInstance();
      case 'TABLECAPTION':
        return Display$TABLECAPTION_getInstance();
      case 'TABLECOLUMNGROUP':
        return Display$TABLECOLUMNGROUP_getInstance();
      case 'TABLEHEADERGROUP':
        return Display$TABLEHEADERGROUP_getInstance();
      case 'TABLEFOOTERGROUP':
        return Display$TABLEFOOTERGROUP_getInstance();
      case 'TABLEROWGROUP':
        return Display$TABLEROWGROUP_getInstance();
      case 'TABLECELL':
        return Display$TABLECELL_getInstance();
      case 'TABLECOLUMN':
        return Display$TABLECOLUMN_getInstance();
      case 'TABLEROW':
        return Display$TABLEROW_getInstance();
      case 'CONTENTS':
        return Display$CONTENTS_getInstance();
      case 'NONE':
        return Display$NONE_getInstance();
      case 'INITIAL':
        return Display$INITIAL_getInstance();
      case 'INHERIT':
        return Display$INHERIT_getInstance();
      default:throwISE('No enum constant io.kvision.core.Display.' + name);
    }
  }
  Display.valueOf_61zpoe$ = Display$valueOf;
  var Position$STATIC_instance;
  var Position$RELATIVE_instance;
  var Position$FIXED_instance;
  var Position$ABSOLUTE_instance;
  var Position$STICKY_instance;
  var Overflow$VISIBLE_instance;
  var Overflow$HIDDEN_instance;
  var Overflow$SCROLL_instance;
  var Overflow$AUTO_instance;
  var Overflow$INITIAL_instance;
  var Overflow$INHERIT_instance;
  var OverflowWrap$NORMAL_instance;
  var OverflowWrap$BREAKWORK_instance;
  var OverflowWrap$ANYWHERE_instance;
  var Resize$NONE_instance;
  var Resize$BOTH_instance;
  var Resize$HORIZONTAL_instance;
  var Resize$VERTICAL_instance;
  var Resize$INITIAL_instance;
  var Resize$INHERIT_instance;
  var Direction$LTR_instance;
  var Direction$RTL_instance;
  var Direction$INITIAL_instance;
  var Direction$INHERIT_instance;
  var TextAlign$LEFT_instance;
  var TextAlign$RIGHT_instance;
  var TextAlign$CENTER_instance;
  var TextAlign$JUSTIFY_instance;
  var TextAlign$INITIAL_instance;
  var TextAlign$INHERIT_instance;
  var TextDecorationLine$NONE_instance;
  var TextDecorationLine$UNDERLINE_instance;
  var TextDecorationLine$OVERLINE_instance;
  var TextDecorationLine$LINETHROUGH_instance;
  var TextDecorationLine$JUSTIFY_instance;
  var TextDecorationLine$INITIAL_instance;
  var TextDecorationLine$INHERIT_instance;
  var TextDecorationStyle$SOLID_instance;
  var TextDecorationStyle$DOUBLE_instance;
  var TextDecorationStyle$DOTTED_instance;
  var TextDecorationStyle$DASHED_instance;
  var TextDecorationStyle$WAVY_instance;
  var TextDecorationStyle$INITIAL_instance;
  var TextDecorationStyle$INHERIT_instance;
  var TextTransform$NONE_instance;
  var TextTransform$CAPITALIZE_instance;
  var TextTransform$UPPERCASE_instance;
  var TextTransform$LOWERCASE_instance;
  var TextTransform$INITIAL_instance;
  var TextTransform$INHERIT_instance;
  var TextOverflow$CLIP_instance;
  var TextOverflow$ELLIPSIS_instance;
  var TextOverflow$INITIAL_instance;
  var TextOverflow$INHERIT_instance;
  var UnicodeBidi$NORMAL_instance;
  var UnicodeBidi$EMBED_instance;
  var UnicodeBidi$BIDIOVERRIDE_instance;
  var UnicodeBidi$INITIAL_instance;
  var UnicodeBidi$INHERIT_instance;
  var VerticalAlign$BASELINE_instance;
  var VerticalAlign$SUB_instance;
  var VerticalAlign$SUPER_instance;
  var VerticalAlign$TOP_instance;
  var VerticalAlign$TEXTTOP_instance;
  var VerticalAlign$MIDDLE_instance;
  var VerticalAlign$BOTTOM_instance;
  var VerticalAlign$TEXTBOTTOM_instance;
  var VerticalAlign$INITIAL_instance;
  var VerticalAlign$INHERIT_instance;
  var WhiteSpace$NORMAL_instance;
  var WhiteSpace$NOWRAP_instance;
  var WhiteSpace$PRE_instance;
  var WhiteSpace$PRELINE_instance;
  var WhiteSpace$PREWRAP_instance;
  var WhiteSpace$INITIAL_instance;
  var WhiteSpace$INHERIT_instance;
  var FontStyle$NORMAL_instance;
  var FontStyle$ITALIC_instance;
  var FontStyle$OBLIQUE_instance;
  var FontStyle$INITIAL_instance;
  var FontStyle$INHERIT_instance;
  var FontVariant$NORMAL_instance;
  var FontVariant$SMALLCAPS_instance;
  var FontVariant$INITIAL_instance;
  var FontVariant$INHERIT_instance;
  var FontWeight$NORMAL_instance;
  var FontWeight$BOLD_instance;
  var FontWeight$BOLDER_instance;
  var FontWeight$LIGHTER_instance;
  var FontWeight$INITIAL_instance;
  var FontWeight$INHERIT_instance;
  var PosFloat$NONE_instance;
  var PosFloat$LEFT_instance;
  var PosFloat$RIGHT_instance;
  var PosFloat$INITIAL_instance;
  var PosFloat$INHERIT_instance;
  var Clear$NONE_instance;
  var Clear$LEFT_instance;
  var Clear$RIGHT_instance;
  var Clear$BOTH_instance;
  var Clear$INITIAL_instance;
  var Clear$INHERIT_instance;
  var WordBreak$NORMAL_instance;
  var WordBreak$KEEPALL_instance;
  var WordBreak$BREAKALL_instance;
  var LineBreak$AUTO_instance;
  var LineBreak$LOOSE_instance;
  var LineBreak$NORMAL_instance;
  var LineBreak$STRICT_instance;
  var LineBreak$ANYWHERE_instance;
  var Cursor$DEFAULT_instance;
  var Cursor$AUTO_instance;
  var Cursor$NONE_instance;
  var Cursor$ALIAS_instance;
  var Cursor$ALLSCROLL_instance;
  var Cursor$CELL_instance;
  var Cursor$CONTEXTMENU_instance;
  var Cursor$COLRESIZE_instance;
  var Cursor$COPY_instance;
  var Cursor$CROSSHAIR_instance;
  var Cursor$ERESIZE_instance;
  var Cursor$EWRESIZE_instance;
  var Cursor$GRAB_instance;
  var Cursor$GRABBING_instance;
  var Cursor$HELP_instance;
  var Cursor$MOVE_instance;
  var Cursor$NRESIZE_instance;
  var Cursor$NERESIZE_instance;
  var Cursor$NESWRESIZE_instance;
  var Cursor$NSRESIZE_instance;
  var Cursor$NWRESIZE_instance;
  var Cursor$NWSERESIZE_instance;
  var Cursor$NODROP_instance;
  var Cursor$NOTALLOWED_instance;
  var Cursor$POINTER_instance;
  var Cursor$PROGRESS_instance;
  var Cursor$ROWRESIZE_instance;
  var Cursor$SRESIZE_instance;
  var Cursor$SERESIZE_instance;
  var Cursor$SWRESIZE_instance;
  var Cursor$TEXT_instance;
  var Cursor$VERTICALTEXT_instance;
  var Cursor$WRESIZE_instance;
  var Cursor$WAIT_instance;
  var Cursor$ZOOMIN_instance;
  var Cursor$ZOOMOUT_instance;
  var Cursor$INITIAL_instance;
  var Cursor$INHERIT_instance;
  var FlexDirection$ROW_instance;
  var FlexDirection$ROWREV_instance;
  var FlexDirection$COLUMN_instance;
  var FlexDirection$COLUMNREV_instance;
  var FlexWrap$NOWRAP_instance;
  var FlexWrap$WRAP_instance;
  var FlexWrap$WRAPREV_instance;
  var JustifyItems$START_instance;
  var JustifyItems$END_instance;
  var JustifyItems$CENTER_instance;
  var JustifyItems$STRETCH_instance;
  var JustifyContent$FLEXSTART_instance;
  var JustifyContent$FLEXEND_instance;
  var JustifyContent$CENTER_instance;
  var JustifyContent$SPACEBETWEEN_instance;
  var JustifyContent$SPACEAROUND_instance;
  var JustifyContent$SPACEEVENLY_instance;
  var JustifyContent$START_instance;
  var JustifyContent$END_instance;
  var JustifyContent$STRETCH_instance;
  var AlignItems$FLEXSTART_instance;
  var AlignItems$FLEXEND_instance;
  var AlignItems$CENTER_instance;
  var AlignItems$BASELINE_instance;
  var AlignItems$STRETCH_instance;
  var AlignItems$START_instance;
  var AlignItems$END_instance;
  var AlignContent$FLEXSTART_instance;
  var AlignContent$FLEXEND_instance;
  var AlignContent$CENTER_instance;
  var AlignContent$SPACEBETWEEN_instance;
  var AlignContent$SPACEAROUND_instance;
  var AlignContent$STRETCH_instance;
  var AlignContent$START_instance;
  var AlignContent$END_instance;
  var AlignContent$SPACEEVENLY_instance;
  var GridAutoFlow$ROW_instance;
  var GridAutoFlow$COLUMN_instance;
  var GridAutoFlow$ROWDENSE_instance;
  var GridAutoFlow$COLUMNDENSE_instance;
  function Color(color) {
    Color$Companion_getInstance();
    if (color === void 0)
      color = null;
    this.color = color;
  }
  Color.prototype.asString = function () {
    var $receiver = this.color;
    return $receiver != null ? $receiver : '';
  };
  Color.prototype.toString = function () {
    return this.asString();
  };
  function Color$Companion() {
    Color$Companion_instance = this;
  }
  Color$Companion.prototype.hex_za3lpa$ = function (color) {
    return new Color('#' + toHexString(color));
  };
  Color$Companion.prototype.name_fntfe4$ = function (color) {
    return new Color(color.color_8be2vx$);
  };
  Color$Companion.$metadata$ = {kind: Kind_OBJECT, simpleName: 'Companion', interfaces: []};
  var Color$Companion_instance = null;
  function Color$Companion_getInstance() {
    if (Color$Companion_instance === null) {
      new Color$Companion();
    }return Color$Companion_instance;
  }
  Color.$metadata$ = {kind: Kind_CLASS, simpleName: 'Color', interfaces: []};
  var Placement$AUTO_instance;
  var Placement$TOP_instance;
  var Placement$BOTTOM_instance;
  var Placement$LEFT_instance;
  var Placement$RIGHT_instance;
  var Trigger$CLICK_instance;
  var Trigger$HOVER_instance;
  var Trigger$FOCUS_instance;
  var Trigger$MANUAL_instance;
  function TooltipOptions(title, rich, animation, delay, hideDelay, placement, triggers, sanitize) {
    if (title === void 0)
      title = null;
    if (rich === void 0)
      rich = null;
    if (animation === void 0)
      animation = null;
    if (delay === void 0)
      delay = null;
    if (hideDelay === void 0)
      hideDelay = null;
    if (placement === void 0)
      placement = null;
    if (triggers === void 0)
      triggers = null;
    if (sanitize === void 0)
      sanitize = null;
    this.title = title;
    this.rich = rich;
    this.animation = animation;
    this.delay = delay;
    this.hideDelay = hideDelay;
    this.placement = placement;
    this.triggers = triggers;
    this.sanitize = sanitize;
  }
  TooltipOptions.$metadata$ = {kind: Kind_CLASS, simpleName: 'TooltipOptions', interfaces: []};
  TooltipOptions.prototype.component1 = function () {
    return this.title;
  };
  TooltipOptions.prototype.component2 = function () {
    return this.rich;
  };
  TooltipOptions.prototype.component3 = function () {
    return this.animation;
  };
  TooltipOptions.prototype.component4 = function () {
    return this.delay;
  };
  TooltipOptions.prototype.component5 = function () {
    return this.hideDelay;
  };
  TooltipOptions.prototype.component6 = function () {
    return this.placement;
  };
  TooltipOptions.prototype.component7 = function () {
    return this.triggers;
  };
  TooltipOptions.prototype.component8 = function () {
    return this.sanitize;
  };
  TooltipOptions.prototype.copy_9214e9$ = function (title, rich, animation, delay, hideDelay, placement, triggers, sanitize) {
    return new TooltipOptions(title === void 0 ? this.title : title, rich === void 0 ? this.rich : rich, animation === void 0 ? this.animation : animation, delay === void 0 ? this.delay : delay, hideDelay === void 0 ? this.hideDelay : hideDelay, placement === void 0 ? this.placement : placement, triggers === void 0 ? this.triggers : triggers, sanitize === void 0 ? this.sanitize : sanitize);
  };
  TooltipOptions.prototype.toString = function () {
    return 'TooltipOptions(title=' + Kotlin.toString(this.title) + (', rich=' + Kotlin.toString(this.rich)) + (', animation=' + Kotlin.toString(this.animation)) + (', delay=' + Kotlin.toString(this.delay)) + (', hideDelay=' + Kotlin.toString(this.hideDelay)) + (', placement=' + Kotlin.toString(this.placement)) + (', triggers=' + Kotlin.toString(this.triggers)) + (', sanitize=' + Kotlin.toString(this.sanitize)) + ')';
  };
  TooltipOptions.prototype.hashCode = function () {
    var result = 0;
    result = result * 31 + Kotlin.hashCode(this.title) | 0;
    result = result * 31 + Kotlin.hashCode(this.rich) | 0;
    result = result * 31 + Kotlin.hashCode(this.animation) | 0;
    result = result * 31 + Kotlin.hashCode(this.delay) | 0;
    result = result * 31 + Kotlin.hashCode(this.hideDelay) | 0;
    result = result * 31 + Kotlin.hashCode(this.placement) | 0;
    result = result * 31 + Kotlin.hashCode(this.triggers) | 0;
    result = result * 31 + Kotlin.hashCode(this.sanitize) | 0;
    return result;
  };
  TooltipOptions.prototype.equals = function (other) {
    return this === other || (other !== null && (typeof other === 'object' && (Object.getPrototypeOf(this) === Object.getPrototypeOf(other) && (Kotlin.equals(this.title, other.title) && Kotlin.equals(this.rich, other.rich) && Kotlin.equals(this.animation, other.animation) && Kotlin.equals(this.delay, other.delay) && Kotlin.equals(this.hideDelay, other.hideDelay) && Kotlin.equals(this.placement, other.placement) && Kotlin.equals(this.triggers, other.triggers) && Kotlin.equals(this.sanitize, other.sanitize)))));
  };
  function toJs$lambda(it) {
    return it.trigger_8be2vx$;
  }
  function toJs($receiver) {
    var tmp$;
    var trigger = (tmp$ = $receiver.triggers) != null ? joinToString(tmp$, ' ', void 0, void 0, void 0, void 0, toJs$lambda) : null;
    var $receiver_0 = new Object_init();
    if ($receiver.title != null)
      $receiver_0.title = $receiver.title;
    if ($receiver.rich != null)
      $receiver_0.html = $receiver.rich;
    if ($receiver.animation != null)
      $receiver_0.animation = $receiver.animation;
    if ($receiver.delay != null && $receiver.hideDelay != null) {
      var $receiver_1 = new Object_init();
      $receiver_1.show = $receiver.delay;
      $receiver_1.hide = $receiver.hideDelay;
      $receiver_0.delay = $receiver_1;
    } else if ($receiver.delay != null) {
      $receiver_0.delay = $receiver.delay;
    } else if ($receiver.hideDelay != null) {
      var $receiver_2 = new Object_init();
      $receiver_2.show = 0;
      $receiver_2.hide = $receiver.hideDelay;
      $receiver_0.delay = $receiver_2;
    }if ($receiver.placement != null)
      $receiver_0.placement = $receiver.placement.placement_8be2vx$;
    if (trigger != null)
      $receiver_0.trigger = trigger;
    if ($receiver.sanitize != null)
      $receiver_0.sanitize = $receiver.sanitize;
    return $receiver_0;
  }
  function PopoverOptions(content, title, rich, animation, delay, hideDelay, placement, triggers, sanitize) {
    if (content === void 0)
      content = null;
    if (title === void 0)
      title = null;
    if (rich === void 0)
      rich = null;
    if (animation === void 0)
      animation = null;
    if (delay === void 0)
      delay = null;
    if (hideDelay === void 0)
      hideDelay = null;
    if (placement === void 0)
      placement = null;
    if (triggers === void 0)
      triggers = null;
    if (sanitize === void 0)
      sanitize = null;
    this.content = content;
    this.title = title;
    this.rich = rich;
    this.animation = animation;
    this.delay = delay;
    this.hideDelay = hideDelay;
    this.placement = placement;
    this.triggers = triggers;
    this.sanitize = sanitize;
  }
  PopoverOptions.$metadata$ = {kind: Kind_CLASS, simpleName: 'PopoverOptions', interfaces: []};
  PopoverOptions.prototype.component1 = function () {
    return this.content;
  };
  PopoverOptions.prototype.component2 = function () {
    return this.title;
  };
  PopoverOptions.prototype.component3 = function () {
    return this.rich;
  };
  PopoverOptions.prototype.component4 = function () {
    return this.animation;
  };
  PopoverOptions.prototype.component5 = function () {
    return this.delay;
  };
  PopoverOptions.prototype.component6 = function () {
    return this.hideDelay;
  };
  PopoverOptions.prototype.component7 = function () {
    return this.placement;
  };
  PopoverOptions.prototype.component8 = function () {
    return this.triggers;
  };
  PopoverOptions.prototype.component9 = function () {
    return this.sanitize;
  };
  PopoverOptions.prototype.copy_kzv7d6$ = function (content, title, rich, animation, delay, hideDelay, placement, triggers, sanitize) {
    return new PopoverOptions(content === void 0 ? this.content : content, title === void 0 ? this.title : title, rich === void 0 ? this.rich : rich, animation === void 0 ? this.animation : animation, delay === void 0 ? this.delay : delay, hideDelay === void 0 ? this.hideDelay : hideDelay, placement === void 0 ? this.placement : placement, triggers === void 0 ? this.triggers : triggers, sanitize === void 0 ? this.sanitize : sanitize);
  };
  PopoverOptions.prototype.toString = function () {
    return 'PopoverOptions(content=' + Kotlin.toString(this.content) + (', title=' + Kotlin.toString(this.title)) + (', rich=' + Kotlin.toString(this.rich)) + (', animation=' + Kotlin.toString(this.animation)) + (', delay=' + Kotlin.toString(this.delay)) + (', hideDelay=' + Kotlin.toString(this.hideDelay)) + (', placement=' + Kotlin.toString(this.placement)) + (', triggers=' + Kotlin.toString(this.triggers)) + (', sanitize=' + Kotlin.toString(this.sanitize)) + ')';
  };
  PopoverOptions.prototype.hashCode = function () {
    var result = 0;
    result = result * 31 + Kotlin.hashCode(this.content) | 0;
    result = result * 31 + Kotlin.hashCode(this.title) | 0;
    result = result * 31 + Kotlin.hashCode(this.rich) | 0;
    result = result * 31 + Kotlin.hashCode(this.animation) | 0;
    result = result * 31 + Kotlin.hashCode(this.delay) | 0;
    result = result * 31 + Kotlin.hashCode(this.hideDelay) | 0;
    result = result * 31 + Kotlin.hashCode(this.placement) | 0;
    result = result * 31 + Kotlin.hashCode(this.triggers) | 0;
    result = result * 31 + Kotlin.hashCode(this.sanitize) | 0;
    return result;
  };
  PopoverOptions.prototype.equals = function (other) {
    return this === other || (other !== null && (typeof other === 'object' && (Object.getPrototypeOf(this) === Object.getPrototypeOf(other) && (Kotlin.equals(this.content, other.content) && Kotlin.equals(this.title, other.title) && Kotlin.equals(this.rich, other.rich) && Kotlin.equals(this.animation, other.animation) && Kotlin.equals(this.delay, other.delay) && Kotlin.equals(this.hideDelay, other.hideDelay) && Kotlin.equals(this.placement, other.placement) && Kotlin.equals(this.triggers, other.triggers) && Kotlin.equals(this.sanitize, other.sanitize)))));
  };
  function toJs$lambda_0(it) {
    return it.trigger_8be2vx$;
  }
  function toJs_0($receiver) {
    var tmp$;
    var trigger = (tmp$ = $receiver.triggers) != null ? joinToString(tmp$, ' ', void 0, void 0, void 0, void 0, toJs$lambda_0) : null;
    var $receiver_0 = new Object_init();
    if ($receiver.content != null)
      $receiver_0.content = $receiver.content;
    if ($receiver.title != null)
      $receiver_0.title = $receiver.title;
    if ($receiver.rich != null)
      $receiver_0.html = $receiver.rich;
    if ($receiver.animation != null)
      $receiver_0.animation = $receiver.animation;
    if ($receiver.delay != null && $receiver.hideDelay != null) {
      var $receiver_1 = new Object_init();
      $receiver_1.show = $receiver.delay;
      $receiver_1.hide = $receiver.hideDelay;
      $receiver_0.delay = $receiver_1;
    } else if ($receiver.delay != null) {
      $receiver_0.delay = $receiver.delay;
    } else if ($receiver.hideDelay != null) {
      var $receiver_2 = new Object_init();
      $receiver_2.show = 0;
      $receiver_2.hide = $receiver.hideDelay;
      $receiver_0.delay = $receiver_2;
    }if ($receiver.placement != null)
      $receiver_0.placement = $receiver.placement.placement_8be2vx$;
    if (trigger != null)
      $receiver_0.trigger = trigger;
    if ($receiver.sanitize != null)
      $receiver_0.sanitize = $receiver.sanitize;
    return $receiver_0;
  }
  function SingleObjectCache() {
  }
  SingleObjectCache.prototype.clearOn_u332lz$ = function (shouldClear) {
    return new AutoClearCache(this, shouldClear);
  };
  SingleObjectCache.$metadata$ = {kind: Kind_INTERFACE, simpleName: 'SingleObjectCache', interfaces: []};
  function LazyCache(initializer) {
    this.initializer = initializer;
    this._value_0 = null;
  }
  Object.defineProperty(LazyCache.prototype, 'value', {configurable: true, get: function () {
    var tmp$;
    var tmp$_0;
    if ((tmp$ = this._value_0) != null)
      tmp$_0 = tmp$;
    else {
      var $receiver = this.initializer();
      this._value_0 = $receiver;
      tmp$_0 = $receiver;
    }
    return tmp$_0;
  }});
  LazyCache.prototype.clear = function () {
    this._value_0 = null;
  };
  LazyCache.$metadata$ = {kind: Kind_CLASS, simpleName: 'LazyCache', interfaces: [SingleObjectCache]};
  function AutoClearCache(delegate, shouldClear) {
    this.delegate = delegate;
    this.shouldClear = shouldClear;
  }
  Object.defineProperty(AutoClearCache.prototype, 'value', {configurable: true, get: function () {
    if (this.shouldClear()) {
      this.delegate.clear();
    }return this.delegate.value;
  }});
  AutoClearCache.prototype.clear = function () {
    return this.delegate.clear();
  };
  AutoClearCache.prototype.clearOn_u332lz$ = function (shouldClear) {
    return this.delegate.clearOn_u332lz$(shouldClear);
  };
  AutoClearCache.$metadata$ = {kind: Kind_CLASS, simpleName: 'AutoClearCache', interfaces: [SingleObjectCache]};
  function Style(className, parentStyle, init) {
    Style$Companion_getInstance();
    if (className === void 0)
      className = null;
    if (parentStyle === void 0)
      parentStyle = null;
    if (init === void 0)
      init = null;
    StyledComponent.call(this);
    this.propertyValues_8shy5i$_0 = {};
    var tmp$, tmp$_0, tmp$_1;
    if (parentStyle == null) {
      tmp$_1 = className != null ? className : 'kv_styleclass_' + (tmp$ = Style$Companion_getInstance().counter_8be2vx$, Style$Companion_getInstance().counter_8be2vx$ = tmp$ + 1 | 0, tmp$);
    } else {
      tmp$_1 = parentStyle.className + ' ' + (className != null ? className : '.kv_styleclass_' + (tmp$_0 = Style$Companion_getInstance().counter_8be2vx$, Style$Companion_getInstance().counter_8be2vx$ = tmp$_0 + 1 | 0, tmp$_0));
    }
    this.newClassName_dg8yku$_0 = tmp$_1;
    this.className_5lrym8$_0 = (new Style$RefreshDelegateProvider(this, this.newClassName_dg8yku$_0, Style$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, Style$className_metadata);
    Style$Companion_getInstance().styles_8be2vx$.add_11rb$(this);
    init != null ? init(this) : null;
  }
  var Style$className_metadata = new PropertyMetadata('className');
  function Style$Companion() {
    Style$Companion_instance = this;
    this.counter_8be2vx$ = 0;
    this.styles_8be2vx$ = ArrayList_init();
  }
  Style$Companion.$metadata$ = {kind: Kind_OBJECT, simpleName: 'Companion', interfaces: []};
  var Style$Companion_instance = null;
  function Style$Companion_getInstance() {
    if (Style$Companion_instance === null) {
      new Style$Companion();
    }return Style$Companion_instance;
  }
  function StyledComponent$refreshOnUpdate$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.refresh();
      return Unit;
    };
  }
  function StyledComponent() {
    StyledComponent$Companion_getInstance();
    this.propertyValues_mhxfgz$_0 = {};
    this.customStyles_5fgek7$_0 = {};
    this.width_kzal5o$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$width_metadata);
    this.minWidth_k32s5m$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$minWidth_metadata);
    this.maxWidth_wuzofs$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$maxWidth_metadata);
    this.height_k0dlj1$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$height_metadata);
    this.minHeight_7qcdip$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$minHeight_metadata);
    this.maxHeight_x5f5cx$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$maxHeight_metadata);
    this.display_wr589k$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$display_metadata);
    this.position_371c01$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$position_metadata);
    this.top_bh8wb$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$top_metadata);
    this.left_a0fkf1$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$left_metadata);
    this.right_nch0s2$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$right_metadata);
    this.bottom_w4wukh$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$bottom_metadata);
    this.zIndex_hwuxea$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$zIndex_metadata);
    this.overflow_xeq3ig$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$overflow_metadata);
    this.overflowWrap_tjkgm6$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$overflowWrap_metadata);
    this.resize_f53acq$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$resize_metadata);
    this.border_w6auua$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$border_metadata);
    this.borderTop_zdbls1$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$borderTop_metadata);
    this.borderRight_y7onae$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$borderRight_metadata);
    this.borderBottom_duwyh9$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$borderBottom_metadata);
    this.borderLeft_uvq0wn$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$borderLeft_metadata);
    this.margin_jeqk10$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$margin_metadata);
    this.marginTop_x8pxtp$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$marginTop_metadata);
    this.marginRight_h2q0ws$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$marginRight_metadata);
    this.marginBottom_df8o8h$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$marginBottom_metadata);
    this.marginLeft_ytrsgl$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$marginLeft_metadata);
    this.padding_oohi13$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$padding_metadata);
    this.paddingTop_610hdm$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$paddingTop_metadata);
    this.paddingRight_uftvbz$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$paddingRight_metadata);
    this.paddingBottom_1ivjgu$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$paddingBottom_metadata);
    this.paddingLeft_q3calu$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$paddingLeft_metadata);
    this.color_ucr921$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$color_metadata);
    this.opacity_n5xnen$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$opacity_metadata);
    this.background_ox5nxg$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$background_metadata);
    this.textDirection_sm05k8$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$textDirection_metadata);
    this.letterSpacing_ec5ik3$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$letterSpacing_metadata);
    this.lineHeight_wk48nl$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$lineHeight_metadata);
    this.textAlign_r5zeky$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$textAlign_metadata);
    this.textDecoration_2yphpp$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$textDecoration_metadata);
    this.textIndent_xzlwjz$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$textIndent_metadata);
    this.textShadow_w5swlf$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$textShadow_metadata);
    this.textTransform_a57yiz$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$textTransform_metadata);
    this.textOverflow_bkrw63$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$textOverflow_metadata);
    this.unicodeBidi_qqq9rz$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$unicodeBidi_metadata);
    this.verticalAlign_nohwyj$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$verticalAlign_metadata);
    this.whiteSpace_3js5sd$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$whiteSpace_metadata);
    this.wordSpacing_xblwen$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$wordSpacing_metadata);
    this.fontFamily_u6vlcn$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$fontFamily_metadata);
    this.fontSize_kc6tju$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$fontSize_metadata);
    this.fontStyle_8m3rw8$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$fontStyle_metadata);
    this.fontWeight_2kvum5$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$fontWeight_metadata);
    this.fontVariant_l61898$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$fontVariant_metadata);
    this.float_sz850y$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$float_metadata);
    this.clear_ueje4j$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$clear_metadata);
    this.wordBreak_ll65md$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$wordBreak_metadata);
    this.lineBreak_5zhswx$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$lineBreak_metadata);
    this.cursor_end218$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$cursor_metadata);
    this.flexDirection_xxd36k$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$flexDirection_metadata);
    this.flexWrap_gtlwuf$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$flexWrap_metadata);
    this.justifyItems_aujwue$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$justifyItems_metadata);
    this.justifyContent_cxcf4v$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$justifyContent_metadata);
    this.alignItems_t3q0y9$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$alignItems_metadata);
    this.alignContent_b2qiay$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$alignContent_metadata);
    this.order_omppus$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$order_metadata);
    this.flexGrow_gkthwe$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$flexGrow_metadata);
    this.flexShrink_kteuxk$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$flexShrink_metadata);
    this.flexBasis_e33pz9$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$flexBasis_metadata);
    this.alignSelf_c8zyhz$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$alignSelf_metadata);
    this.justifySelf_9db8r6$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$justifySelf_metadata);
    this.gridAutoColumns_xba5ia$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$gridAutoColumns_metadata);
    this.gridAutoRows_rirek$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$gridAutoRows_metadata);
    this.gridAutoFlow_kv5hj$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$gridAutoFlow_metadata);
    this.gridTemplateColumns_vo4ai5$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$gridTemplateColumns_metadata);
    this.gridTemplateRows_ho38ep$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$gridTemplateRows_metadata);
    this.gridTemplateAreas_sik7rw$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$gridTemplateAreas_metadata);
    this.gridColumnGap_493brk$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$gridColumnGap_metadata);
    this.gridRowGap_3z3jk8$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$gridRowGap_metadata);
    this.gridColumnStart_vzmqfw$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$gridColumnStart_metadata);
    this.gridRowStart_9rqkas$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$gridRowStart_metadata);
    this.gridColumnEnd_494cdx$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$gridColumnEnd_metadata);
    this.gridRowEnd_3z2ixv$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$gridRowEnd_metadata);
    this.gridArea_4bi4y1$_0 = (new StyledComponent$RefreshDelegateProvider(this, null, StyledComponent$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$gridArea_metadata);
    this.snStyleCache_4me8oy$_0 = null;
  }
  var StyledComponent$width_metadata = new PropertyMetadata('width');
  Object.defineProperty(StyledComponent.prototype, 'width', {configurable: true, get: function () {
    return this.width_kzal5o$_0.getValue_fmbzy8$(this, StyledComponent$width_metadata);
  }, set: function (width) {
    this.width_kzal5o$_0.setValue_19qrsr$(this, StyledComponent$width_metadata, width);
  }});
  var StyledComponent$minWidth_metadata = new PropertyMetadata('minWidth');
  Object.defineProperty(StyledComponent.prototype, 'minWidth', {configurable: true, get: function () {
    return this.minWidth_k32s5m$_0.getValue_fmbzy8$(this, StyledComponent$minWidth_metadata);
  }, set: function (minWidth) {
    this.minWidth_k32s5m$_0.setValue_19qrsr$(this, StyledComponent$minWidth_metadata, minWidth);
  }});
  var StyledComponent$maxWidth_metadata = new PropertyMetadata('maxWidth');
  Object.defineProperty(StyledComponent.prototype, 'maxWidth', {configurable: true, get: function () {
    return this.maxWidth_wuzofs$_0.getValue_fmbzy8$(this, StyledComponent$maxWidth_metadata);
  }, set: function (maxWidth) {
    this.maxWidth_wuzofs$_0.setValue_19qrsr$(this, StyledComponent$maxWidth_metadata, maxWidth);
  }});
  var StyledComponent$height_metadata = new PropertyMetadata('height');
  Object.defineProperty(StyledComponent.prototype, 'height', {configurable: true, get: function () {
    return this.height_k0dlj1$_0.getValue_fmbzy8$(this, StyledComponent$height_metadata);
  }, set: function (height) {
    this.height_k0dlj1$_0.setValue_19qrsr$(this, StyledComponent$height_metadata, height);
  }});
  var StyledComponent$minHeight_metadata = new PropertyMetadata('minHeight');
  Object.defineProperty(StyledComponent.prototype, 'minHeight', {configurable: true, get: function () {
    return this.minHeight_7qcdip$_0.getValue_fmbzy8$(this, StyledComponent$minHeight_metadata);
  }, set: function (minHeight) {
    this.minHeight_7qcdip$_0.setValue_19qrsr$(this, StyledComponent$minHeight_metadata, minHeight);
  }});
  var StyledComponent$maxHeight_metadata = new PropertyMetadata('maxHeight');
  Object.defineProperty(StyledComponent.prototype, 'maxHeight', {configurable: true, get: function () {
    return this.maxHeight_x5f5cx$_0.getValue_fmbzy8$(this, StyledComponent$maxHeight_metadata);
  }, set: function (maxHeight) {
    this.maxHeight_x5f5cx$_0.setValue_19qrsr$(this, StyledComponent$maxHeight_metadata, maxHeight);
  }});
  var StyledComponent$display_metadata = new PropertyMetadata('display');
  Object.defineProperty(StyledComponent.prototype, 'display', {configurable: true, get: function () {
    return this.display_wr589k$_0.getValue_fmbzy8$(this, StyledComponent$display_metadata);
  }, set: function (display) {
    this.display_wr589k$_0.setValue_19qrsr$(this, StyledComponent$display_metadata, display);
  }});
  var StyledComponent$position_metadata = new PropertyMetadata('position');
  Object.defineProperty(StyledComponent.prototype, 'position', {configurable: true, get: function () {
    return this.position_371c01$_0.getValue_fmbzy8$(this, StyledComponent$position_metadata);
  }, set: function (position) {
    this.position_371c01$_0.setValue_19qrsr$(this, StyledComponent$position_metadata, position);
  }});
  var StyledComponent$top_metadata = new PropertyMetadata('top');
  Object.defineProperty(StyledComponent.prototype, 'top', {configurable: true, get: function () {
    return this.top_bh8wb$_0.getValue_fmbzy8$(this, StyledComponent$top_metadata);
  }, set: function (top) {
    this.top_bh8wb$_0.setValue_19qrsr$(this, StyledComponent$top_metadata, top);
  }});
  var StyledComponent$left_metadata = new PropertyMetadata('left');
  Object.defineProperty(StyledComponent.prototype, 'left', {configurable: true, get: function () {
    return this.left_a0fkf1$_0.getValue_fmbzy8$(this, StyledComponent$left_metadata);
  }, set: function (left) {
    this.left_a0fkf1$_0.setValue_19qrsr$(this, StyledComponent$left_metadata, left);
  }});
  var StyledComponent$right_metadata = new PropertyMetadata('right');
  Object.defineProperty(StyledComponent.prototype, 'right', {configurable: true, get: function () {
    return this.right_nch0s2$_0.getValue_fmbzy8$(this, StyledComponent$right_metadata);
  }, set: function (right) {
    this.right_nch0s2$_0.setValue_19qrsr$(this, StyledComponent$right_metadata, right);
  }});
  var StyledComponent$bottom_metadata = new PropertyMetadata('bottom');
  Object.defineProperty(StyledComponent.prototype, 'bottom', {configurable: true, get: function () {
    return this.bottom_w4wukh$_0.getValue_fmbzy8$(this, StyledComponent$bottom_metadata);
  }, set: function (bottom) {
    this.bottom_w4wukh$_0.setValue_19qrsr$(this, StyledComponent$bottom_metadata, bottom);
  }});
  var StyledComponent$zIndex_metadata = new PropertyMetadata('zIndex');
  Object.defineProperty(StyledComponent.prototype, 'zIndex', {configurable: true, get: function () {
    return this.zIndex_hwuxea$_0.getValue_fmbzy8$(this, StyledComponent$zIndex_metadata);
  }, set: function (zIndex) {
    this.zIndex_hwuxea$_0.setValue_19qrsr$(this, StyledComponent$zIndex_metadata, zIndex);
  }});
  var StyledComponent$overflow_metadata = new PropertyMetadata('overflow');
  Object.defineProperty(StyledComponent.prototype, 'overflow', {configurable: true, get: function () {
    return this.overflow_xeq3ig$_0.getValue_fmbzy8$(this, StyledComponent$overflow_metadata);
  }, set: function (overflow) {
    this.overflow_xeq3ig$_0.setValue_19qrsr$(this, StyledComponent$overflow_metadata, overflow);
  }});
  var StyledComponent$overflowWrap_metadata = new PropertyMetadata('overflowWrap');
  Object.defineProperty(StyledComponent.prototype, 'overflowWrap', {configurable: true, get: function () {
    return this.overflowWrap_tjkgm6$_0.getValue_fmbzy8$(this, StyledComponent$overflowWrap_metadata);
  }, set: function (overflowWrap) {
    this.overflowWrap_tjkgm6$_0.setValue_19qrsr$(this, StyledComponent$overflowWrap_metadata, overflowWrap);
  }});
  var StyledComponent$resize_metadata = new PropertyMetadata('resize');
  Object.defineProperty(StyledComponent.prototype, 'resize', {configurable: true, get: function () {
    return this.resize_f53acq$_0.getValue_fmbzy8$(this, StyledComponent$resize_metadata);
  }, set: function (resize) {
    this.resize_f53acq$_0.setValue_19qrsr$(this, StyledComponent$resize_metadata, resize);
  }});
  var StyledComponent$border_metadata = new PropertyMetadata('border');
  Object.defineProperty(StyledComponent.prototype, 'border', {configurable: true, get: function () {
    return this.border_w6auua$_0.getValue_fmbzy8$(this, StyledComponent$border_metadata);
  }, set: function (border) {
    this.border_w6auua$_0.setValue_19qrsr$(this, StyledComponent$border_metadata, border);
  }});
  var StyledComponent$borderTop_metadata = new PropertyMetadata('borderTop');
  Object.defineProperty(StyledComponent.prototype, 'borderTop', {configurable: true, get: function () {
    return this.borderTop_zdbls1$_0.getValue_fmbzy8$(this, StyledComponent$borderTop_metadata);
  }, set: function (borderTop) {
    this.borderTop_zdbls1$_0.setValue_19qrsr$(this, StyledComponent$borderTop_metadata, borderTop);
  }});
  var StyledComponent$borderRight_metadata = new PropertyMetadata('borderRight');
  Object.defineProperty(StyledComponent.prototype, 'borderRight', {configurable: true, get: function () {
    return this.borderRight_y7onae$_0.getValue_fmbzy8$(this, StyledComponent$borderRight_metadata);
  }, set: function (borderRight) {
    this.borderRight_y7onae$_0.setValue_19qrsr$(this, StyledComponent$borderRight_metadata, borderRight);
  }});
  var StyledComponent$borderBottom_metadata = new PropertyMetadata('borderBottom');
  Object.defineProperty(StyledComponent.prototype, 'borderBottom', {configurable: true, get: function () {
    return this.borderBottom_duwyh9$_0.getValue_fmbzy8$(this, StyledComponent$borderBottom_metadata);
  }, set: function (borderBottom) {
    this.borderBottom_duwyh9$_0.setValue_19qrsr$(this, StyledComponent$borderBottom_metadata, borderBottom);
  }});
  var StyledComponent$borderLeft_metadata = new PropertyMetadata('borderLeft');
  Object.defineProperty(StyledComponent.prototype, 'borderLeft', {configurable: true, get: function () {
    return this.borderLeft_uvq0wn$_0.getValue_fmbzy8$(this, StyledComponent$borderLeft_metadata);
  }, set: function (borderLeft) {
    this.borderLeft_uvq0wn$_0.setValue_19qrsr$(this, StyledComponent$borderLeft_metadata, borderLeft);
  }});
  var StyledComponent$margin_metadata = new PropertyMetadata('margin');
  Object.defineProperty(StyledComponent.prototype, 'margin', {configurable: true, get: function () {
    return this.margin_jeqk10$_0.getValue_fmbzy8$(this, StyledComponent$margin_metadata);
  }, set: function (margin) {
    this.margin_jeqk10$_0.setValue_19qrsr$(this, StyledComponent$margin_metadata, margin);
  }});
  var StyledComponent$marginTop_metadata = new PropertyMetadata('marginTop');
  Object.defineProperty(StyledComponent.prototype, 'marginTop', {configurable: true, get: function () {
    return this.marginTop_x8pxtp$_0.getValue_fmbzy8$(this, StyledComponent$marginTop_metadata);
  }, set: function (marginTop) {
    this.marginTop_x8pxtp$_0.setValue_19qrsr$(this, StyledComponent$marginTop_metadata, marginTop);
  }});
  var StyledComponent$marginRight_metadata = new PropertyMetadata('marginRight');
  Object.defineProperty(StyledComponent.prototype, 'marginRight', {configurable: true, get: function () {
    return this.marginRight_h2q0ws$_0.getValue_fmbzy8$(this, StyledComponent$marginRight_metadata);
  }, set: function (marginRight) {
    this.marginRight_h2q0ws$_0.setValue_19qrsr$(this, StyledComponent$marginRight_metadata, marginRight);
  }});
  var StyledComponent$marginBottom_metadata = new PropertyMetadata('marginBottom');
  Object.defineProperty(StyledComponent.prototype, 'marginBottom', {configurable: true, get: function () {
    return this.marginBottom_df8o8h$_0.getValue_fmbzy8$(this, StyledComponent$marginBottom_metadata);
  }, set: function (marginBottom) {
    this.marginBottom_df8o8h$_0.setValue_19qrsr$(this, StyledComponent$marginBottom_metadata, marginBottom);
  }});
  var StyledComponent$marginLeft_metadata = new PropertyMetadata('marginLeft');
  Object.defineProperty(StyledComponent.prototype, 'marginLeft', {configurable: true, get: function () {
    return this.marginLeft_ytrsgl$_0.getValue_fmbzy8$(this, StyledComponent$marginLeft_metadata);
  }, set: function (marginLeft) {
    this.marginLeft_ytrsgl$_0.setValue_19qrsr$(this, StyledComponent$marginLeft_metadata, marginLeft);
  }});
  var StyledComponent$padding_metadata = new PropertyMetadata('padding');
  Object.defineProperty(StyledComponent.prototype, 'padding', {configurable: true, get: function () {
    return this.padding_oohi13$_0.getValue_fmbzy8$(this, StyledComponent$padding_metadata);
  }, set: function (padding) {
    this.padding_oohi13$_0.setValue_19qrsr$(this, StyledComponent$padding_metadata, padding);
  }});
  var StyledComponent$paddingTop_metadata = new PropertyMetadata('paddingTop');
  Object.defineProperty(StyledComponent.prototype, 'paddingTop', {configurable: true, get: function () {
    return this.paddingTop_610hdm$_0.getValue_fmbzy8$(this, StyledComponent$paddingTop_metadata);
  }, set: function (paddingTop) {
    this.paddingTop_610hdm$_0.setValue_19qrsr$(this, StyledComponent$paddingTop_metadata, paddingTop);
  }});
  var StyledComponent$paddingRight_metadata = new PropertyMetadata('paddingRight');
  Object.defineProperty(StyledComponent.prototype, 'paddingRight', {configurable: true, get: function () {
    return this.paddingRight_uftvbz$_0.getValue_fmbzy8$(this, StyledComponent$paddingRight_metadata);
  }, set: function (paddingRight) {
    this.paddingRight_uftvbz$_0.setValue_19qrsr$(this, StyledComponent$paddingRight_metadata, paddingRight);
  }});
  var StyledComponent$paddingBottom_metadata = new PropertyMetadata('paddingBottom');
  Object.defineProperty(StyledComponent.prototype, 'paddingBottom', {configurable: true, get: function () {
    return this.paddingBottom_1ivjgu$_0.getValue_fmbzy8$(this, StyledComponent$paddingBottom_metadata);
  }, set: function (paddingBottom) {
    this.paddingBottom_1ivjgu$_0.setValue_19qrsr$(this, StyledComponent$paddingBottom_metadata, paddingBottom);
  }});
  var StyledComponent$paddingLeft_metadata = new PropertyMetadata('paddingLeft');
  Object.defineProperty(StyledComponent.prototype, 'paddingLeft', {configurable: true, get: function () {
    return this.paddingLeft_q3calu$_0.getValue_fmbzy8$(this, StyledComponent$paddingLeft_metadata);
  }, set: function (paddingLeft) {
    this.paddingLeft_q3calu$_0.setValue_19qrsr$(this, StyledComponent$paddingLeft_metadata, paddingLeft);
  }});
  var StyledComponent$color_metadata = new PropertyMetadata('color');
  Object.defineProperty(StyledComponent.prototype, 'color', {configurable: true, get: function () {
    return this.color_ucr921$_0.getValue_fmbzy8$(this, StyledComponent$color_metadata);
  }, set: function (color) {
    this.color_ucr921$_0.setValue_19qrsr$(this, StyledComponent$color_metadata, color);
  }});
  Object.defineProperty(StyledComponent.prototype, 'colorHex', {configurable: true, get: function () {
    return null;
  }, set: function (value) {
    this.color = value != null ? Color$Companion_getInstance().hex_za3lpa$(value) : null;
  }});
  Object.defineProperty(StyledComponent.prototype, 'colorName', {configurable: true, get: function () {
    return null;
  }, set: function (value) {
    this.color = value != null ? Color$Companion_getInstance().name_fntfe4$(value) : null;
  }});
  var StyledComponent$opacity_metadata = new PropertyMetadata('opacity');
  Object.defineProperty(StyledComponent.prototype, 'opacity', {configurable: true, get: function () {
    return this.opacity_n5xnen$_0.getValue_fmbzy8$(this, StyledComponent$opacity_metadata);
  }, set: function (opacity) {
    this.opacity_n5xnen$_0.setValue_19qrsr$(this, StyledComponent$opacity_metadata, opacity);
  }});
  var StyledComponent$background_metadata = new PropertyMetadata('background');
  Object.defineProperty(StyledComponent.prototype, 'background', {configurable: true, get: function () {
    return this.background_ox5nxg$_0.getValue_fmbzy8$(this, StyledComponent$background_metadata);
  }, set: function (background) {
    this.background_ox5nxg$_0.setValue_19qrsr$(this, StyledComponent$background_metadata, background);
  }});
  var StyledComponent$textDirection_metadata = new PropertyMetadata('textDirection');
  Object.defineProperty(StyledComponent.prototype, 'textDirection', {configurable: true, get: function () {
    return this.textDirection_sm05k8$_0.getValue_fmbzy8$(this, StyledComponent$textDirection_metadata);
  }, set: function (textDirection) {
    this.textDirection_sm05k8$_0.setValue_19qrsr$(this, StyledComponent$textDirection_metadata, textDirection);
  }});
  var StyledComponent$letterSpacing_metadata = new PropertyMetadata('letterSpacing');
  Object.defineProperty(StyledComponent.prototype, 'letterSpacing', {configurable: true, get: function () {
    return this.letterSpacing_ec5ik3$_0.getValue_fmbzy8$(this, StyledComponent$letterSpacing_metadata);
  }, set: function (letterSpacing) {
    this.letterSpacing_ec5ik3$_0.setValue_19qrsr$(this, StyledComponent$letterSpacing_metadata, letterSpacing);
  }});
  var StyledComponent$lineHeight_metadata = new PropertyMetadata('lineHeight');
  Object.defineProperty(StyledComponent.prototype, 'lineHeight', {configurable: true, get: function () {
    return this.lineHeight_wk48nl$_0.getValue_fmbzy8$(this, StyledComponent$lineHeight_metadata);
  }, set: function (lineHeight) {
    this.lineHeight_wk48nl$_0.setValue_19qrsr$(this, StyledComponent$lineHeight_metadata, lineHeight);
  }});
  var StyledComponent$textAlign_metadata = new PropertyMetadata('textAlign');
  Object.defineProperty(StyledComponent.prototype, 'textAlign', {configurable: true, get: function () {
    return this.textAlign_r5zeky$_0.getValue_fmbzy8$(this, StyledComponent$textAlign_metadata);
  }, set: function (textAlign) {
    this.textAlign_r5zeky$_0.setValue_19qrsr$(this, StyledComponent$textAlign_metadata, textAlign);
  }});
  var StyledComponent$textDecoration_metadata = new PropertyMetadata('textDecoration');
  Object.defineProperty(StyledComponent.prototype, 'textDecoration', {configurable: true, get: function () {
    return this.textDecoration_2yphpp$_0.getValue_fmbzy8$(this, StyledComponent$textDecoration_metadata);
  }, set: function (textDecoration) {
    this.textDecoration_2yphpp$_0.setValue_19qrsr$(this, StyledComponent$textDecoration_metadata, textDecoration);
  }});
  var StyledComponent$textIndent_metadata = new PropertyMetadata('textIndent');
  Object.defineProperty(StyledComponent.prototype, 'textIndent', {configurable: true, get: function () {
    return this.textIndent_xzlwjz$_0.getValue_fmbzy8$(this, StyledComponent$textIndent_metadata);
  }, set: function (textIndent) {
    this.textIndent_xzlwjz$_0.setValue_19qrsr$(this, StyledComponent$textIndent_metadata, textIndent);
  }});
  var StyledComponent$textShadow_metadata = new PropertyMetadata('textShadow');
  Object.defineProperty(StyledComponent.prototype, 'textShadow', {configurable: true, get: function () {
    return this.textShadow_w5swlf$_0.getValue_fmbzy8$(this, StyledComponent$textShadow_metadata);
  }, set: function (textShadow) {
    this.textShadow_w5swlf$_0.setValue_19qrsr$(this, StyledComponent$textShadow_metadata, textShadow);
  }});
  var StyledComponent$textTransform_metadata = new PropertyMetadata('textTransform');
  Object.defineProperty(StyledComponent.prototype, 'textTransform', {configurable: true, get: function () {
    return this.textTransform_a57yiz$_0.getValue_fmbzy8$(this, StyledComponent$textTransform_metadata);
  }, set: function (textTransform) {
    this.textTransform_a57yiz$_0.setValue_19qrsr$(this, StyledComponent$textTransform_metadata, textTransform);
  }});
  var StyledComponent$textOverflow_metadata = new PropertyMetadata('textOverflow');
  Object.defineProperty(StyledComponent.prototype, 'textOverflow', {configurable: true, get: function () {
    return this.textOverflow_bkrw63$_0.getValue_fmbzy8$(this, StyledComponent$textOverflow_metadata);
  }, set: function (textOverflow) {
    this.textOverflow_bkrw63$_0.setValue_19qrsr$(this, StyledComponent$textOverflow_metadata, textOverflow);
  }});
  var StyledComponent$unicodeBidi_metadata = new PropertyMetadata('unicodeBidi');
  Object.defineProperty(StyledComponent.prototype, 'unicodeBidi', {configurable: true, get: function () {
    return this.unicodeBidi_qqq9rz$_0.getValue_fmbzy8$(this, StyledComponent$unicodeBidi_metadata);
  }, set: function (unicodeBidi) {
    this.unicodeBidi_qqq9rz$_0.setValue_19qrsr$(this, StyledComponent$unicodeBidi_metadata, unicodeBidi);
  }});
  var StyledComponent$verticalAlign_metadata = new PropertyMetadata('verticalAlign');
  Object.defineProperty(StyledComponent.prototype, 'verticalAlign', {configurable: true, get: function () {
    return this.verticalAlign_nohwyj$_0.getValue_fmbzy8$(this, StyledComponent$verticalAlign_metadata);
  }, set: function (verticalAlign) {
    this.verticalAlign_nohwyj$_0.setValue_19qrsr$(this, StyledComponent$verticalAlign_metadata, verticalAlign);
  }});
  var StyledComponent$whiteSpace_metadata = new PropertyMetadata('whiteSpace');
  Object.defineProperty(StyledComponent.prototype, 'whiteSpace', {configurable: true, get: function () {
    return this.whiteSpace_3js5sd$_0.getValue_fmbzy8$(this, StyledComponent$whiteSpace_metadata);
  }, set: function (whiteSpace) {
    this.whiteSpace_3js5sd$_0.setValue_19qrsr$(this, StyledComponent$whiteSpace_metadata, whiteSpace);
  }});
  var StyledComponent$wordSpacing_metadata = new PropertyMetadata('wordSpacing');
  Object.defineProperty(StyledComponent.prototype, 'wordSpacing', {configurable: true, get: function () {
    return this.wordSpacing_xblwen$_0.getValue_fmbzy8$(this, StyledComponent$wordSpacing_metadata);
  }, set: function (wordSpacing) {
    this.wordSpacing_xblwen$_0.setValue_19qrsr$(this, StyledComponent$wordSpacing_metadata, wordSpacing);
  }});
  var StyledComponent$fontFamily_metadata = new PropertyMetadata('fontFamily');
  Object.defineProperty(StyledComponent.prototype, 'fontFamily', {configurable: true, get: function () {
    return this.fontFamily_u6vlcn$_0.getValue_fmbzy8$(this, StyledComponent$fontFamily_metadata);
  }, set: function (fontFamily) {
    this.fontFamily_u6vlcn$_0.setValue_19qrsr$(this, StyledComponent$fontFamily_metadata, fontFamily);
  }});
  var StyledComponent$fontSize_metadata = new PropertyMetadata('fontSize');
  Object.defineProperty(StyledComponent.prototype, 'fontSize', {configurable: true, get: function () {
    return this.fontSize_kc6tju$_0.getValue_fmbzy8$(this, StyledComponent$fontSize_metadata);
  }, set: function (fontSize) {
    this.fontSize_kc6tju$_0.setValue_19qrsr$(this, StyledComponent$fontSize_metadata, fontSize);
  }});
  var StyledComponent$fontStyle_metadata = new PropertyMetadata('fontStyle');
  Object.defineProperty(StyledComponent.prototype, 'fontStyle', {configurable: true, get: function () {
    return this.fontStyle_8m3rw8$_0.getValue_fmbzy8$(this, StyledComponent$fontStyle_metadata);
  }, set: function (fontStyle) {
    this.fontStyle_8m3rw8$_0.setValue_19qrsr$(this, StyledComponent$fontStyle_metadata, fontStyle);
  }});
  var StyledComponent$fontWeight_metadata = new PropertyMetadata('fontWeight');
  Object.defineProperty(StyledComponent.prototype, 'fontWeight', {configurable: true, get: function () {
    return this.fontWeight_2kvum5$_0.getValue_fmbzy8$(this, StyledComponent$fontWeight_metadata);
  }, set: function (fontWeight) {
    this.fontWeight_2kvum5$_0.setValue_19qrsr$(this, StyledComponent$fontWeight_metadata, fontWeight);
  }});
  var StyledComponent$fontVariant_metadata = new PropertyMetadata('fontVariant');
  Object.defineProperty(StyledComponent.prototype, 'fontVariant', {configurable: true, get: function () {
    return this.fontVariant_l61898$_0.getValue_fmbzy8$(this, StyledComponent$fontVariant_metadata);
  }, set: function (fontVariant) {
    this.fontVariant_l61898$_0.setValue_19qrsr$(this, StyledComponent$fontVariant_metadata, fontVariant);
  }});
  var StyledComponent$float_metadata = new PropertyMetadata('float');
  Object.defineProperty(StyledComponent.prototype, 'float', {configurable: true, get: function () {
    return this.float_sz850y$_0.getValue_fmbzy8$(this, StyledComponent$float_metadata);
  }, set: function (float) {
    this.float_sz850y$_0.setValue_19qrsr$(this, StyledComponent$float_metadata, float);
  }});
  var StyledComponent$clear_metadata = new PropertyMetadata('clear');
  Object.defineProperty(StyledComponent.prototype, 'clear', {configurable: true, get: function () {
    return this.clear_ueje4j$_0.getValue_fmbzy8$(this, StyledComponent$clear_metadata);
  }, set: function (clear) {
    this.clear_ueje4j$_0.setValue_19qrsr$(this, StyledComponent$clear_metadata, clear);
  }});
  var StyledComponent$wordBreak_metadata = new PropertyMetadata('wordBreak');
  Object.defineProperty(StyledComponent.prototype, 'wordBreak', {configurable: true, get: function () {
    return this.wordBreak_ll65md$_0.getValue_fmbzy8$(this, StyledComponent$wordBreak_metadata);
  }, set: function (wordBreak) {
    this.wordBreak_ll65md$_0.setValue_19qrsr$(this, StyledComponent$wordBreak_metadata, wordBreak);
  }});
  var StyledComponent$lineBreak_metadata = new PropertyMetadata('lineBreak');
  Object.defineProperty(StyledComponent.prototype, 'lineBreak', {configurable: true, get: function () {
    return this.lineBreak_5zhswx$_0.getValue_fmbzy8$(this, StyledComponent$lineBreak_metadata);
  }, set: function (lineBreak) {
    this.lineBreak_5zhswx$_0.setValue_19qrsr$(this, StyledComponent$lineBreak_metadata, lineBreak);
  }});
  var StyledComponent$cursor_metadata = new PropertyMetadata('cursor');
  Object.defineProperty(StyledComponent.prototype, 'cursor', {configurable: true, get: function () {
    return this.cursor_end218$_0.getValue_fmbzy8$(this, StyledComponent$cursor_metadata);
  }, set: function (cursor) {
    this.cursor_end218$_0.setValue_19qrsr$(this, StyledComponent$cursor_metadata, cursor);
  }});
  var StyledComponent$flexDirection_metadata = new PropertyMetadata('flexDirection');
  Object.defineProperty(StyledComponent.prototype, 'flexDirection', {configurable: true, get: function () {
    return this.flexDirection_xxd36k$_0.getValue_fmbzy8$(this, StyledComponent$flexDirection_metadata);
  }, set: function (flexDirection) {
    this.flexDirection_xxd36k$_0.setValue_19qrsr$(this, StyledComponent$flexDirection_metadata, flexDirection);
  }});
  var StyledComponent$flexWrap_metadata = new PropertyMetadata('flexWrap');
  Object.defineProperty(StyledComponent.prototype, 'flexWrap', {configurable: true, get: function () {
    return this.flexWrap_gtlwuf$_0.getValue_fmbzy8$(this, StyledComponent$flexWrap_metadata);
  }, set: function (flexWrap) {
    this.flexWrap_gtlwuf$_0.setValue_19qrsr$(this, StyledComponent$flexWrap_metadata, flexWrap);
  }});
  var StyledComponent$justifyItems_metadata = new PropertyMetadata('justifyItems');
  Object.defineProperty(StyledComponent.prototype, 'justifyItems', {configurable: true, get: function () {
    return this.justifyItems_aujwue$_0.getValue_fmbzy8$(this, StyledComponent$justifyItems_metadata);
  }, set: function (justifyItems) {
    this.justifyItems_aujwue$_0.setValue_19qrsr$(this, StyledComponent$justifyItems_metadata, justifyItems);
  }});
  var StyledComponent$justifyContent_metadata = new PropertyMetadata('justifyContent');
  Object.defineProperty(StyledComponent.prototype, 'justifyContent', {configurable: true, get: function () {
    return this.justifyContent_cxcf4v$_0.getValue_fmbzy8$(this, StyledComponent$justifyContent_metadata);
  }, set: function (justifyContent) {
    this.justifyContent_cxcf4v$_0.setValue_19qrsr$(this, StyledComponent$justifyContent_metadata, justifyContent);
  }});
  var StyledComponent$alignItems_metadata = new PropertyMetadata('alignItems');
  Object.defineProperty(StyledComponent.prototype, 'alignItems', {configurable: true, get: function () {
    return this.alignItems_t3q0y9$_0.getValue_fmbzy8$(this, StyledComponent$alignItems_metadata);
  }, set: function (alignItems) {
    this.alignItems_t3q0y9$_0.setValue_19qrsr$(this, StyledComponent$alignItems_metadata, alignItems);
  }});
  var StyledComponent$alignContent_metadata = new PropertyMetadata('alignContent');
  Object.defineProperty(StyledComponent.prototype, 'alignContent', {configurable: true, get: function () {
    return this.alignContent_b2qiay$_0.getValue_fmbzy8$(this, StyledComponent$alignContent_metadata);
  }, set: function (alignContent) {
    this.alignContent_b2qiay$_0.setValue_19qrsr$(this, StyledComponent$alignContent_metadata, alignContent);
  }});
  var StyledComponent$order_metadata = new PropertyMetadata('order');
  Object.defineProperty(StyledComponent.prototype, 'order', {configurable: true, get: function () {
    return this.order_omppus$_0.getValue_fmbzy8$(this, StyledComponent$order_metadata);
  }, set: function (order) {
    this.order_omppus$_0.setValue_19qrsr$(this, StyledComponent$order_metadata, order);
  }});
  var StyledComponent$flexGrow_metadata = new PropertyMetadata('flexGrow');
  Object.defineProperty(StyledComponent.prototype, 'flexGrow', {configurable: true, get: function () {
    return this.flexGrow_gkthwe$_0.getValue_fmbzy8$(this, StyledComponent$flexGrow_metadata);
  }, set: function (flexGrow) {
    this.flexGrow_gkthwe$_0.setValue_19qrsr$(this, StyledComponent$flexGrow_metadata, flexGrow);
  }});
  var StyledComponent$flexShrink_metadata = new PropertyMetadata('flexShrink');
  Object.defineProperty(StyledComponent.prototype, 'flexShrink', {configurable: true, get: function () {
    return this.flexShrink_kteuxk$_0.getValue_fmbzy8$(this, StyledComponent$flexShrink_metadata);
  }, set: function (flexShrink) {
    this.flexShrink_kteuxk$_0.setValue_19qrsr$(this, StyledComponent$flexShrink_metadata, flexShrink);
  }});
  var StyledComponent$flexBasis_metadata = new PropertyMetadata('flexBasis');
  Object.defineProperty(StyledComponent.prototype, 'flexBasis', {configurable: true, get: function () {
    return this.flexBasis_e33pz9$_0.getValue_fmbzy8$(this, StyledComponent$flexBasis_metadata);
  }, set: function (flexBasis) {
    this.flexBasis_e33pz9$_0.setValue_19qrsr$(this, StyledComponent$flexBasis_metadata, flexBasis);
  }});
  var StyledComponent$alignSelf_metadata = new PropertyMetadata('alignSelf');
  Object.defineProperty(StyledComponent.prototype, 'alignSelf', {configurable: true, get: function () {
    return this.alignSelf_c8zyhz$_0.getValue_fmbzy8$(this, StyledComponent$alignSelf_metadata);
  }, set: function (alignSelf) {
    this.alignSelf_c8zyhz$_0.setValue_19qrsr$(this, StyledComponent$alignSelf_metadata, alignSelf);
  }});
  var StyledComponent$justifySelf_metadata = new PropertyMetadata('justifySelf');
  Object.defineProperty(StyledComponent.prototype, 'justifySelf', {configurable: true, get: function () {
    return this.justifySelf_9db8r6$_0.getValue_fmbzy8$(this, StyledComponent$justifySelf_metadata);
  }, set: function (justifySelf) {
    this.justifySelf_9db8r6$_0.setValue_19qrsr$(this, StyledComponent$justifySelf_metadata, justifySelf);
  }});
  var StyledComponent$gridAutoColumns_metadata = new PropertyMetadata('gridAutoColumns');
  Object.defineProperty(StyledComponent.prototype, 'gridAutoColumns', {configurable: true, get: function () {
    return this.gridAutoColumns_xba5ia$_0.getValue_fmbzy8$(this, StyledComponent$gridAutoColumns_metadata);
  }, set: function (gridAutoColumns) {
    this.gridAutoColumns_xba5ia$_0.setValue_19qrsr$(this, StyledComponent$gridAutoColumns_metadata, gridAutoColumns);
  }});
  var StyledComponent$gridAutoRows_metadata = new PropertyMetadata('gridAutoRows');
  Object.defineProperty(StyledComponent.prototype, 'gridAutoRows', {configurable: true, get: function () {
    return this.gridAutoRows_rirek$_0.getValue_fmbzy8$(this, StyledComponent$gridAutoRows_metadata);
  }, set: function (gridAutoRows) {
    this.gridAutoRows_rirek$_0.setValue_19qrsr$(this, StyledComponent$gridAutoRows_metadata, gridAutoRows);
  }});
  var StyledComponent$gridAutoFlow_metadata = new PropertyMetadata('gridAutoFlow');
  Object.defineProperty(StyledComponent.prototype, 'gridAutoFlow', {configurable: true, get: function () {
    return this.gridAutoFlow_kv5hj$_0.getValue_fmbzy8$(this, StyledComponent$gridAutoFlow_metadata);
  }, set: function (gridAutoFlow) {
    this.gridAutoFlow_kv5hj$_0.setValue_19qrsr$(this, StyledComponent$gridAutoFlow_metadata, gridAutoFlow);
  }});
  var StyledComponent$gridTemplateColumns_metadata = new PropertyMetadata('gridTemplateColumns');
  Object.defineProperty(StyledComponent.prototype, 'gridTemplateColumns', {configurable: true, get: function () {
    return this.gridTemplateColumns_vo4ai5$_0.getValue_fmbzy8$(this, StyledComponent$gridTemplateColumns_metadata);
  }, set: function (gridTemplateColumns) {
    this.gridTemplateColumns_vo4ai5$_0.setValue_19qrsr$(this, StyledComponent$gridTemplateColumns_metadata, gridTemplateColumns);
  }});
  var StyledComponent$gridTemplateRows_metadata = new PropertyMetadata('gridTemplateRows');
  Object.defineProperty(StyledComponent.prototype, 'gridTemplateRows', {configurable: true, get: function () {
    return this.gridTemplateRows_ho38ep$_0.getValue_fmbzy8$(this, StyledComponent$gridTemplateRows_metadata);
  }, set: function (gridTemplateRows) {
    this.gridTemplateRows_ho38ep$_0.setValue_19qrsr$(this, StyledComponent$gridTemplateRows_metadata, gridTemplateRows);
  }});
  var StyledComponent$gridTemplateAreas_metadata = new PropertyMetadata('gridTemplateAreas');
  Object.defineProperty(StyledComponent.prototype, 'gridTemplateAreas', {configurable: true, get: function () {
    return this.gridTemplateAreas_sik7rw$_0.getValue_fmbzy8$(this, StyledComponent$gridTemplateAreas_metadata);
  }, set: function (gridTemplateAreas) {
    this.gridTemplateAreas_sik7rw$_0.setValue_19qrsr$(this, StyledComponent$gridTemplateAreas_metadata, gridTemplateAreas);
  }});
  var StyledComponent$gridColumnGap_metadata = new PropertyMetadata('gridColumnGap');
  Object.defineProperty(StyledComponent.prototype, 'gridColumnGap', {configurable: true, get: function () {
    return this.gridColumnGap_493brk$_0.getValue_fmbzy8$(this, StyledComponent$gridColumnGap_metadata);
  }, set: function (gridColumnGap) {
    this.gridColumnGap_493brk$_0.setValue_19qrsr$(this, StyledComponent$gridColumnGap_metadata, gridColumnGap);
  }});
  var StyledComponent$gridRowGap_metadata = new PropertyMetadata('gridRowGap');
  Object.defineProperty(StyledComponent.prototype, 'gridRowGap', {configurable: true, get: function () {
    return this.gridRowGap_3z3jk8$_0.getValue_fmbzy8$(this, StyledComponent$gridRowGap_metadata);
  }, set: function (gridRowGap) {
    this.gridRowGap_3z3jk8$_0.setValue_19qrsr$(this, StyledComponent$gridRowGap_metadata, gridRowGap);
  }});
  var StyledComponent$gridColumnStart_metadata = new PropertyMetadata('gridColumnStart');
  Object.defineProperty(StyledComponent.prototype, 'gridColumnStart', {configurable: true, get: function () {
    return this.gridColumnStart_vzmqfw$_0.getValue_fmbzy8$(this, StyledComponent$gridColumnStart_metadata);
  }, set: function (gridColumnStart) {
    this.gridColumnStart_vzmqfw$_0.setValue_19qrsr$(this, StyledComponent$gridColumnStart_metadata, gridColumnStart);
  }});
  var StyledComponent$gridRowStart_metadata = new PropertyMetadata('gridRowStart');
  Object.defineProperty(StyledComponent.prototype, 'gridRowStart', {configurable: true, get: function () {
    return this.gridRowStart_9rqkas$_0.getValue_fmbzy8$(this, StyledComponent$gridRowStart_metadata);
  }, set: function (gridRowStart) {
    this.gridRowStart_9rqkas$_0.setValue_19qrsr$(this, StyledComponent$gridRowStart_metadata, gridRowStart);
  }});
  var StyledComponent$gridColumnEnd_metadata = new PropertyMetadata('gridColumnEnd');
  Object.defineProperty(StyledComponent.prototype, 'gridColumnEnd', {configurable: true, get: function () {
    return this.gridColumnEnd_494cdx$_0.getValue_fmbzy8$(this, StyledComponent$gridColumnEnd_metadata);
  }, set: function (gridColumnEnd) {
    this.gridColumnEnd_494cdx$_0.setValue_19qrsr$(this, StyledComponent$gridColumnEnd_metadata, gridColumnEnd);
  }});
  var StyledComponent$gridRowEnd_metadata = new PropertyMetadata('gridRowEnd');
  Object.defineProperty(StyledComponent.prototype, 'gridRowEnd', {configurable: true, get: function () {
    return this.gridRowEnd_3z2ixv$_0.getValue_fmbzy8$(this, StyledComponent$gridRowEnd_metadata);
  }, set: function (gridRowEnd) {
    this.gridRowEnd_3z2ixv$_0.setValue_19qrsr$(this, StyledComponent$gridRowEnd_metadata, gridRowEnd);
  }});
  var StyledComponent$gridArea_metadata = new PropertyMetadata('gridArea');
  Object.defineProperty(StyledComponent.prototype, 'gridArea', {configurable: true, get: function () {
    return this.gridArea_4bi4y1$_0.getValue_fmbzy8$(this, StyledComponent$gridArea_metadata);
  }, set: function (gridArea) {
    this.gridArea_4bi4y1$_0.setValue_19qrsr$(this, StyledComponent$gridArea_metadata, gridArea);
  }});
  StyledComponent.prototype.refresh = function () {
    this.snStyleCache_4me8oy$_0 = null;
    return this;
  };
  StyledComponent.prototype.getSnStyleInternal_8be2vx$ = function () {
    var tmp$;
    var tmp$_0;
    if ((tmp$ = this.snStyleCache_4me8oy$_0) != null)
      tmp$_0 = tmp$;
    else {
      var s = this.getSnStyle();
      this.snStyleCache_4me8oy$_0 = s;
      tmp$_0 = s;
    }
    return tmp$_0;
  };
  StyledComponent.prototype.getSnStyle = function () {
    var tmp$;
    var cacheKey = this.getCacheKey();
    var tmp$_0;
    if ((tmp$ = StyledComponent$Companion_getInstance().globalStyleCache_8be2vx$.get_11rb$(cacheKey)) != null)
      tmp$_0 = tmp$;
    else {
      var tmp$_1, tmp$_2, tmp$_3, tmp$_4, tmp$_5, tmp$_6, tmp$_7, tmp$_8, tmp$_9, tmp$_10, tmp$_11, tmp$_12, tmp$_13, tmp$_14, tmp$_15, tmp$_16, tmp$_17, tmp$_18, tmp$_19, tmp$_20, tmp$_21, tmp$_22, tmp$_23, tmp$_24, tmp$_25, tmp$_26, tmp$_27, tmp$_28, tmp$_29, tmp$_30, tmp$_31, tmp$_32, tmp$_33, tmp$_34, tmp$_35, tmp$_36, tmp$_37, tmp$_38, tmp$_39, tmp$_40, tmp$_41, tmp$_42, tmp$_43, tmp$_44, tmp$_45, tmp$_46, tmp$_47, tmp$_48, tmp$_49, tmp$_50, tmp$_51, tmp$_52, tmp$_53, tmp$_54, tmp$_55, tmp$_56, tmp$_57, tmp$_58, tmp$_59, tmp$_60, tmp$_61, tmp$_62, tmp$_63, tmp$_64, tmp$_65, tmp$_66, tmp$_67, tmp$_68, tmp$_69, tmp$_70, tmp$_71, tmp$_72, tmp$_73, tmp$_74, tmp$_75, tmp$_76, tmp$_77, tmp$_78, tmp$_79, tmp$_80, tmp$_81, tmp$_82, tmp$_83, tmp$_84;
      var snstyle = ArrayList_init();
      if ((tmp$_1 = this.width) != null) {
        snstyle.add_11rb$(to('width', asString(tmp$_1)));
      }if ((tmp$_2 = this.minWidth) != null) {
        snstyle.add_11rb$(to('min-width', asString(tmp$_2)));
      }if ((tmp$_3 = this.maxWidth) != null) {
        snstyle.add_11rb$(to('max-width', asString(tmp$_3)));
      }if ((tmp$_4 = this.height) != null) {
        snstyle.add_11rb$(to('height', asString(tmp$_4)));
      }if ((tmp$_5 = this.minHeight) != null) {
        snstyle.add_11rb$(to('min-height', asString(tmp$_5)));
      }if ((tmp$_6 = this.maxHeight) != null) {
        snstyle.add_11rb$(to('max-height', asString(tmp$_6)));
      }if ((tmp$_7 = this.display) != null) {
        snstyle.add_11rb$(to('display', tmp$_7.display_8be2vx$));
      }if ((tmp$_8 = this.position) != null) {
        snstyle.add_11rb$(to('position', tmp$_8.position_8be2vx$));
      }if ((tmp$_9 = this.top) != null) {
        snstyle.add_11rb$(to('top', asString(tmp$_9)));
      }if ((tmp$_10 = this.left) != null) {
        snstyle.add_11rb$(to('left', asString(tmp$_10)));
      }if ((tmp$_11 = this.right) != null) {
        snstyle.add_11rb$(to('right', asString(tmp$_11)));
      }if ((tmp$_12 = this.bottom) != null) {
        snstyle.add_11rb$(to('bottom', asString(tmp$_12)));
      }if ((tmp$_13 = this.zIndex) != null) {
        snstyle.add_11rb$(to('z-index', tmp$_13.toString()));
      }if ((tmp$_14 = this.overflow) != null) {
        snstyle.add_11rb$(to('overflow', tmp$_14.overflow_8be2vx$));
      }if ((tmp$_15 = this.overflowWrap) != null) {
        snstyle.add_11rb$(to('overflow-wrap', tmp$_15.overflowWrap_8be2vx$));
      }if ((tmp$_16 = this.resize) != null) {
        snstyle.add_11rb$(to('resize', tmp$_16.resize_8be2vx$));
      }if ((tmp$_17 = this.border) != null) {
        snstyle.add_11rb$(to('border', tmp$_17.asString_8be2vx$()));
      }if ((tmp$_18 = this.borderTop) != null) {
        snstyle.add_11rb$(to('border-top', tmp$_18.asString_8be2vx$()));
      }if ((tmp$_19 = this.borderRight) != null) {
        snstyle.add_11rb$(to('border-right', tmp$_19.asString_8be2vx$()));
      }if ((tmp$_20 = this.borderBottom) != null) {
        snstyle.add_11rb$(to('border-bottom', tmp$_20.asString_8be2vx$()));
      }if ((tmp$_21 = this.borderLeft) != null) {
        snstyle.add_11rb$(to('border-left', tmp$_21.asString_8be2vx$()));
      }if ((tmp$_22 = this.margin) != null) {
        snstyle.add_11rb$(to('margin', asString(tmp$_22)));
      }if ((tmp$_23 = this.marginTop) != null) {
        snstyle.add_11rb$(to('margin-top', asString(tmp$_23)));
      }if ((tmp$_24 = this.marginRight) != null) {
        snstyle.add_11rb$(to('margin-right', asString(tmp$_24)));
      }if ((tmp$_25 = this.marginBottom) != null) {
        snstyle.add_11rb$(to('margin-bottom', asString(tmp$_25)));
      }if ((tmp$_26 = this.marginLeft) != null) {
        snstyle.add_11rb$(to('margin-left', asString(tmp$_26)));
      }if ((tmp$_27 = this.padding) != null) {
        snstyle.add_11rb$(to('padding', asString(tmp$_27)));
      }if ((tmp$_28 = this.paddingTop) != null) {
        snstyle.add_11rb$(to('padding-top', asString(tmp$_28)));
      }if ((tmp$_29 = this.paddingRight) != null) {
        snstyle.add_11rb$(to('padding-right', asString(tmp$_29)));
      }if ((tmp$_30 = this.paddingBottom) != null) {
        snstyle.add_11rb$(to('padding-bottom', asString(tmp$_30)));
      }if ((tmp$_31 = this.paddingLeft) != null) {
        snstyle.add_11rb$(to('padding-left', asString(tmp$_31)));
      }if ((tmp$_32 = this.color) != null) {
        snstyle.add_11rb$(to('color', tmp$_32.asString()));
      }if ((tmp$_33 = this.opacity) != null) {
        snstyle.add_11rb$(to('opacity', tmp$_33.toString()));
      }if ((tmp$_34 = this.background) != null) {
        snstyle.add_11rb$(to('background', tmp$_34.asString_8be2vx$()));
      }if ((tmp$_35 = this.textDirection) != null) {
        snstyle.add_11rb$(to('direction', tmp$_35.direction_8be2vx$));
      }if ((tmp$_36 = this.letterSpacing) != null) {
        snstyle.add_11rb$(to('letter-spacing', asString(tmp$_36)));
      }if ((tmp$_37 = this.lineHeight) != null) {
        snstyle.add_11rb$(to('line-height', asString(tmp$_37)));
      }if ((tmp$_38 = this.textAlign) != null) {
        snstyle.add_11rb$(to('text-align', tmp$_38.textAlign_8be2vx$));
      }if ((tmp$_39 = this.textDecoration) != null) {
        snstyle.add_11rb$(to('text-decoration', tmp$_39.asString_8be2vx$()));
      }if ((tmp$_40 = this.textIndent) != null) {
        snstyle.add_11rb$(to('text-indent', asString(tmp$_40)));
      }if ((tmp$_41 = this.textShadow) != null) {
        snstyle.add_11rb$(to('text-shadow', tmp$_41.asString_8be2vx$()));
      }if ((tmp$_42 = this.textTransform) != null) {
        snstyle.add_11rb$(to('text-transform', tmp$_42.textTransform_8be2vx$));
      }if ((tmp$_43 = this.textOverflow) != null) {
        snstyle.add_11rb$(to('text-overflow', tmp$_43.textOverflow_8be2vx$));
      }if ((tmp$_44 = this.unicodeBidi) != null) {
        snstyle.add_11rb$(to('unicode-bidi', tmp$_44.unicodeBidi_8be2vx$));
      }if ((tmp$_45 = this.verticalAlign) != null) {
        snstyle.add_11rb$(to('vertical-align', tmp$_45.verticalAlign_8be2vx$));
      }if ((tmp$_46 = this.whiteSpace) != null) {
        snstyle.add_11rb$(to('white-space', tmp$_46.whiteSpace_8be2vx$));
      }if ((tmp$_47 = this.wordSpacing) != null) {
        snstyle.add_11rb$(to('word-spacing', asString(tmp$_47)));
      }if ((tmp$_48 = this.fontFamily) != null) {
        snstyle.add_11rb$(to('font-family', tmp$_48));
      }if ((tmp$_49 = this.fontSize) != null) {
        snstyle.add_11rb$(to('font-size', asString(tmp$_49)));
      }if ((tmp$_50 = this.fontStyle) != null) {
        snstyle.add_11rb$(to('font-style', tmp$_50.fontStyle_8be2vx$));
      }if ((tmp$_51 = this.fontWeight) != null) {
        snstyle.add_11rb$(to('font-weight', tmp$_51.fontWeight_8be2vx$));
      }if ((tmp$_52 = this.fontVariant) != null) {
        snstyle.add_11rb$(to('font-variant', tmp$_52.fontVariant_8be2vx$));
      }if ((tmp$_53 = this.float) != null) {
        snstyle.add_11rb$(to('float', tmp$_53.posFloat_8be2vx$));
      }if ((tmp$_54 = this.clear) != null) {
        snstyle.add_11rb$(to('clear', tmp$_54.clear_8be2vx$));
      }if ((tmp$_55 = this.wordBreak) != null) {
        snstyle.add_11rb$(to('word-break', tmp$_55.wordBreak_8be2vx$));
      }if ((tmp$_56 = this.lineBreak) != null) {
        snstyle.add_11rb$(to('line-break', tmp$_56.lineBreak_8be2vx$));
      }if ((tmp$_57 = this.cursor) != null) {
        snstyle.add_11rb$(to('cursor', tmp$_57.cursor_8be2vx$));
      }if ((tmp$_58 = this.flexDirection) != null) {
        snstyle.add_11rb$(to('flex-direction', tmp$_58.dir_8be2vx$));
      }if ((tmp$_59 = this.flexWrap) != null) {
        snstyle.add_11rb$(to('flex-wrap', tmp$_59.wrap_8be2vx$));
      }if ((tmp$_60 = this.justifyItems) != null) {
        snstyle.add_11rb$(to('justify-items', tmp$_60.justify_8be2vx$));
      }if ((tmp$_61 = this.justifyContent) != null) {
        snstyle.add_11rb$(to('justify-content', tmp$_61.justifyContent_8be2vx$));
      }if ((tmp$_62 = this.alignItems) != null) {
        snstyle.add_11rb$(to('align-items', tmp$_62.alignItems_8be2vx$));
      }if ((tmp$_63 = this.alignContent) != null) {
        snstyle.add_11rb$(to('align-content', tmp$_63.alignContent_8be2vx$));
      }if ((tmp$_64 = this.order) != null) {
        snstyle.add_11rb$(to('order', tmp$_64.toString()));
      }if ((tmp$_65 = this.flexGrow) != null) {
        snstyle.add_11rb$(to('flex-grow', tmp$_65.toString()));
      }if ((tmp$_66 = this.flexShrink) != null) {
        snstyle.add_11rb$(to('flex-shrink', tmp$_66.toString()));
      }if ((tmp$_67 = this.flexBasis) != null) {
        snstyle.add_11rb$(to('flex-basis', asString(tmp$_67)));
      }if ((tmp$_68 = this.alignSelf) != null) {
        snstyle.add_11rb$(to('align-self', tmp$_68.alignItems_8be2vx$));
      }if ((tmp$_69 = this.justifySelf) != null) {
        snstyle.add_11rb$(to('justify-self', tmp$_69.justify_8be2vx$));
      }if ((tmp$_70 = this.gridAutoColumns) != null) {
        snstyle.add_11rb$(to('grid-auto-columns', tmp$_70));
      }if ((tmp$_71 = this.gridAutoRows) != null) {
        snstyle.add_11rb$(to('grid-auto-rows', tmp$_71));
      }if ((tmp$_72 = this.gridAutoFlow) != null) {
        snstyle.add_11rb$(to('grid-auto-flow', tmp$_72.flow_8be2vx$));
      }if ((tmp$_73 = this.gridTemplateColumns) != null) {
        snstyle.add_11rb$(to('grid-template-columns', tmp$_73));
      }if ((tmp$_74 = this.gridTemplateRows) != null) {
        snstyle.add_11rb$(to('grid-template-rows', tmp$_74));
      }if ((tmp$_75 = this.gridTemplateAreas) != null) {
        snstyle.add_11rb$(to('grid-template-areas', joinToString(tmp$_75, '\n')));
      }if ((tmp$_76 = this.gridColumnGap) != null) {
        snstyle.add_11rb$(to('grid-column-gap', tmp$_76.toString() + 'px'));
      }if ((tmp$_77 = this.gridRowGap) != null) {
        snstyle.add_11rb$(to('grid-row-gap', tmp$_77.toString() + 'px'));
      }if ((tmp$_78 = this.gridColumnStart) != null) {
        snstyle.add_11rb$(to('grid-column-start', tmp$_78.toString()));
      }if ((tmp$_79 = this.gridRowStart) != null) {
        snstyle.add_11rb$(to('grid-row-start', tmp$_79.toString()));
      }if ((tmp$_80 = this.gridColumnEnd) != null) {
        snstyle.add_11rb$(to('grid-column-end', tmp$_80));
      }if ((tmp$_81 = this.gridRowEnd) != null) {
        snstyle.add_11rb$(to('grid-row-end', tmp$_81));
      }if ((tmp$_82 = this.gridArea) != null) {
        snstyle.add_11rb$(to('grid-area', tmp$_82));
      }tmp$_83 = Object.keys(this.customStyles_5fgek7$_0);
      for (tmp$_84 = 0; tmp$_84 !== tmp$_83.length; ++tmp$_84) {
        var key = tmp$_83[tmp$_84];
        snstyle.add_11rb$(new Pair(key, this.customStyles_5fgek7$_0[key]));
      }
      StyledComponent$Companion_getInstance().globalStyleCache_8be2vx$.set_xwzc9p$(cacheKey, snstyle);
      return snstyle;
    }
    return tmp$_0;
  };
  StyledComponent.prototype.getStyle_61zpoe$ = function (name) {
    return this.customStyles_5fgek7$_0[name];
  };
  StyledComponent.prototype.setStyle_puj7f4$ = function (name, value) {
    this.customStyles_5fgek7$_0[name] = value;
    this.refresh();
    return this;
  };
  StyledComponent.prototype.removeStyle_61zpoe$ = function (name) {
    delete_0(this.customStyles_5fgek7$_0, name);
    this.refresh();
    return this;
  };
  StyledComponent.prototype.getCacheKey = function () {
    return JSON.stringify(this.propertyValues_mhxfgz$_0) + JSON.stringify(this.customStyles_5fgek7$_0);
  };
  StyledComponent.prototype.refreshOnUpdate_s6iq0o$_0 = wrapFunction(function () {
    function StyledComponent$refreshOnUpdate$lambda(this$StyledComponent) {
      return function (it) {
        this$StyledComponent.refresh();
        return Unit;
      };
    }
    return function (refreshFunction) {
      if (refreshFunction === void 0)
        refreshFunction = StyledComponent$refreshOnUpdate$lambda(this);
      return new StyledComponent$RefreshDelegateProvider(this, null, refreshFunction);
    };
  });
  StyledComponent.prototype.refreshOnUpdate_38y3ci$_0 = wrapFunction(function () {
    function StyledComponent$refreshOnUpdate$lambda(this$StyledComponent) {
      return function (it) {
        this$StyledComponent.refresh();
        return Unit;
      };
    }
    return function (initialValue, refreshFunction) {
      if (refreshFunction === void 0)
        refreshFunction = StyledComponent$refreshOnUpdate$lambda(this);
      return new StyledComponent$RefreshDelegateProvider(this, initialValue, refreshFunction);
    };
  });
  function StyledComponent$RefreshDelegateProvider($outer, initialValue, refreshFunction) {
    this.$outer = $outer;
    this.initialValue_0 = initialValue;
    this.refreshFunction_0 = refreshFunction;
  }
  StyledComponent$RefreshDelegateProvider.prototype.provideDelegate_n5byny$ = function (thisRef, prop) {
    if (this.initialValue_0 != null)
      this.$outer.propertyValues_mhxfgz$_0[prop.callableName] = this.initialValue_0;
    return new StyledComponent$RefreshDelegate(this.$outer, this.refreshFunction_0);
  };
  StyledComponent$RefreshDelegateProvider.$metadata$ = {kind: Kind_CLASS, simpleName: 'RefreshDelegateProvider', interfaces: []};
  function StyledComponent$RefreshDelegate($outer, refreshFunction) {
    this.$outer = $outer;
    this.refreshFunction_0 = refreshFunction;
  }
  StyledComponent$RefreshDelegate.prototype.getValue_fmbzy8$ = function (thisRef, property) {
    var tmp$;
    var value = this.$outer.propertyValues_mhxfgz$_0[property.callableName];
    if (value != null) {
      tmp$ = value;
    } else {
      tmp$ = null;
    }
    return tmp$;
  };
  StyledComponent$RefreshDelegate.prototype.setValue_19qrsr$ = function (thisRef, property, value) {
    this.$outer.propertyValues_mhxfgz$_0[property.callableName] = value;
    this.refreshFunction_0(value);
  };
  StyledComponent$RefreshDelegate.$metadata$ = {kind: Kind_CLASS, simpleName: 'RefreshDelegate', interfaces: []};
  function StyledComponent$Companion() {
    StyledComponent$Companion_instance = this;
    this.globalStyleCache_8be2vx$ = new Cache();
  }
  StyledComponent$Companion.$metadata$ = {kind: Kind_OBJECT, simpleName: 'Companion', interfaces: []};
  var StyledComponent$Companion_instance = null;
  function StyledComponent$Companion_getInstance() {
    if (StyledComponent$Companion_instance === null) {
      new StyledComponent$Companion();
    }return StyledComponent$Companion_instance;
  }
  StyledComponent.$metadata$ = {kind: Kind_CLASS, simpleName: 'StyledComponent', interfaces: []};
  function Widget$refreshOnUpdate$lambda(this$Widget) {
    return function (it) {
      this$Widget.refresh();
      return Unit;
    };
  }
  function Widget$refreshOnUpdate$lambda_0(this$Widget) {
    return function (it) {
      this$Widget.refresh();
      return Unit;
    };
  }
  function Easing(name, ordinal, easing) {
    Enum.call(this);
    this.easing_8be2vx$ = easing;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function Easing_initFields() {
    Easing_initFields = function () {
    };
    Easing$SWING_instance = new Easing('SWING', 0, 'swing');
    Easing$LINEAR_instance = new Easing('LINEAR', 1, 'linear');
  }
  var Easing$SWING_instance;
  function Easing$SWING_getInstance() {
    Easing_initFields();
    return Easing$SWING_instance;
  }
  var Easing$LINEAR_instance;
  function Easing$LINEAR_getInstance() {
    Easing_initFields();
    return Easing$LINEAR_instance;
  }
  Easing.$metadata$ = {kind: Kind_CLASS, simpleName: 'Easing', interfaces: [Enum]};
  function Easing$values() {
    return [Easing$SWING_getInstance(), Easing$LINEAR_getInstance()];
  }
  Easing.values = Easing$values;
  function Easing$valueOf(name) {
    switch (name) {
      case 'SWING':
        return Easing$SWING_getInstance();
      case 'LINEAR':
        return Easing$LINEAR_getInstance();
      default:throwISE('No enum constant io.kvision.core.Easing.' + name);
    }
  }
  Easing.valueOf_61zpoe$ = Easing$valueOf;
  function Widget(intClasses, init) {
    Widget$Companion_getInstance();
    if (intClasses === void 0)
      intClasses = null;
    if (init === void 0)
      init = null;
    StyledComponent.call(this);
    this.intClasses_8be2vx$ = intClasses;
    this.propertyValues_v9485h$_0 = {};
    this.classes_8be2vx$ = null;
    this.surroundingClasses_8be2vx$ = null;
    this.attributes_8be2vx$ = null;
    this.internalListenersMap_8be2vx$ = null;
    this.listenersMap_8be2vx$ = null;
    this.listenerCounter_8be2vx$ = 0;
    this.parent_a7yca6$_0 = null;
    this.visible_pymgje$_0 = true;
    this.title_d56peo$_0 = (new Widget$RefreshDelegateProvider(this, null, Widget$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, Widget$title_metadata);
    this.id_w1ms5d$_0 = (new Widget$RefreshDelegateProvider(this, null, Widget$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, Widget$id_metadata);
    this.role_vok4fu$_0 = (new Widget$RefreshDelegateProvider(this, null, Widget$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, Widget$role_metadata);
    this.tabindex_hfhf29$_0 = (new Widget$RefreshDelegateProvider(this, null, Widget$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, Widget$tabindex_metadata);
    this.draggable_7fc13f$_0 = (new Widget$RefreshDelegateProvider(this, null, Widget$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, Widget$draggable_metadata);
    this.surroundingSpan_pj1ppm$_0 = (new Widget$RefreshDelegateProvider(this, false, Widget$refreshOnUpdate$lambda_0(this))).provideDelegate_n5byny$(this, Widget$surroundingSpan_metadata);
    this.tooltipSiblings_m26fto$_0 = null;
    this.popoverSiblings_yemu4i$_0 = null;
    this.tooltipOptions = null;
    this.popoverOptions = null;
    this.eventTarget = null;
    var tmp$;
    this.vnkey_e5v1kh$_0 = 'kv_widget_' + (tmp$ = Widget$Companion_getInstance().counter_0, Widget$Companion_getInstance().counter_0 = tmp$ + 1 | 0, tmp$);
    this.vnode = null;
    this.snAttrsCache_cfphr3$_0 = (new LazyCache(Widget$snAttrsCache$lambda(this))).clearOn_u332lz$(Widget$snAttrsCache$lambda_0(this));
    this.snClassCache_hcl495$_0 = new LazyCache(Widget$snClassCache$lambda(this));
    this.snOnCache_aaik0$_0 = null;
    this.snHooksCache_rlx0tr$_0 = null;
    this.lastLanguage = null;
    this.afterInsertHooks_dk5ndt$_0 = null;
    this.afterDestroyHooks_9vsnae$_0 = null;
    this.beforeDisposeHooks_qk8awk$_0 = null;
    init != null ? init(this) : null;
  }
  Object.defineProperty(Widget.prototype, 'parent', {configurable: true, get: function () {
    return this.parent_a7yca6$_0;
  }, set: function (parent) {
    this.parent_a7yca6$_0 = parent;
  }});
  Object.defineProperty(Widget.prototype, 'visible', {configurable: true, get: function () {
    return this.visible_pymgje$_0;
  }, set: function (value) {
    var oldField = this.visible_pymgje$_0;
    this.visible_pymgje$_0 = value;
    if (oldField !== this.visible_pymgje$_0)
      this.refresh();
  }});
  var Widget$title_metadata = new PropertyMetadata('title');
  Object.defineProperty(Widget.prototype, 'title', {configurable: true, get: function () {
    return this.title_d56peo$_0.getValue_fmbzy8$(this, Widget$title_metadata);
  }, set: function (title) {
    this.title_d56peo$_0.setValue_19qrsr$(this, Widget$title_metadata, title);
  }});
  var Widget$id_metadata = new PropertyMetadata('id');
  Object.defineProperty(Widget.prototype, 'id', {configurable: true, get: function () {
    return this.id_w1ms5d$_0.getValue_fmbzy8$(this, Widget$id_metadata);
  }, set: function (id) {
    this.id_w1ms5d$_0.setValue_19qrsr$(this, Widget$id_metadata, id);
  }});
  var Widget$role_metadata = new PropertyMetadata('role');
  Object.defineProperty(Widget.prototype, 'role', {configurable: true, get: function () {
    return this.role_vok4fu$_0.getValue_fmbzy8$(this, Widget$role_metadata);
  }, set: function (role) {
    this.role_vok4fu$_0.setValue_19qrsr$(this, Widget$role_metadata, role);
  }});
  var Widget$tabindex_metadata = new PropertyMetadata('tabindex');
  Object.defineProperty(Widget.prototype, 'tabindex', {configurable: true, get: function () {
    return this.tabindex_hfhf29$_0.getValue_fmbzy8$(this, Widget$tabindex_metadata);
  }, set: function (tabindex) {
    this.tabindex_hfhf29$_0.setValue_19qrsr$(this, Widget$tabindex_metadata, tabindex);
  }});
  var Widget$draggable_metadata = new PropertyMetadata('draggable');
  Object.defineProperty(Widget.prototype, 'draggable', {configurable: true, get: function () {
    return this.draggable_7fc13f$_0.getValue_fmbzy8$(this, Widget$draggable_metadata);
  }, set: function (draggable) {
    this.draggable_7fc13f$_0.setValue_19qrsr$(this, Widget$draggable_metadata, draggable);
  }});
  var Widget$surroundingSpan_metadata = new PropertyMetadata('surroundingSpan');
  Object.defineProperty(Widget.prototype, 'surroundingSpan', {configurable: true, get: function () {
    return this.surroundingSpan_pj1ppm$_0.getValue_fmbzy8$(this, Widget$surroundingSpan_metadata);
  }, set: function (surroundingSpan) {
    this.surroundingSpan_pj1ppm$_0.setValue_19qrsr$(this, Widget$surroundingSpan_metadata, surroundingSpan);
  }});
  Widget.prototype.addBeforeDisposeHook_o14v8n$ = function (hook) {
    var tmp$;
    var tmp$_0;
    if ((tmp$ = this.beforeDisposeHooks_qk8awk$_0) != null)
      tmp$_0 = tmp$;
    else {
      this.beforeDisposeHooks_qk8awk$_0 = ArrayList_init();
      tmp$_0 = ensureNotNull(this.beforeDisposeHooks_qk8awk$_0);
    }
    return tmp$_0.add_11rb$(hook);
  };
  Widget.prototype.addAfterDestroyHook_o14v8n$ = function (hook) {
    var tmp$;
    var tmp$_0;
    if ((tmp$ = this.afterDestroyHooks_9vsnae$_0) != null)
      tmp$_0 = tmp$;
    else {
      this.afterDestroyHooks_9vsnae$_0 = ArrayList_init();
      tmp$_0 = ensureNotNull(this.afterDestroyHooks_9vsnae$_0);
    }
    return tmp$_0.add_11rb$(hook);
  };
  Widget.prototype.addAfterInsertHook_gg6t83$ = function (hook) {
    var tmp$;
    var tmp$_0;
    if ((tmp$ = this.afterInsertHooks_dk5ndt$_0) != null)
      tmp$_0 = tmp$;
    else {
      this.afterInsertHooks_dk5ndt$_0 = ArrayList_init();
      tmp$_0 = ensureNotNull(this.afterInsertHooks_dk5ndt$_0);
    }
    return tmp$_0.add_11rb$(hook);
  };
  Widget.prototype.singleRender_klfg04$ = function (block) {
    var tmp$, tmp$_0, tmp$_1;
    (tmp$ = this.getRoot()) != null ? (tmp$.renderDisabled_8be2vx$ = true) : null;
    var t = block();
    (tmp$_0 = this.getRoot()) != null ? (tmp$_0.renderDisabled_8be2vx$ = false) : null;
    (tmp$_1 = this.getRoot()) != null ? tmp$_1.reRender_8be2vx$() : null;
    return t;
  };
  function Widget$renderVNode$lambda(this$Widget) {
    return function ($receiver) {
      var $receiver_0 = ensureNotNull(this$Widget.surroundingClasses_8be2vx$);
      var destination = ArrayList_init_0(collectionSizeOrDefault($receiver_0, 10));
      var tmp$;
      tmp$ = $receiver_0.iterator();
      while (tmp$.hasNext()) {
        var item = tmp$.next();
        destination.add_11rb$(to(item, true));
      }
      var $receiver_1 = new Object_init();
      var tmp$_0;
      tmp$_0 = destination.iterator();
      while (tmp$_0.hasNext()) {
        var element = tmp$_0.next();
        var key = element.component1(), value = element.component2();
        $receiver_1[key] = value;
      }
      $receiver.class = $receiver_1;
      return Unit;
    };
  }
  Widget.prototype.renderVNode = function () {
    var tmp$;
    if (this.surroundingClasses_8be2vx$ == null) {
      if (this.surroundingSpan) {
        tmp$ = h('span', [this.render()]);
      } else {
        tmp$ = this.render();
      }
    } else {
      var opt = getCallableRef('apply', function ($receiver_0, p1_0) {
        p1_0($receiver_0);
        return $receiver_0;
      }.bind(null, {}))(Widget$renderVNode$lambda(this));
      if (this.surroundingSpan) {
        tmp$ = h('div', opt, [h('span', [this.render()])]);
      } else {
        tmp$ = h('div', opt, [this.render()]);
      }
    }
    return tmp$;
  };
  Widget.prototype.translate_61zpoe$ = function (text) {
    this.lastLanguage = I18n_getInstance().language;
    return I18n_getInstance().trans_61zpoe$(text);
  };
  Widget.prototype.translate_pdl1vj$ = function (text) {
    return text != null ? this.translate_61zpoe$(text) : null;
  };
  Widget.prototype.render = function () {
    return this.render_61zpoe$('div');
  };
  Widget.prototype.render_61zpoe$ = function (elementName) {
    return h(elementName, this.getSnOpt_tx4gd6$_0());
  };
  Widget.prototype.render_pjwf99$ = function (elementName, children) {
    return h(elementName, this.getSnOpt_tx4gd6$_0(), children);
  };
  function Widget$getSnOpt$lambda(this$Widget) {
    return function ($receiver) {
      $receiver.key = this$Widget.vnkey_e5v1kh$_0;
      $receiver.attrs = this$Widget.snAttrsCache_cfphr3$_0.value;
      var pairs = this$Widget.getSnStyleInternal_8be2vx$();
      var $receiver_0 = new Object_init();
      var tmp$;
      tmp$ = pairs.iterator();
      while (tmp$.hasNext()) {
        var element = tmp$.next();
        var key = element.component1(), value = element.component2();
        $receiver_0[key] = value;
      }
      $receiver.style = $receiver_0;
      $receiver.class = this$Widget.snClassCache_hcl495$_0.value;
      $receiver.on = this$Widget.getSnOn();
      $receiver.hook = this$Widget.getSnHooksInternal_766wlc$_0();
      return Unit;
    };
  }
  Widget.prototype.getSnOpt_tx4gd6$_0 = function () {
    return getCallableRef('apply', function ($receiver_0, p1_0) {
      p1_0($receiver_0);
      return $receiver_0;
    }.bind(null, {}))(Widget$getSnOpt$lambda(this));
  };
  Widget.prototype.getSnHooksInternal_766wlc$_0 = function () {
    var tmp$;
    var tmp$_0;
    if ((tmp$ = this.snHooksCache_rlx0tr$_0) != null)
      tmp$_0 = tmp$;
    else {
      var $receiver = this.getSnHooks();
      this.snHooksCache_rlx0tr$_0 = $receiver;
      tmp$_0 = $receiver;
    }
    return tmp$_0;
  };
  Widget.prototype.buildClassSet_xutoed$ = function (classSetBuilder) {
    if (this.classes_8be2vx$ == null && this.intClasses_8be2vx$ != null) {
      classSetBuilder.addAll_jfy1ql$(this.intClasses_8be2vx$);
    } else if (this.classes_8be2vx$ != null) {
      classSetBuilder.addAll_jfy1ql$(ensureNotNull(this.classes_8be2vx$));
    }if (!this.visible) {
      classSetBuilder.add_61zpoe$('hidden');
    }};
  Widget.prototype.buildAttributeSet_34lhpl$ = function (attributeSetBuilder) {
    var tmp$, tmp$_0, tmp$_1, tmp$_2;
    if (this.attributes_8be2vx$ == null) {
      this.attributes_8be2vx$ = LinkedHashMap_init();
    }attributeSetBuilder.addAll_y0zsll$(ensureNotNull(this.attributes_8be2vx$));
    if ((tmp$ = this.id) != null) {
      attributeSetBuilder.add_puj7f4$('id', tmp$);
    }if ((tmp$_0 = this.title) != null) {
      attributeSetBuilder.add_puj7f4$('title', this.translate_61zpoe$(tmp$_0));
    }if ((tmp$_1 = this.role) != null) {
      attributeSetBuilder.add_puj7f4$('role', tmp$_1);
    }if ((tmp$_2 = this.tabindex) != null) {
      attributeSetBuilder.add_puj7f4$('tabindex', tmp$_2.toString());
    }if (this.draggable === true) {
      attributeSetBuilder.add_puj7f4$('draggable', 'true');
    }};
  Widget.prototype.getSnOn = function () {
    var tmp$, tmp$_0, tmp$_1, tmp$_2, tmp$_3, tmp$_4, tmp$_5, tmp$_6;
    if (this.internalListenersMap_8be2vx$ == null && this.listenersMap_8be2vx$ == null)
      return null;
    var tmp$_7;
    if ((tmp$ = this.internalListenersMap_8be2vx$) != null) {
      var destination = LinkedHashMap_init();
      var tmp$_8;
      tmp$_8 = tmp$.entries.iterator();
      while (tmp$_8.hasNext()) {
        var element = tmp$_8.next();
        var tmp$_9 = !equals(element.key, 'self');
        if (tmp$_9) {
          tmp$_9 = !element.value.isEmpty();
        }if (tmp$_9) {
          destination.put_xwzc9p$(element.key, element.value);
        }}
      tmp$_7 = destination;
    } else
      tmp$_7 = null;
    var tmp$_10;
    if ((tmp$_0 = tmp$_7) != null) {
      var destination_0 = ArrayList_init_0(tmp$_0.size);
      var tmp$_11;
      tmp$_11 = tmp$_0.entries.iterator();
      while (tmp$_11.hasNext()) {
        var item = tmp$_11.next();
        var tmp$_12 = destination_0.add_11rb$;
        var internalListeners = LinkedHashMap_init();
        internalListeners.putAll_a2k3zr$(item.value);
        tmp$_12.call(destination_0, to(item.key, internalListeners));
      }
      tmp$_10 = destination_0;
    } else
      tmp$_10 = null;
    var map = (tmp$_3 = (tmp$_2 = (tmp$_1 = tmp$_10) != null ? toMap(tmp$_1) : null) != null ? toMutableMap(tmp$_2) : null) != null ? tmp$_3 : LinkedHashMap_init();
    var tmp$_13;
    if ((tmp$_4 = this.listenersMap_8be2vx$) != null) {
      var destination_1 = LinkedHashMap_init();
      var tmp$_14;
      tmp$_14 = tmp$_4.entries.iterator();
      while (tmp$_14.hasNext()) {
        var element_0 = tmp$_14.next();
        var tmp$_15 = !equals(element_0.key, 'self');
        if (tmp$_15) {
          tmp$_15 = !element_0.value.isEmpty();
        }if (tmp$_15) {
          destination_1.put_xwzc9p$(element_0.key, element_0.value);
        }}
      tmp$_13 = destination_1;
    } else
      tmp$_13 = null;
    if ((tmp$_5 = tmp$_13) != null) {
      var tmp$_16;
      tmp$_16 = tmp$_5.entries.iterator();
      while (tmp$_16.hasNext()) {
        var element_1 = tmp$_16.next();
        var event = element_1.key;
        var listeners = element_1.value;
        var internalListeners_0 = map.get_11rb$(event);
        if (internalListeners_0 != null) {
          internalListeners_0.putAll_a2k3zr$(listeners);
        } else {
          map.put_xwzc9p$(event, listeners);
        }
      }
    }if (!map.isEmpty()) {
      var handlers = emptyOn();
      var tmp$_17;
      tmp$_17 = map.entries.iterator();
      while (tmp$_17.hasNext()) {
        var element_2 = tmp$_17.next();
        var event_0 = element_2.key;
        var listeners_0 = element_2.value;
        var tmp$_18;
        if (listeners_0.size === 1) {
          tmp$_18 = first(listeners_0.values);
        } else {
          var destination_2 = ArrayList_init_0(listeners_0.size);
          var tmp$_19;
          tmp$_19 = listeners_0.entries.iterator();
          while (tmp$_19.hasNext()) {
            var item_0 = tmp$_19.next();
            destination_2.add_11rb$([item_0.value]);
          }
          tmp$_18 = copyToArray(destination_2);
        }
        handlers[event_0] = tmp$_18;
      }
      tmp$_6 = handlers;
    } else {
      tmp$_6 = null;
    }
    return tmp$_6;
  };
  function Widget$getSnHooks$lambda$lambda(this$Widget) {
    return function (f, v) {
      this$Widget.vnode = v;
      this$Widget.afterCreate_cmtal8$(v);
      return Unit;
    };
  }
  function Widget$getSnHooks$lambda$lambda_0(this$Widget) {
    return function (v) {
      var tmp$;
      this$Widget.vnode = v;
      this$Widget.afterInsertInternal_cmtal8$(v);
      this$Widget.afterInsert_cmtal8$(v);
      var tmp$_0;
      if ((tmp$ = this$Widget.afterInsertHooks_dk5ndt$_0) != null) {
        var tmp$_1;
        tmp$_1 = tmp$.iterator();
        while (tmp$_1.hasNext()) {
          var element = tmp$_1.next();
          element(v);
        }
        tmp$_0 = Unit;
      } else
        tmp$_0 = null;
      return tmp$_0;
    };
  }
  function Widget$getSnHooks$lambda$lambda_1(this$Widget) {
    return function (it) {
      var tmp$;
      this$Widget.afterDestroyInternal();
      this$Widget.afterDestroy();
      if ((tmp$ = this$Widget.afterDestroyHooks_9vsnae$_0) != null) {
        var tmp$_0;
        tmp$_0 = tmp$.iterator();
        while (tmp$_0.hasNext()) {
          var element = tmp$_0.next();
          element();
        }
      }this$Widget.vnode = null;
      return this$Widget.vnode;
    };
  }
  Widget.prototype.getSnHooks = function () {
    var hooks = {};
    hooks.create = Widget$getSnHooks$lambda$lambda(this);
    hooks.insert = Widget$getSnHooks$lambda$lambda_0(this);
    hooks.destroy = Widget$getSnHooks$lambda$lambda_1(this);
    return hooks;
  };
  Widget.prototype.setInternalEventListener_a1up2z$ = function (block) {
    var tmp$, tmp$_0, tmp$_1;
    if (this.internalListenersMap_8be2vx$ == null) {
      this.internalListenersMap_8be2vx$ = LinkedHashMap_init();
    }var handlerCounter = (tmp$ = this.listenerCounter_8be2vx$, this.listenerCounter_8be2vx$ = tmp$ + 1 | 0, tmp$);
    var blockAsWidget = typeof (tmp$_0 = block) === 'function' ? tmp$_0 : throwCCE();
    var handlers = on(this);
    getCallableRef('apply', function ($receiver, p1) {
      p1($receiver);
      return $receiver;
    }.bind(null, handlers))(blockAsWidget);
    tmp$_1 = iterator(Object.keys(handlers));
    while (tmp$_1.hasNext()) {
      var key = tmp$_1.next();
      if (!equals(key, 'self')) {
        var handler = handlers[key];
        var map = ensureNotNull(this.internalListenersMap_8be2vx$).get_11rb$(key);
        if (map != null) {
          map.put_xwzc9p$(handlerCounter, handler);
        } else {
          var $receiver = ensureNotNull(this.internalListenersMap_8be2vx$);
          var value = mutableMapOf([to(handlerCounter, handler)]);
          $receiver.put_xwzc9p$(key, value);
        }
      }}
    this.refresh();
    return handlerCounter;
  };
  Widget.prototype.setEventListener_a1up2z$ = function (block) {
    var tmp$, tmp$_0, tmp$_1, tmp$_2;
    if (this.listenersMap_8be2vx$ == null) {
      this.listenersMap_8be2vx$ = LinkedHashMap_init();
    }var handlerCounter = (tmp$ = this.listenerCounter_8be2vx$, this.listenerCounter_8be2vx$ = tmp$ + 1 | 0, tmp$);
    var blockAsWidget = typeof (tmp$_0 = block) === 'function' ? tmp$_0 : throwCCE();
    var handlers = on((tmp$_1 = this.eventTarget) != null ? tmp$_1 : this);
    getCallableRef('apply', function ($receiver, p1) {
      p1($receiver);
      return $receiver;
    }.bind(null, handlers))(blockAsWidget);
    tmp$_2 = iterator(Object.keys(handlers));
    while (tmp$_2.hasNext()) {
      var key = tmp$_2.next();
      if (!equals(key, 'self')) {
        var handler = handlers[key];
        var map = ensureNotNull(this.listenersMap_8be2vx$).get_11rb$(key);
        if (map != null) {
          map.put_xwzc9p$(handlerCounter, handler);
        } else {
          var $receiver = ensureNotNull(this.listenersMap_8be2vx$);
          var value = mutableMapOf([to(handlerCounter, handler)]);
          $receiver.put_xwzc9p$(key, value);
        }
      }}
    this.refresh();
    return handlerCounter;
  };
  Widget.prototype.removeEventListener_za3lpa$ = function (id) {
    var tmp$;
    if ((tmp$ = this.listenersMap_8be2vx$) != null) {
      var tmp$_0;
      tmp$_0 = tmp$.entries.iterator();
      while (tmp$_0.hasNext()) {
        var element = tmp$_0.next();
        element.value.remove_11rb$(id);
      }
    }this.refresh();
    return this;
  };
  Widget.prototype.removeEventListeners = function () {
    var tmp$;
    (tmp$ = this.listenersMap_8be2vx$) != null ? (tmp$.clear(), Unit) : null;
    this.refresh();
    return this;
  };
  Widget.prototype.show = function () {
    this.visible = true;
    return this;
  };
  Widget.prototype.hide = function () {
    this.visible = false;
    return this;
  };
  function Widget$showAnim$lambda(this$Widget, closure$complete) {
    return function () {
      this$Widget.display = null;
      return closure$complete != null ? closure$complete() : null;
    };
  }
  Widget.prototype.showAnim_ieys43$$default = function (duration, easing, complete) {
    this.display = Display$NONE_getInstance();
    this.visible = true;
    var jq = this.getElementJQuery();
    if (jq != null) {
      jq.show(duration, easing.easing_8be2vx$, Widget$showAnim$lambda(this, complete));
    } else {
      this.display = null;
      complete != null ? complete() : null;
    }
    return this;
  };
  Widget.prototype.showAnim_ieys43$ = function (duration, easing, complete, callback$default) {
    if (duration === void 0)
      duration = 400;
    if (easing === void 0)
      easing = Easing$SWING_getInstance();
    if (complete === void 0)
      complete = null;
    return callback$default ? callback$default(duration, easing, complete) : this.showAnim_ieys43$$default(duration, easing, complete);
  };
  function Widget$hideAnim$lambda(this$Widget, closure$complete) {
    return function () {
      this$Widget.visible = false;
      return closure$complete != null ? closure$complete() : null;
    };
  }
  Widget.prototype.hideAnim_ieys43$$default = function (duration, easing, complete) {
    var jq = this.getElementJQuery();
    if (jq != null) {
      jq.hide(duration, easing.easing_8be2vx$, Widget$hideAnim$lambda(this, complete));
    } else {
      this.visible = false;
      complete != null ? complete() : null;
    }
    return this;
  };
  Widget.prototype.hideAnim_ieys43$ = function (duration, easing, complete, callback$default) {
    if (duration === void 0)
      duration = 400;
    if (easing === void 0)
      easing = Easing$SWING_getInstance();
    if (complete === void 0)
      complete = null;
    return callback$default ? callback$default(duration, easing, complete) : this.hideAnim_ieys43$$default(duration, easing, complete);
  };
  function Widget$slideDown$lambda(this$Widget, closure$complete) {
    return function () {
      this$Widget.display = null;
      return closure$complete != null ? closure$complete() : null;
    };
  }
  Widget.prototype.slideDown_ieys43$$default = function (duration, easing, complete) {
    this.display = Display$NONE_getInstance();
    this.visible = true;
    var jq = this.getElementJQuery();
    if (jq != null) {
      jq.slideDown(duration, easing.easing_8be2vx$, Widget$slideDown$lambda(this, complete));
    } else {
      this.display = null;
      complete != null ? complete() : null;
    }
    return this;
  };
  Widget.prototype.slideDown_ieys43$ = function (duration, easing, complete, callback$default) {
    if (duration === void 0)
      duration = 400;
    if (easing === void 0)
      easing = Easing$SWING_getInstance();
    if (complete === void 0)
      complete = null;
    return callback$default ? callback$default(duration, easing, complete) : this.slideDown_ieys43$$default(duration, easing, complete);
  };
  function Widget$slideUp$lambda(this$Widget, closure$complete) {
    return function () {
      this$Widget.visible = false;
      return closure$complete != null ? closure$complete() : null;
    };
  }
  Widget.prototype.slideUp_ieys43$$default = function (duration, easing, complete) {
    var jq = this.getElementJQuery();
    if (jq != null) {
      jq.slideUp(duration, easing.easing_8be2vx$, Widget$slideUp$lambda(this, complete));
    } else {
      this.visible = false;
      complete != null ? complete() : null;
    }
    return this;
  };
  Widget.prototype.slideUp_ieys43$ = function (duration, easing, complete, callback$default) {
    if (duration === void 0)
      duration = 400;
    if (easing === void 0)
      easing = Easing$SWING_getInstance();
    if (complete === void 0)
      complete = null;
    return callback$default ? callback$default(duration, easing, complete) : this.slideUp_ieys43$$default(duration, easing, complete);
  };
  function Widget$fadeIn$lambda(this$Widget, closure$complete) {
    return function () {
      this$Widget.display = null;
      return closure$complete != null ? closure$complete() : null;
    };
  }
  Widget.prototype.fadeIn_ieys43$$default = function (duration, easing, complete) {
    this.display = Display$NONE_getInstance();
    this.visible = true;
    var jq = this.getElementJQuery();
    if (jq != null) {
      jq.fadeIn(duration, easing.easing_8be2vx$, Widget$fadeIn$lambda(this, complete));
    } else {
      this.display = null;
      complete != null ? complete() : null;
    }
    return this;
  };
  Widget.prototype.fadeIn_ieys43$ = function (duration, easing, complete, callback$default) {
    if (duration === void 0)
      duration = 400;
    if (easing === void 0)
      easing = Easing$SWING_getInstance();
    if (complete === void 0)
      complete = null;
    return callback$default ? callback$default(duration, easing, complete) : this.fadeIn_ieys43$$default(duration, easing, complete);
  };
  function Widget$fadeOut$lambda(this$Widget, closure$complete) {
    return function () {
      this$Widget.visible = false;
      return closure$complete != null ? closure$complete() : null;
    };
  }
  Widget.prototype.fadeOut_ieys43$$default = function (duration, easing, complete) {
    var jq = this.getElementJQuery();
    if (jq != null) {
      jq.fadeOut(duration, easing.easing_8be2vx$, Widget$fadeOut$lambda(this, complete));
    } else {
      this.visible = false;
      complete != null ? complete() : null;
    }
    return this;
  };
  Widget.prototype.fadeOut_ieys43$ = function (duration, easing, complete, callback$default) {
    if (duration === void 0)
      duration = 400;
    if (easing === void 0)
      easing = Easing$SWING_getInstance();
    if (complete === void 0)
      complete = null;
    return callback$default ? callback$default(duration, easing, complete) : this.fadeOut_ieys43$$default(duration, easing, complete);
  };
  Widget.prototype.enableTooltip_33qfk7$$default = function (options) {
    var tmp$, tmp$_0, tmp$_1, tmp$_2;
    this.tooltipOptions = options;
    var tooltipFun = (tmp$ = this.getElementJQueryD()) != null ? tmp$.tooltip : null;
    if (tooltipFun != undefined) {
      tmp$_2 = this.getElementJQueryD();
      tmp$_1 = toJs(options.copy_9214e9$((tmp$_0 = options.title) != null ? this.translate_61zpoe$(tmp$_0) : null));
      tmp$_2 != null ? tmp$_2.tooltip(tmp$_1) : null;
    }return this;
  };
  Widget.prototype.enableTooltip_33qfk7$ = function (options, callback$default) {
    if (options === void 0)
      options = new TooltipOptions();
    return callback$default ? callback$default(options) : this.enableTooltip_33qfk7$$default(options);
  };
  Widget.prototype.showTooltip = function () {
    var tmp$, tmp$_0;
    if (this.tooltipOptions != null) {
      var tooltipFun = (tmp$ = this.getElementJQueryD()) != null ? tmp$.tooltip : null;
      if (tooltipFun != undefined)
        (tmp$_0 = this.getElementJQueryD()) != null ? tmp$_0.tooltip('show') : null;
    }return this;
  };
  Widget.prototype.hideTooltip = function () {
    var tmp$, tmp$_0;
    if (this.tooltipOptions != null) {
      var tooltipFun = (tmp$ = this.getElementJQueryD()) != null ? tmp$.tooltip : null;
      if (tooltipFun != undefined)
        (tmp$_0 = this.getElementJQueryD()) != null ? tmp$_0.tooltip('hide') : null;
    }return this;
  };
  Widget.prototype.disableTooltip = function () {
    var tmp$, tmp$_0;
    this.tooltipOptions = null;
    var tooltipFun = (tmp$ = this.getElementJQueryD()) != null ? tmp$.tooltip : null;
    if (tooltipFun != undefined)
      (tmp$_0 = this.getElementJQueryD()) != null ? tmp$_0.tooltip('dispose') : null;
    return this;
  };
  Widget.prototype.enablePopover_ltj3bv$$default = function (options) {
    var tmp$, tmp$_0, tmp$_1, tmp$_2, tmp$_3, tmp$_4;
    this.popoverOptions = options;
    var popoverFun = (tmp$ = this.getElementJQueryD()) != null ? tmp$.popover : null;
    if (popoverFun != undefined) {
      tmp$_4 = this.getElementJQueryD();
      tmp$_1 = (tmp$_0 = options.title) != null ? this.translate_61zpoe$(tmp$_0) : null;
      tmp$_3 = toJs_0(options.copy_kzv7d6$((tmp$_2 = options.content) != null ? this.translate_61zpoe$(tmp$_2) : null, tmp$_1));
      tmp$_4 != null ? tmp$_4.popover(tmp$_3) : null;
    }return this;
  };
  Widget.prototype.enablePopover_ltj3bv$ = function (options, callback$default) {
    if (options === void 0)
      options = new PopoverOptions();
    return callback$default ? callback$default(options) : this.enablePopover_ltj3bv$$default(options);
  };
  Widget.prototype.showPopover = function () {
    var tmp$, tmp$_0;
    if (this.popoverOptions != null) {
      var popoverFun = (tmp$ = this.getElementJQueryD()) != null ? tmp$.popover : null;
      if (popoverFun != undefined)
        (tmp$_0 = this.getElementJQueryD()) != null ? tmp$_0.popover('show') : null;
    }return this;
  };
  Widget.prototype.hidePopover = function () {
    var tmp$, tmp$_0;
    if (this.popoverOptions != null) {
      var popoverFun = (tmp$ = this.getElementJQueryD()) != null ? tmp$.popover : null;
      if (popoverFun != undefined)
        (tmp$_0 = this.getElementJQueryD()) != null ? tmp$_0.popover('hide') : null;
    }return this;
  };
  Widget.prototype.disablePopover = function () {
    var tmp$, tmp$_0;
    this.popoverOptions = null;
    var popoverFun = (tmp$ = this.getElementJQueryD()) != null ? tmp$.popover : null;
    if (popoverFun != undefined)
      (tmp$_0 = this.getElementJQueryD()) != null ? tmp$_0.popover('dispose') : null;
    return this;
  };
  Widget.prototype.toggleVisible = function () {
    return this.visible ? this.hide() : this.show();
  };
  Widget.prototype.addCssClass_61zpoe$ = function (css) {
    var tmp$, tmp$_0;
    if (this.classes_8be2vx$ == null) {
      this.classes_8be2vx$ = (tmp$_0 = (tmp$ = this.intClasses_8be2vx$) != null ? toMutableSet(tmp$) : null) != null ? tmp$_0 : LinkedHashSet_init();
    }ensureNotNull(this.classes_8be2vx$).add_11rb$(css);
    this.refresh();
    return this;
  };
  Widget.prototype.removeCssClass_61zpoe$ = function (css) {
    var tmp$, tmp$_0;
    if (this.classes_8be2vx$ == null) {
      this.classes_8be2vx$ = (tmp$_0 = (tmp$ = this.intClasses_8be2vx$) != null ? toMutableSet(tmp$) : null) != null ? tmp$_0 : LinkedHashSet_init();
    }ensureNotNull(this.classes_8be2vx$).remove_11rb$(css);
    this.refresh();
    return this;
  };
  Widget.prototype.hasCssClass_61zpoe$ = function (css) {
    var tmp$, tmp$_0;
    return (tmp$_0 = (tmp$ = this.classes_8be2vx$) != null ? tmp$.contains_11rb$(css) : null) != null ? tmp$_0 : false;
  };
  Widget.prototype.addSurroundingCssClass_61zpoe$ = function (css) {
    if (this.surroundingClasses_8be2vx$ == null) {
      this.surroundingClasses_8be2vx$ = LinkedHashSet_init();
    }ensureNotNull(this.surroundingClasses_8be2vx$).add_11rb$(css);
    this.refresh();
    return this;
  };
  Widget.prototype.removeSurroundingCssClass_61zpoe$ = function (css) {
    if (this.surroundingClasses_8be2vx$ == null) {
      this.surroundingClasses_8be2vx$ = LinkedHashSet_init();
    }ensureNotNull(this.surroundingClasses_8be2vx$).remove_11rb$(css);
    this.refresh();
    return this;
  };
  Widget.prototype.addCssStyle_807zt1$ = function (css) {
    return this.addCssClass_61zpoe$(css.className);
  };
  Widget.prototype.removeCssStyle_807zt1$ = function (css) {
    return this.removeCssClass_61zpoe$(css.className);
  };
  Widget.prototype.addSurroundingCssStyle_807zt1$ = function (css) {
    return this.addSurroundingCssClass_61zpoe$(css.className);
  };
  Widget.prototype.removeSurroundingCssStyle_807zt1$ = function (css) {
    return this.removeSurroundingCssClass_61zpoe$(css.className);
  };
  Widget.prototype.getAttribute_61zpoe$ = function (name) {
    var tmp$;
    return (tmp$ = this.attributes_8be2vx$) != null ? tmp$.get_11rb$(name) : null;
  };
  Widget.prototype.setAttribute_puj7f4$ = function (name, value) {
    if (this.attributes_8be2vx$ == null) {
      this.attributes_8be2vx$ = LinkedHashMap_init();
    }ensureNotNull(this.attributes_8be2vx$).put_xwzc9p$(name, value);
    this.refresh();
    return this;
  };
  Widget.prototype.removeAttribute_61zpoe$ = function (name) {
    if (this.attributes_8be2vx$ == null) {
      this.attributes_8be2vx$ = LinkedHashMap_init();
    }ensureNotNull(this.attributes_8be2vx$).remove_11rb$(name);
    this.refresh();
    return this;
  };
  Widget.prototype.getElement = function () {
    var tmp$;
    return (tmp$ = this.vnode) != null ? tmp$.elm : null;
  };
  Widget.prototype.getElementJQuery = function () {
    var tmp$;
    return (tmp$ = this.getElement()) != null ? $module$jquery(tmp$) : null;
  };
  Widget.prototype.getElementJQueryD = function () {
    var tmp$;
    return (tmp$ = this.getElement()) != null ? $module$jquery(tmp$) : null;
  };
  Widget.prototype.clearParent = function () {
    this.parent = null;
    return this;
  };
  Widget.prototype.refresh = function () {
    var tmp$;
    StyledComponent.prototype.refresh.call(this);
    this.snAttrsCache_cfphr3$_0.clear();
    this.snClassCache_hcl495$_0.clear();
    this.snOnCache_aaik0$_0 = null;
    this.snHooksCache_rlx0tr$_0 = null;
    (tmp$ = this.getRoot()) != null ? tmp$.reRender_8be2vx$() : null;
    return this;
  };
  Widget.prototype.afterCreate_cmtal8$ = function (node) {
  };
  Widget.prototype.afterInsertInternal_cmtal8$ = function (node) {
    var tmp$, tmp$_0;
    if ((tmp$ = this.tooltipOptions) != null) {
      var tmp$_1, tmp$_2, tmp$_3, tmp$_4;
      var tooltipFun = (tmp$_1 = this.getElementJQueryD()) != null ? tmp$_1.tooltip : null;
      if (tooltipFun != undefined) {
        tmp$_4 = this.getElementJQueryD();
        tmp$_3 = toJs(tmp$.copy_9214e9$((tmp$_2 = tmp$.title) != null ? this.translate_61zpoe$(tmp$_2) : null));
        tmp$_4 != null ? tmp$_4.tooltip(tmp$_3) : null;
      }}if ((tmp$_0 = this.popoverOptions) != null) {
      var tmp$_5, tmp$_6, tmp$_7, tmp$_8, tmp$_9, tmp$_10;
      var popoverFun = (tmp$_5 = this.getElementJQueryD()) != null ? tmp$_5.popover : null;
      if (popoverFun != undefined) {
        tmp$_10 = this.getElementJQueryD();
        tmp$_7 = (tmp$_6 = tmp$_0.title) != null ? this.translate_61zpoe$(tmp$_6) : null;
        tmp$_9 = toJs_0(tmp$_0.copy_kzv7d6$((tmp$_8 = tmp$_0.content) != null ? this.translate_61zpoe$(tmp$_8) : null, tmp$_7));
        tmp$_10 != null ? tmp$_10.popover(tmp$_9) : null;
      }}};
  Widget.prototype.afterInsert_cmtal8$ = function (node) {
  };
  Widget.prototype.afterDestroyInternal = function () {
    if (this.tooltipOptions != null) {
      var tmp$, tmp$_0;
      var tooltipFun = (tmp$ = this.getElementJQueryD()) != null ? tmp$.tooltip : null;
      if (tooltipFun != undefined)
        (tmp$_0 = this.getElementJQueryD()) != null ? tmp$_0.tooltip('dispose') : null;
    }if (this.popoverOptions != null) {
      var tmp$_1, tmp$_2;
      var popoverFun = (tmp$_1 = this.getElementJQueryD()) != null ? tmp$_1.popover : null;
      if (popoverFun != undefined)
        (tmp$_2 = this.getElementJQueryD()) != null ? tmp$_2.popover('dispose') : null;
    }};
  Widget.prototype.afterDestroy = function () {
  };
  Widget.prototype.getRoot = function () {
    var tmp$;
    return (tmp$ = this.parent) != null ? tmp$.getRoot() : null;
  };
  function Widget$setDragDropData$lambda$lambda(closure$format, closure$data) {
    return function (e) {
      var tmp$;
      (tmp$ = e.dataTransfer) != null ? (tmp$.setData(closure$format, closure$data), Unit) : null;
      return Unit;
    };
  }
  function Widget$setDragDropData$lambda(closure$format, closure$data) {
    return function ($receiver) {
      $receiver.dragstart = Widget$setDragDropData$lambda$lambda(closure$format, closure$data);
      return Unit;
    };
  }
  Widget.prototype.setDragDropData_puj7f4$ = function (format, data) {
    this.draggable = true;
    this.setEventListener_a1up2z$(Widget$setDragDropData$lambda(format, data));
  };
  function Widget$clearDragDropData$lambda$lambda(it) {
    return Unit;
  }
  function Widget$clearDragDropData$lambda($receiver) {
    $receiver.dragstart = Widget$clearDragDropData$lambda$lambda;
    return Unit;
  }
  Widget.prototype.clearDragDropData = function () {
    this.draggable = false;
    this.setEventListener_a1up2z$(Widget$clearDragDropData$lambda);
  };
  function Widget$setDropTargetData$lambda(closure$callback, closure$format) {
    return function (e) {
      var tmp$;
      closure$callback((tmp$ = e.dataTransfer) != null ? tmp$.getData(closure$format) : null);
      return Unit;
    };
  }
  Widget.prototype.setDropTargetData_2by8ig$ = function (format, callback) {
    this.setDropTarget_aem84q$(format, Widget$setDropTargetData$lambda(callback, format));
  };
  Widget.prototype.setDropTarget_aem84q$ = function (format, callback) {
    this.setDropTarget_jwrva8$(setOf(format), callback);
  };
  function Widget$setDropTarget$lambda$lambda(closure$formats) {
    return function (e) {
      var tmp$, tmp$_0, tmp$_1;
      var types = (tmp$_1 = (tmp$_0 = (tmp$ = e.dataTransfer) != null ? tmp$.types : null) != null ? toSet(tmp$_0) : null) != null ? tmp$_1 : emptySet();
      var tmp$_2 = closure$formats == null;
      if (!tmp$_2) {
        tmp$_2 = !intersect(closure$formats, types).isEmpty();
      }if (tmp$_2) {
        e.preventDefault();
      }return Unit;
    };
  }
  function Widget$setDropTarget$lambda$lambda_0(closure$callback) {
    return function (e) {
      e.preventDefault();
      e.stopPropagation();
      closure$callback(e);
      return Unit;
    };
  }
  function Widget$setDropTarget$lambda(closure$formats, closure$callback) {
    return function ($receiver) {
      $receiver.dragover = Widget$setDropTarget$lambda$lambda(closure$formats);
      $receiver.drop = Widget$setDropTarget$lambda$lambda_0(closure$callback);
      return Unit;
    };
  }
  Widget.prototype.setDropTarget_jwrva8$$default = function (formats, callback) {
    this.setEventListener_a1up2z$(Widget$setDropTarget$lambda(formats, callback));
  };
  Widget.prototype.setDropTarget_jwrva8$ = function (formats, callback, callback$default) {
    if (formats === void 0)
      formats = null;
    callback$default ? callback$default(formats, callback) : this.setDropTarget_jwrva8$$default(formats, callback);
  };
  function Widget$animate$lambda(closure$widget, this$Widget, closure$styles, closure$complete) {
    return function () {
      closure$widget.dispose();
      closure$styles(this$Widget);
      return closure$complete != null ? closure$complete() : null;
    };
  }
  Widget.prototype.animate_iyl642$$default = function (duration, easing, complete, styles) {
    var tmp$;
    var widget = new Widget();
    styles(widget);
    var stylesList = widget.getSnStyle();
    var obj = {};
    var tmp$_0;
    tmp$_0 = stylesList.iterator();
    while (tmp$_0.hasNext()) {
      var element = tmp$_0.next();
      var key = element.component1(), value = element.component2();
      obj[toCamelCase(key)] = value;
    }
    (tmp$ = this.getElementJQuery()) != null ? tmp$.animate(obj, duration, easing.easing_8be2vx$, Widget$animate$lambda(widget, this, styles, complete)) : null;
  };
  Widget.prototype.animate_iyl642$ = function (duration, easing, complete, styles, callback$default) {
    if (duration === void 0)
      duration = 400;
    if (easing === void 0)
      easing = Easing$SWING_getInstance();
    if (complete === void 0)
      complete = null;
    callback$default ? callback$default(duration, easing, complete, styles) : this.animate_iyl642$$default(duration, easing, complete, styles);
  };
  function Widget$createLabelWithIcon$lambda(closure$iconClasses) {
    return function ($receiver) {
      var $receiver_0 = closure$iconClasses;
      var destination = ArrayList_init_0(collectionSizeOrDefault($receiver_0, 10));
      var tmp$;
      tmp$ = $receiver_0.iterator();
      while (tmp$.hasNext()) {
        var item = tmp$.next();
        destination.add_11rb$(to(item, true));
      }
      var $receiver_1 = new Object_init();
      var tmp$_0;
      tmp$_0 = destination.iterator();
      while (tmp$_0.hasNext()) {
        var element = tmp$_0.next();
        var key = element.component1(), value = element.component2();
        $receiver_1[key] = value;
      }
      $receiver.class = $receiver_1;
      return Unit;
    };
  }
  function Widget$createLabelWithIcon$lambda_0(closure$image) {
    return function ($receiver) {
      var pairs = mapOf([to('src', closure$image), to('alt', '')]);
      var $receiver_0 = new Object_init();
      var tmp$;
      tmp$ = pairs.entries.iterator();
      while (tmp$.hasNext()) {
        var element = tmp$.next();
        var key = element.key;
        var value = element.value;
        $receiver_0[key] = value;
      }
      $receiver.attrs = $receiver_0;
      return Unit;
    };
  }
  Widget.prototype.createLabelWithIcon_dawjdb$$default = function (label, icon, image, separator) {
    var tmp$;
    var translatedLabel = this.translate_61zpoe$(label);
    if (icon != null) {
      var iconClasses = toSet_0(split(icon, [' ']));
      var iconOpt = getCallableRef('apply', function ($receiver_0, p1_0) {
        p1_0($receiver_0);
        return $receiver_0;
      }.bind(null, {}))(Widget$createLabelWithIcon$lambda(iconClasses));
      if (separator == null) {
        tmp$ = [h('i', iconOpt), ' ' + translatedLabel];
      } else {
        tmp$ = [h('i', iconOpt), KVManager_getInstance().virtualize_61zpoe$(separator), translatedLabel];
      }
    } else if (image != null) {
      var imageOpt = getCallableRef('apply', function ($receiver_0, p1_0) {
        p1_0($receiver_0);
        return $receiver_0;
      }.bind(null, {}))(Widget$createLabelWithIcon$lambda_0(image));
      if (separator == null) {
        tmp$ = [h('img', imageOpt), ' ' + translatedLabel];
      } else {
        tmp$ = [h('img', imageOpt), KVManager_getInstance().virtualize_61zpoe$(separator), translatedLabel];
      }
    } else {
      tmp$ = [translatedLabel];
    }
    return tmp$;
  };
  Widget.prototype.createLabelWithIcon_dawjdb$ = function (label, icon, image, separator, callback$default) {
    if (icon === void 0)
      icon = null;
    if (image === void 0)
      image = null;
    if (separator === void 0)
      separator = null;
    return callback$default ? callback$default(label, icon, image, separator) : this.createLabelWithIcon_dawjdb$$default(label, icon, image, separator);
  };
  Widget.prototype.dispatchEvent_nxedta$ = function (type, eventInitDict) {
    var tmp$;
    var event = new CustomEvent(type, eventInitDict);
    return (tmp$ = this.getElement()) != null ? tmp$.dispatchEvent(event) : null;
  };
  Widget.prototype.dispose = function () {
    var tmp$;
    if ((tmp$ = this.beforeDisposeHooks_qk8awk$_0) != null) {
      var tmp$_0;
      tmp$_0 = tmp$.iterator();
      while (tmp$_0.hasNext()) {
        var element = tmp$_0.next();
        element();
      }
    }};
  Widget.prototype.refreshOnUpdate_7qq44f$ = defineInlineFunction('kvision-jsLegacy.io.kvision.core.Widget.refreshOnUpdate_7qq44f$', wrapFunction(function () {
    var Unit = Kotlin.kotlin.Unit;
    var Widget$Widget$RefreshDelegateProvider_init = _.io.kvision.core.Widget.RefreshDelegateProvider;
    function Widget$refreshOnUpdate$lambda(this$Widget) {
      return function (it) {
        this$Widget.refresh();
        return Unit;
      };
    }
    return function (refreshFunction) {
      if (refreshFunction === void 0)
        refreshFunction = Widget$refreshOnUpdate$lambda(this);
      return new Widget$Widget$RefreshDelegateProvider_init(this, null, refreshFunction);
    };
  }));
  Widget.prototype.refreshOnUpdate_7uhc0p$ = defineInlineFunction('kvision-jsLegacy.io.kvision.core.Widget.refreshOnUpdate_7uhc0p$', wrapFunction(function () {
    var Unit = Kotlin.kotlin.Unit;
    var Widget$Widget$RefreshDelegateProvider_init = _.io.kvision.core.Widget.RefreshDelegateProvider;
    function Widget$refreshOnUpdate$lambda(this$Widget) {
      return function (it) {
        this$Widget.refresh();
        return Unit;
      };
    }
    return function (initialValue, refreshFunction) {
      if (refreshFunction === void 0)
        refreshFunction = Widget$refreshOnUpdate$lambda(this);
      return new Widget$Widget$RefreshDelegateProvider_init(this, initialValue, refreshFunction);
    };
  }));
  function Widget$RefreshDelegateProvider($outer, initialValue, refreshFunction) {
    this.$outer = $outer;
    this.initialValue_0 = initialValue;
    this.refreshFunction_0 = refreshFunction;
  }
  Widget$RefreshDelegateProvider.prototype.provideDelegate_n5byny$ = function (thisRef, prop) {
    if (this.initialValue_0 != null)
      this.$outer.propertyValues_v9485h$_0[prop.callableName] = this.initialValue_0;
    return new Widget$RefreshDelegate(this.$outer, this.refreshFunction_0);
  };
  Widget$RefreshDelegateProvider.$metadata$ = {kind: Kind_CLASS, simpleName: 'RefreshDelegateProvider', interfaces: []};
  function Widget$RefreshDelegate($outer, refreshFunction) {
    this.$outer = $outer;
    this.refreshFunction_0 = refreshFunction;
  }
  Widget$RefreshDelegate.prototype.getValue_fmbzy8$ = function (thisRef, property) {
    var tmp$;
    var value = this.$outer.propertyValues_v9485h$_0[property.callableName];
    if (value != null) {
      tmp$ = value;
    } else {
      tmp$ = null;
    }
    return tmp$;
  };
  Widget$RefreshDelegate.prototype.setValue_19qrsr$ = function (thisRef, property, value) {
    this.$outer.propertyValues_v9485h$_0[property.callableName] = value;
    this.refreshFunction_0(value);
  };
  Widget$RefreshDelegate.$metadata$ = {kind: Kind_CLASS, simpleName: 'RefreshDelegate', interfaces: []};
  function Widget$Companion() {
    Widget$Companion_instance = this;
    this.counter_0 = 0;
  }
  function Widget$Companion$bindState$lambda$lambda(closure$removeChildren, this$bindState, closure$factory, closure$it) {
    return function () {
      var tmp$, tmp$_0;
      if (closure$removeChildren)
        (tmp$_0 = Kotlin.isType(tmp$ = this$bindState, Container) ? tmp$ : null) != null ? tmp$_0.disposeAll() : null;
      closure$factory(this$bindState, closure$it);
      return Unit;
    };
  }
  function Widget$Companion$bindState$lambda(closure$removeChildren, this$bindState, closure$factory) {
    return function (it) {
      this$bindState.singleRender_klfg04$(Widget$Companion$bindState$lambda$lambda(closure$removeChildren, this$bindState, closure$factory, it));
      return Unit;
    };
  }
  Widget$Companion.prototype.bindState_wt73pd$ = function ($receiver, observableState, removeChildren, factory) {
    if (removeChildren === void 0)
      removeChildren = true;
    $receiver.addBeforeDisposeHook_o14v8n$(observableState.subscribe_qlkmfe$(Widget$Companion$bindState$lambda(removeChildren, $receiver, factory)));
    return $receiver;
  };
  Widget$Companion.$metadata$ = {kind: Kind_OBJECT, simpleName: 'Companion', interfaces: []};
  var Widget$Companion_instance = null;
  function Widget$Companion_getInstance() {
    if (Widget$Companion_instance === null) {
      new Widget$Companion();
    }return Widget$Companion_instance;
  }
  function Widget$snAttrsCache$lambda(this$Widget) {
    return function () {
      return buildAttributeSet(getCallableRef('buildAttributeSet', function ($receiver, p1) {
        return $receiver.buildAttributeSet_34lhpl$(p1), Unit;
      }.bind(null, this$Widget)));
    };
  }
  function Widget$snAttrsCache$lambda_0(this$Widget) {
    return function () {
      return this$Widget.lastLanguage != null && !equals(this$Widget.lastLanguage, I18n_getInstance().language);
    };
  }
  function Widget$snClassCache$lambda(this$Widget) {
    return function () {
      return buildClassSet(getCallableRef('buildClassSet', function ($receiver, p1) {
        return $receiver.buildClassSet_xutoed$(p1), Unit;
      }.bind(null, this$Widget)));
    };
  }
  Widget.$metadata$ = {kind: Kind_CLASS, simpleName: 'Widget', interfaces: [Component, StyledComponent]};
  var Form$Companion_instance = null;
  var InputSize$LARGE_instance;
  var InputSize$SMALL_instance;
  var ValidationStatus$VALID_instance;
  var ValidationStatus$INVALID_instance;
  function FormInput() {
  }
  function FormControl() {
  }
  function StringFormControl() {
  }
  function NumberFormControl() {
  }
  function BoolFormControl() {
  }
  function DateFormControl() {
  }
  function KFilesFormControl() {
  }
  function GenericFormControl() {
  }
  var FormType$INLINE_instance;
  var FormType$HORIZONTAL_instance;
  var FormHorizontalRatio$RATIO_2_instance;
  var FormHorizontalRatio$RATIO_3_instance;
  var FormHorizontalRatio$RATIO_4_instance;
  var FormHorizontalRatio$RATIO_5_instance;
  var FormHorizontalRatio$RATIO_6_instance;
  var FormHorizontalRatio$RATIO_7_instance;
  var FormHorizontalRatio$RATIO_8_instance;
  var FormHorizontalRatio$RATIO_9_instance;
  var FormHorizontalRatio$RATIO_10_instance;
  var FormMethod$GET_instance;
  var FormMethod$POST_instance;
  var FormEnctype$URLENCODED_instance;
  var FormEnctype$MULTIPART_instance;
  var FormEnctype$PLAIN_instance;
  var FormTarget$BLANK_instance;
  var FormTarget$SELF_instance;
  var FormTarget$PARENT_instance;
  var FormTarget$TOP_instance;
  var FormPanel$method_metadata = new PropertyMetadata('method');
  var FormPanel$action_metadata = new PropertyMetadata('action');
  var FormPanel$enctype_metadata = new PropertyMetadata('enctype');
  var FormPanel$name_metadata = new PropertyMetadata('name');
  var FormPanel$target_metadata = new PropertyMetadata('target');
  var FormPanel$novalidate_metadata = new PropertyMetadata('novalidate');
  var FormPanel$autocomplete_metadata = new PropertyMetadata('autocomplete');
  var FormPanel$condensed_metadata = new PropertyMetadata('condensed');
  var FormPanel$horizRatio_metadata = new PropertyMetadata('horizRatio');
  var FormPanel$Companion_instance = null;
  var CheckBoxStyle$PRIMARY_instance;
  var CheckBoxStyle$SUCCESS_instance;
  var CheckBoxStyle$INFO_instance;
  var CheckBoxStyle$WARNING_instance;
  var CheckBoxStyle$DANGER_instance;
  var CheckBox$style_metadata = new PropertyMetadata('style');
  var CheckBox$circled_metadata = new PropertyMetadata('circled');
  var CheckBox$inline_metadata = new PropertyMetadata('inline');
  var CheckBox$Companion_instance = null;
  var CheckInputType$CHECKBOX_instance;
  var CheckInputType$RADIO_instance;
  var CheckInput$value_metadata = new PropertyMetadata('value');
  var CheckInput$startValue_metadata = new PropertyMetadata('startValue');
  var CheckInput$type_metadata = new PropertyMetadata('type');
  var CheckInput$name_metadata = new PropertyMetadata('name');
  var CheckInput$disabled_metadata = new PropertyMetadata('disabled');
  var CheckInput$extraValue_metadata = new PropertyMetadata('extraValue');
  var CheckInput$size_metadata = new PropertyMetadata('size');
  var CheckInput$validationStatus_metadata = new PropertyMetadata('validationStatus');
  var GenericRadioGroup$options_metadata = new PropertyMetadata('options');
  var GenericRadioGroup$value_metadata = new PropertyMetadata('value');
  var GenericRadioGroup$inline_metadata = new PropertyMetadata('inline');
  var GenericRadioGroup$Companion_instance = null;
  var GenericRadioGroupInput$options_metadata = new PropertyMetadata('options');
  var GenericRadioGroupInput$value_metadata = new PropertyMetadata('value');
  var GenericRadioGroupInput$inline_metadata = new PropertyMetadata('inline');
  var GenericRadioGroupInput$Companion_instance = null;
  var RadioStyle$PRIMARY_instance;
  var RadioStyle$SUCCESS_instance;
  var RadioStyle$INFO_instance;
  var RadioStyle$WARNING_instance;
  var RadioStyle$DANGER_instance;
  var Radio$style_metadata = new PropertyMetadata('style');
  var Radio$squared_metadata = new PropertyMetadata('squared');
  var Radio$inline_metadata = new PropertyMetadata('inline');
  var Radio$Companion_instance = null;
  var Range$Companion_instance = null;
  var DEFAULT_STEP;
  var RangeInput$value_metadata = new PropertyMetadata('value');
  var RangeInput$startValue_metadata = new PropertyMetadata('startValue');
  var RangeInput$min_metadata = new PropertyMetadata('min');
  var RangeInput$max_metadata = new PropertyMetadata('max');
  var RangeInput$step_metadata = new PropertyMetadata('step');
  var RangeInput$name_metadata = new PropertyMetadata('name');
  var RangeInput$disabled_metadata = new PropertyMetadata('disabled');
  var RangeInput$autofocus_metadata = new PropertyMetadata('autofocus');
  var RangeInput$readonly_metadata = new PropertyMetadata('readonly');
  var RangeInput$size_metadata = new PropertyMetadata('size');
  var RangeInput$validationStatus_metadata = new PropertyMetadata('validationStatus');
  var SimpleSelect$Companion_instance = null;
  var KVNULL;
  var SimpleSelectInput$options_metadata = new PropertyMetadata('options');
  var SimpleSelectInput$value_metadata = new PropertyMetadata('value');
  var SimpleSelectInput$startValue_metadata = new PropertyMetadata('startValue');
  var SimpleSelectInput$name_metadata = new PropertyMetadata('name');
  var SimpleSelectInput$disabled_metadata = new PropertyMetadata('disabled');
  var SimpleSelectInput$autofocus_metadata = new PropertyMetadata('autofocus');
  var SimpleSelectInput$emptyOption_metadata = new PropertyMetadata('emptyOption');
  var SimpleSelectInput$multiple_metadata = new PropertyMetadata('multiple');
  var SimpleSelectInput$selectSize_metadata = new PropertyMetadata('selectSize');
  var SimpleSelectInput$size_metadata = new PropertyMetadata('size');
  var SimpleSelectInput$validationStatus_metadata = new PropertyMetadata('validationStatus');
  var AbstractText$Companion_instance = null;
  var AbstractTextInput$value_metadata = new PropertyMetadata('value');
  var AbstractTextInput$startValue_metadata = new PropertyMetadata('startValue');
  var AbstractTextInput$placeholder_metadata = new PropertyMetadata('placeholder');
  var AbstractTextInput$name_metadata = new PropertyMetadata('name');
  var AbstractTextInput$maxlength_metadata = new PropertyMetadata('maxlength');
  var AbstractTextInput$disabled_metadata = new PropertyMetadata('disabled');
  var AbstractTextInput$autofocus_metadata = new PropertyMetadata('autofocus');
  var AbstractTextInput$readonly_metadata = new PropertyMetadata('readonly');
  var AbstractTextInput$size_metadata = new PropertyMetadata('size');
  var AbstractTextInput$validationStatus_metadata = new PropertyMetadata('validationStatus');
  var TextAreaInput$cols_metadata = new PropertyMetadata('cols');
  var TextAreaInput$rows_metadata = new PropertyMetadata('rows');
  var TextAreaInput$wrapHard_metadata = new PropertyMetadata('wrapHard');
  var TextInputType$TEXT_instance;
  var TextInputType$PASSWORD_instance;
  var TextInputType$EMAIL_instance;
  var TextInputType$TEL_instance;
  var TextInputType$COLOR_instance;
  var TextInputType$SEARCH_instance;
  var TextInputType$URL_instance;
  var TextInput$type_metadata = new PropertyMetadata('type');
  var TextInput$autocomplete_metadata = new PropertyMetadata('autocomplete');
  var ButtonStyle$PRIMARY_instance;
  var ButtonStyle$SECONDARY_instance;
  var ButtonStyle$SUCCESS_instance;
  var ButtonStyle$DANGER_instance;
  var ButtonStyle$WARNING_instance;
  var ButtonStyle$INFO_instance;
  var ButtonStyle$LIGHT_instance;
  var ButtonStyle$DARK_instance;
  var ButtonStyle$LINK_instance;
  var ButtonStyle$OUTLINEPRIMARY_instance;
  var ButtonStyle$OUTLINESECONDARY_instance;
  var ButtonStyle$OUTLINESUCCESS_instance;
  var ButtonStyle$OUTLINEDANGER_instance;
  var ButtonStyle$OUTLINEWARNING_instance;
  var ButtonStyle$OUTLINEINFO_instance;
  var ButtonStyle$OUTLINELIGHT_instance;
  var ButtonStyle$OUTLINEDARK_instance;
  var ButtonSize$LARGE_instance;
  var ButtonSize$SMALL_instance;
  var ButtonType$BUTTON_instance;
  var ButtonType$SUBMIT_instance;
  var ButtonType$RESET_instance;
  var Button$text_metadata = new PropertyMetadata('text');
  var Button$icon_metadata = new PropertyMetadata('icon');
  var Button$style_metadata = new PropertyMetadata('style');
  var Button$type_metadata = new PropertyMetadata('type');
  var Button$disabled_metadata = new PropertyMetadata('disabled');
  var Button$image_metadata = new PropertyMetadata('image');
  var Button$size_metadata = new PropertyMetadata('size');
  var Button$block_metadata = new PropertyMetadata('block');
  var Button$separator_metadata = new PropertyMetadata('separator');
  var Button$labelFirst_metadata = new PropertyMetadata('labelFirst');
  function Widget$refreshOnUpdate$lambda_22(this$Widget) {
    return function (it) {
      this$Widget.refresh();
      return Unit;
    };
  }
  function Canvas(canvasWidth, canvasHeight, classes, init) {
    Canvas$Companion_getInstance();
    if (canvasWidth === void 0)
      canvasWidth = null;
    if (canvasHeight === void 0)
      canvasHeight = null;
    if (classes === void 0) {
      classes = emptySet();
    }if (init === void 0)
      init = null;
    Widget.call(this, classes);
    this.canvasWidth_d9084e$_0 = (new Widget$RefreshDelegateProvider(this, canvasWidth, Widget$refreshOnUpdate$lambda_22(this))).provideDelegate_n5byny$(this, Canvas$canvasWidth_metadata);
    this.canvasHeight_6j7gn9$_0 = (new Widget$RefreshDelegateProvider(this, canvasHeight, Widget$refreshOnUpdate$lambda_22(this))).provideDelegate_n5byny$(this, Canvas$canvasHeight_metadata);
    this.context2D_1q65gx$_0 = this.context2D_1q65gx$_0;
    init != null ? init(this) : null;
  }
  var Canvas$canvasWidth_metadata = new PropertyMetadata('canvasWidth');
  Object.defineProperty(Canvas.prototype, 'canvasWidth', {configurable: true, get: function () {
    return this.canvasWidth_d9084e$_0.getValue_fmbzy8$(this, Canvas$canvasWidth_metadata);
  }, set: function (canvasWidth) {
    this.canvasWidth_d9084e$_0.setValue_19qrsr$(this, Canvas$canvasWidth_metadata, canvasWidth);
  }});
  var Canvas$canvasHeight_metadata = new PropertyMetadata('canvasHeight');
  Object.defineProperty(Canvas.prototype, 'canvasHeight', {configurable: true, get: function () {
    return this.canvasHeight_6j7gn9$_0.getValue_fmbzy8$(this, Canvas$canvasHeight_metadata);
  }, set: function (canvasHeight) {
    this.canvasHeight_6j7gn9$_0.setValue_19qrsr$(this, Canvas$canvasHeight_metadata, canvasHeight);
  }});
  Object.defineProperty(Canvas.prototype, 'context2D', {configurable: true, get: function () {
    if (this.context2D_1q65gx$_0 == null)
      return throwUPAE('context2D');
    return this.context2D_1q65gx$_0;
  }, set: function (context2D) {
    this.context2D_1q65gx$_0 = context2D;
  }});
  Canvas.prototype.render = function () {
    return this.render_61zpoe$('canvas');
  };
  Canvas.prototype.buildAttributeSet_34lhpl$ = function (attributeSetBuilder) {
    var tmp$, tmp$_0;
    Widget.prototype.buildAttributeSet_34lhpl$.call(this, attributeSetBuilder);
    if ((tmp$ = this.canvasWidth) != null) {
      attributeSetBuilder.add_puj7f4$('width', tmp$.toString());
    }if ((tmp$_0 = this.canvasHeight) != null) {
      attributeSetBuilder.add_puj7f4$('height', tmp$_0.toString());
    }};
  Canvas.prototype.afterInsertInternal_cmtal8$ = function (node) {
    var tmp$, tmp$_0;
    Widget.prototype.afterInsertInternal_cmtal8$.call(this, node);
    this.context2D = Kotlin.isType(tmp$_0 = (Kotlin.isType(tmp$ = node.elm, HTMLCanvasElement) ? tmp$ : throwCCE()).getContext('2d'), CanvasRenderingContext2D) ? tmp$_0 : throwCCE();
  };
  function Canvas$Companion() {
    Canvas$Companion_instance = this;
    this.counter_8be2vx$ = 0;
  }
  Canvas$Companion.$metadata$ = {kind: Kind_OBJECT, simpleName: 'Companion', interfaces: []};
  var Canvas$Companion_instance = null;
  function Canvas$Companion_getInstance() {
    if (Canvas$Companion_instance === null) {
      new Canvas$Companion();
    }return Canvas$Companion_instance;
  }
  Canvas.$metadata$ = {kind: Kind_CLASS, simpleName: 'Canvas', interfaces: [Widget]};
  var CustomTag$elementName_metadata = new PropertyMetadata('elementName');
  var Icon$icon_metadata = new PropertyMetadata('icon');
  var Sandbox$ALLOWFORMS_instance;
  var Sandbox$ALLOWPOINTERLOCK_instance;
  var Sandbox$ALLOWPOPUPS_instance;
  var Sandbox$ALLOWSAMEORIGIN_instance;
  var Sandbox$ALLOWSCRIPTS_instance;
  var Sandbox$ALLOWTOPNAVIGATION_instance;
  var Iframe$src_metadata = new PropertyMetadata('src');
  var Iframe$srcdoc_metadata = new PropertyMetadata('srcdoc');
  var Iframe$name_metadata = new PropertyMetadata('name');
  var Iframe$iframeWidth_metadata = new PropertyMetadata('iframeWidth');
  var Iframe$iframeHeight_metadata = new PropertyMetadata('iframeHeight');
  var Iframe$sandbox_metadata = new PropertyMetadata('sandbox');
  var ImageShape$ROUNDED_instance;
  var ImageShape$CIRCLE_instance;
  var ImageShape$THUMBNAIL_instance;
  var Image$src_metadata = new PropertyMetadata('src');
  var Image$alt_metadata = new PropertyMetadata('alt');
  var Image$responsive_metadata = new PropertyMetadata('responsive');
  var Image$shape_metadata = new PropertyMetadata('shape');
  var Image$centered_metadata = new PropertyMetadata('centered');
  var Label$forId_metadata = new PropertyMetadata('forId');
  var Link$label_metadata = new PropertyMetadata('label');
  var Link$url_metadata = new PropertyMetadata('url');
  var Link$icon_metadata = new PropertyMetadata('icon');
  var Link$image_metadata = new PropertyMetadata('image');
  var Link$separator_metadata = new PropertyMetadata('separator');
  var Link$labelFirst_metadata = new PropertyMetadata('labelFirst');
  var Link$target_metadata = new PropertyMetadata('target');
  var ListType$UL_instance;
  var ListType$OL_instance;
  var ListType$UNSTYLED_instance;
  var ListType$INLINE_instance;
  var ListType$DL_instance;
  var ListType$DL_HORIZ_instance;
  var ListTag$type_metadata = new PropertyMetadata('type');
  var ListTag$elements_metadata = new PropertyMetadata('elements');
  var ListTag$rich_metadata = new PropertyMetadata('rich');
  var TAG$H1_instance;
  var TAG$H2_instance;
  var TAG$H3_instance;
  var TAG$H4_instance;
  var TAG$H5_instance;
  var TAG$H6_instance;
  var TAG$P_instance;
  var TAG$ABBR_instance;
  var TAG$ADDRESS_instance;
  var TAG$BLOCKQUOTE_instance;
  var TAG$MAIN_instance;
  var TAG$SECTION_instance;
  var TAG$HEADER_instance;
  var TAG$FOOTER_instance;
  var TAG$ARTICLE_instance;
  var TAG$NAV_instance;
  var TAG$PRE_instance;
  var TAG$UL_instance;
  var TAG$OL_instance;
  var TAG$DIV_instance;
  var TAG$LABEL_instance;
  var TAG$A_instance;
  var TAG$IMG_instance;
  var TAG$I_instance;
  var TAG$B_instance;
  var TAG$MARK_instance;
  var TAG$DEL_instance;
  var TAG$S_instance;
  var TAG$INS_instance;
  var TAG$U_instance;
  var TAG$SMALL_instance;
  var TAG$STRONG_instance;
  var TAG$EM_instance;
  var TAG$CITE_instance;
  var TAG$CODE_instance;
  var TAG$KBD_instance;
  var TAG$VAR_instance;
  var TAG$SAMP_instance;
  var TAG$SPAN_instance;
  var TAG$LI_instance;
  var TAG$HR_instance;
  var TAG$BR_instance;
  var TAG$CAPTION_instance;
  var TAG$FIGURE_instance;
  var TAG$FIGCAPTION_instance;
  var TAG$PICTURE_instance;
  var TAG$SOURCE_instance;
  var TAG$TABLE_instance;
  var TAG$THEAD_instance;
  var TAG$TH_instance;
  var TAG$TBODY_instance;
  var TAG$TR_instance;
  var TAG$TD_instance;
  var TAG$FIELDSET_instance;
  var TAG$LEGEND_instance;
  var TAG$FORM_instance;
  var TAG$INPUT_instance;
  var TAG$SELECT_instance;
  var TAG$OPTION_instance;
  var TAG$BUTTON_instance;
  var Align$LEFT_instance;
  var Align$CENTER_instance;
  var Align$RIGHT_instance;
  var Align$JUSTIFY_instance;
  var Align$NOWRAP_instance;
  var Tag$type_metadata = new PropertyMetadata('type');
  var Tag$content_metadata = new PropertyMetadata('content');
  var Tag$rich_metadata = new PropertyMetadata('rich');
  var Tag$align_metadata = new PropertyMetadata('align');
  var Tag$template_metadata = new PropertyMetadata('template');
  var Tag$templates_metadata = new PropertyMetadata('templates');
  function Widget$refreshOnUpdate$lambda_32(this$Widget) {
    return function (it) {
      this$Widget.refresh();
      return Unit;
    };
  }
  function TextNode(content, rich, init) {
    if (rich === void 0)
      rich = false;
    if (init === void 0)
      init = null;
    Widget.call(this);
    this.content_uig00$_0 = (new Widget$RefreshDelegateProvider(this, content, Widget$refreshOnUpdate$lambda_32(this))).provideDelegate_n5byny$(this, TextNode$content_metadata);
    this.rich_w1n42p$_0 = (new Widget$RefreshDelegateProvider(this, rich, Widget$refreshOnUpdate$lambda_32(this))).provideDelegate_n5byny$(this, TextNode$rich_metadata);
    init != null ? init(this) : null;
  }
  var TextNode$content_metadata = new PropertyMetadata('content');
  Object.defineProperty(TextNode.prototype, 'content', {configurable: true, get: function () {
    return this.content_uig00$_0.getValue_fmbzy8$(this, TextNode$content_metadata);
  }, set: function (content) {
    this.content_uig00$_0.setValue_19qrsr$(this, TextNode$content_metadata, content);
  }});
  var TextNode$rich_metadata = new PropertyMetadata('rich');
  Object.defineProperty(TextNode.prototype, 'rich', {configurable: true, get: function () {
    return this.rich_w1n42p$_0.getValue_fmbzy8$(this, TextNode$rich_metadata);
  }, set: function (rich) {
    this.rich_w1n42p$_0.setValue_19qrsr$(this, TextNode$rich_metadata, rich);
  }});
  TextNode.prototype.render = function () {
    var tmp$;
    var translatedContent = this.translate_61zpoe$(this.content);
    if (this.rich) {
      tmp$ = KVManager_getInstance().virtualize_61zpoe$('<span style=' + '"' + 'display: contents;' + '"' + '>' + translatedContent + '<\/span>');
    } else {
      tmp$ = translatedContent;
    }
    return tmp$;
  };
  TextNode.$metadata$ = {kind: Kind_CLASS, simpleName: 'TextNode', interfaces: [Widget]};
  function I18n() {
    I18n_instance = this;
    this.manager = new SimpleI18nManager();
    this.defaultLanguage_0 = split(window.navigator.language, ['-']).get_za3lpa$(0);
    this.language_asxknz$_0 = this.defaultLanguage_0;
  }
  Object.defineProperty(I18n.prototype, 'language', {configurable: true, get: function () {
    return this.language_asxknz$_0;
  }, set: function (value) {
    this.language_asxknz$_0 = value;
    var tmp$;
    tmp$ = Root$Companion_getInstance().roots_8be2vx$.iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      element.restart_8be2vx$();
    }
  }});
  I18n.prototype.gettext_25kzsl$ = function (key, args) {
    return this.manager.gettext_25kzsl$(key, args.slice());
  };
  I18n.prototype.ngettext_hjhpvv$ = function (singularKey, pluralKey, value, args) {
    return this.manager.ngettext_hjhpvv$(singularKey, pluralKey, value, args.slice());
  };
  I18n.$metadata$ = {kind: Kind_OBJECT, simpleName: 'I18n', interfaces: [I18nManager]};
  var I18n_instance = null;
  function I18n_getInstance() {
    if (I18n_instance === null) {
      new I18n();
    }return I18n_instance;
  }
  var I18N_SINGLE_DELIMITER;
  var I18N_PLURAL_DELIMITER;
  function I18nManager() {
  }
  I18nManager.prototype.tr_61zpoe$ = function (key) {
    return I18N_SINGLE_DELIMITER + key;
  };
  I18nManager.prototype.ntr_rjan26$ = function (singularKey, pluralKey, value) {
    return I18N_PLURAL_DELIMITER + singularKey + I18N_PLURAL_DELIMITER + pluralKey + I18N_PLURAL_DELIMITER + toString(value);
  };
  I18nManager.prototype.trans_61zpoe$ = function (text) {
    var tmp$, tmp$_0;
    if (startsWith(text, I18N_SINGLE_DELIMITER)) {
      tmp$_0 = this.gettext_25kzsl$(text.substring(13), []);
    } else if (startsWith(text, I18N_PLURAL_DELIMITER)) {
      var tab = split(text.substring(13), [I18N_PLURAL_DELIMITER]);
      if (tab.size === 3) {
        tmp$_0 = this.ngettext_hjhpvv$(tab.get_za3lpa$(0), tab.get_za3lpa$(1), (tmp$ = toIntOrNull(tab.get_za3lpa$(2))) != null ? tmp$ : 1, []);
      } else {
        tmp$_0 = text;
      }
    } else {
      tmp$_0 = text;
    }
    return tmp$_0;
  };
  I18nManager.prototype.trans_pdl1vj$ = function (text) {
    return text != null ? this.trans_61zpoe$(text) : null;
  };
  I18nManager.$metadata$ = {kind: Kind_INTERFACE, simpleName: 'I18nManager', interfaces: []};
  function SimpleI18nManager() {
  }
  SimpleI18nManager.prototype.gettext_25kzsl$ = function (key, args) {
    return key;
  };
  SimpleI18nManager.prototype.ngettext_hjhpvv$ = function (singularKey, pluralKey, value, args) {
    return singularKey;
  };
  SimpleI18nManager.$metadata$ = {kind: Kind_CLASS, simpleName: 'SimpleI18nManager', interfaces: [I18nManager]};
  function BasicPanel(classes, init) {
    if (classes === void 0) {
      classes = emptySet();
    }if (init === void 0)
      init = null;
    Widget.call(this, classes);
    this.privateChildren = ArrayList_init();
    this.children = ArrayList_init();
    init != null ? init(this) : null;
  }
  BasicPanel.prototype.render = function () {
    return this.render_pjwf99$('div', this.childrenVNodes());
  };
  BasicPanel.prototype.childrenVNodes = function () {
    var $receiver = plus_0(this.privateChildren, this.children);
    var destination = ArrayList_init();
    var tmp$;
    tmp$ = $receiver.iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      if (element.visible)
        destination.add_11rb$(element);
    }
    var destination_0 = ArrayList_init_0(collectionSizeOrDefault(destination, 10));
    var tmp$_0;
    tmp$_0 = destination.iterator();
    while (tmp$_0.hasNext()) {
      var item = tmp$_0.next();
      destination_0.add_11rb$(item.renderVNode());
    }
    return copyToArray(destination_0);
  };
  BasicPanel.prototype.addPrivate_87eobz$ = function (child) {
    var tmp$;
    this.privateChildren.add_11rb$(child);
    (tmp$ = child.parent) != null ? tmp$.remove_87eobz$(child) : null;
    child.parent = this;
    this.refresh();
    return this;
  };
  BasicPanel.prototype.addInternal_87eobz$ = function (child) {
    var tmp$;
    this.children.add_11rb$(child);
    (tmp$ = child.parent) != null ? tmp$.remove_87eobz$(child) : null;
    child.parent = this;
    this.refresh();
    return this;
  };
  BasicPanel.prototype.add_87eobz$ = function (child) {
    return this.addInternal_87eobz$(child);
  };
  BasicPanel.prototype.addAll_xquxs0$ = function (children) {
    this.children.addAll_brywnq$(children);
    var destination = ArrayList_init_0(collectionSizeOrDefault(children, 10));
    var tmp$;
    tmp$ = children.iterator();
    while (tmp$.hasNext()) {
      var item = tmp$.next();
      var tmp$_0 = destination.add_11rb$;
      item.parent = this;
      tmp$_0.call(destination, Unit);
    }
    this.refresh();
    return this;
  };
  BasicPanel.prototype.remove_87eobz$ = function (child) {
    if (this.children.remove_11rb$(child)) {
      child.clearParent();
      this.refresh();
    }return this;
  };
  BasicPanel.prototype.removeAll = function () {
    var $receiver = this.children;
    var destination = ArrayList_init_0(collectionSizeOrDefault($receiver, 10));
    var tmp$;
    tmp$ = $receiver.iterator();
    while (tmp$.hasNext()) {
      var item = tmp$.next();
      destination.add_11rb$(item.clearParent());
    }
    this.children.clear();
    this.refresh();
    return this;
  };
  BasicPanel.prototype.disposeAll = function () {
    var tmp$;
    tmp$ = this.children.iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      element.dispose();
    }
    return this.removeAll();
  };
  BasicPanel.prototype.getChildren = function () {
    return this.children;
  };
  BasicPanel.prototype.dispose = function () {
    Widget.prototype.dispose.call(this);
    var tmp$;
    tmp$ = this.children.iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      element.dispose();
    }
    var tmp$_0;
    tmp$_0 = this.privateChildren.iterator();
    while (tmp$_0.hasNext()) {
      var element_0 = tmp$_0.next();
      element_0.dispose();
    }
    var $receiver = this.children;
    var destination = ArrayList_init_0(collectionSizeOrDefault($receiver, 10));
    var tmp$_1;
    tmp$_1 = $receiver.iterator();
    while (tmp$_1.hasNext()) {
      var item = tmp$_1.next();
      destination.add_11rb$(item.clearParent());
    }
    this.children.clear();
    var $receiver_0 = this.privateChildren;
    var destination_0 = ArrayList_init_0(collectionSizeOrDefault($receiver_0, 10));
    var tmp$_2;
    tmp$_2 = $receiver_0.iterator();
    while (tmp$_2.hasNext()) {
      var item_0 = tmp$_2.next();
      destination_0.add_11rb$(item_0.clearParent());
    }
    this.privateChildren.clear();
  };
  BasicPanel.$metadata$ = {kind: Kind_CLASS, simpleName: 'BasicPanel', interfaces: [Container, Widget]};
  var Side$LEFT_instance;
  var Side$RIGHT_instance;
  var Side$CENTER_instance;
  var Side$UP_instance;
  var Side$DOWN_instance;
  var FlexPanel$spacing_metadata = new PropertyMetadata('spacing');
  function ContainerType(name, ordinal, type) {
    Enum.call(this);
    this.type_8be2vx$ = type;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function ContainerType_initFields() {
    ContainerType_initFields = function () {
    };
    ContainerType$NONE_instance = new ContainerType('NONE', 0, '');
    ContainerType$FIXED_instance = new ContainerType('FIXED', 1, 'container');
    ContainerType$FLUID_instance = new ContainerType('FLUID', 2, 'container-fluid');
    ContainerType$SM_instance = new ContainerType('SM', 3, 'container-sm');
    ContainerType$MD_instance = new ContainerType('MD', 4, 'container-md');
    ContainerType$LG_instance = new ContainerType('LG', 5, 'container-lg');
    ContainerType$XL_instance = new ContainerType('XL', 6, 'container-xl');
  }
  var ContainerType$NONE_instance;
  function ContainerType$NONE_getInstance() {
    ContainerType_initFields();
    return ContainerType$NONE_instance;
  }
  var ContainerType$FIXED_instance;
  function ContainerType$FIXED_getInstance() {
    ContainerType_initFields();
    return ContainerType$FIXED_instance;
  }
  var ContainerType$FLUID_instance;
  function ContainerType$FLUID_getInstance() {
    ContainerType_initFields();
    return ContainerType$FLUID_instance;
  }
  var ContainerType$SM_instance;
  function ContainerType$SM_getInstance() {
    ContainerType_initFields();
    return ContainerType$SM_instance;
  }
  var ContainerType$MD_instance;
  function ContainerType$MD_getInstance() {
    ContainerType_initFields();
    return ContainerType$MD_instance;
  }
  var ContainerType$LG_instance;
  function ContainerType$LG_getInstance() {
    ContainerType_initFields();
    return ContainerType$LG_instance;
  }
  var ContainerType$XL_instance;
  function ContainerType$XL_getInstance() {
    ContainerType_initFields();
    return ContainerType$XL_instance;
  }
  ContainerType.$metadata$ = {kind: Kind_CLASS, simpleName: 'ContainerType', interfaces: [Enum]};
  function ContainerType$values() {
    return [ContainerType$NONE_getInstance(), ContainerType$FIXED_getInstance(), ContainerType$FLUID_getInstance(), ContainerType$SM_getInstance(), ContainerType$MD_getInstance(), ContainerType$LG_getInstance(), ContainerType$XL_getInstance()];
  }
  ContainerType.values = ContainerType$values;
  function ContainerType$valueOf(name) {
    switch (name) {
      case 'NONE':
        return ContainerType$NONE_getInstance();
      case 'FIXED':
        return ContainerType$FIXED_getInstance();
      case 'FLUID':
        return ContainerType$FLUID_getInstance();
      case 'SM':
        return ContainerType$SM_getInstance();
      case 'MD':
        return ContainerType$MD_getInstance();
      case 'LG':
        return ContainerType$LG_getInstance();
      case 'XL':
        return ContainerType$XL_getInstance();
      default:throwISE('No enum constant io.kvision.panel.ContainerType.' + name);
    }
  }
  ContainerType.valueOf_61zpoe$ = ContainerType$valueOf;
  function Root() {
    Root$Companion_getInstance();
    this.containerType_0 = null;
    this.addRow_0 = false;
    this.contextMenus_0 = ArrayList_init();
    this.rootVnode_0 = null;
    this.renderDisabled_8be2vx$ = false;
    this.isFirstRoot = Root$Companion_getInstance().roots_8be2vx$.isEmpty();
    Root$Companion_getInstance().roots_8be2vx$.add_11rb$(this);
    if (this.isFirstRoot) {
      var tmp$;
      tmp$ = Root$Companion_getInstance().modals_0.iterator();
      while (tmp$.hasNext()) {
        var element = tmp$.next();
        element.parent = this;
      }
    }}
  function Root$render$lambda($receiver) {
    var pairs = listOf(to('row', true));
    var $receiver_0 = new Object_init();
    var tmp$;
    tmp$ = pairs.iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      var key = element.component1(), value = element.component2();
      $receiver_0[key] = value;
    }
    $receiver.class = $receiver_0;
    return Unit;
  }
  Root.prototype.render = function () {
    var tmp$;
    if (this.addRow_0) {
      var tmp$_0 = 'div#' + toString(this.id);
      var tmp$_1 = getCallableRef('apply', function ($receiver_0, p1_0) {
        p1_0($receiver_0);
        return $receiver_0;
      }.bind(null, {}))(Root$render$lambda);
      var $receiver_0 = this.stylesVNodes_0();
      var elements = this.childrenVNodes();
      var $receiver_1 = $receiver_0.concat(elements);
      var elements_0 = this.modalsVNodes_0();
      var $receiver_2 = $receiver_1.concat(elements_0);
      var elements_1 = this.contextMenusVNodes_0();
      tmp$ = this.render_pjwf99$(tmp$_0, [h('div', tmp$_1, $receiver_2.concat(elements_1))]);
    } else {
      var tmp$_2 = 'div#' + toString(this.id);
      var $receiver_3 = this.stylesVNodes_0();
      var elements_2 = this.childrenVNodes();
      var $receiver_4 = $receiver_3.concat(elements_2);
      var elements_3 = this.modalsVNodes_0();
      var $receiver_5 = $receiver_4.concat(elements_3);
      var elements_4 = this.contextMenusVNodes_0();
      tmp$ = this.render_pjwf99$(tmp$_2, $receiver_5.concat(elements_4));
    }
    return tmp$;
  };
  function Root$addContextMenu$lambda$lambda(closure$contextMenu) {
    return function (e) {
      if (!e.dropDownCM)
        closure$contextMenu.hide();
      return Unit;
    };
  }
  function Root$addContextMenu$lambda(closure$contextMenu) {
    return function ($receiver) {
      $receiver.click = Root$addContextMenu$lambda$lambda(closure$contextMenu);
      return Unit;
    };
  }
  Root.prototype.addContextMenu_y7t574$ = function (contextMenu) {
    this.contextMenus_0.add_11rb$(contextMenu);
    contextMenu.parent = this;
    this.setInternalEventListener_a1up2z$(Root$addContextMenu$lambda(contextMenu));
    this.refresh();
  };
  function Root$stylesVNodes$lambda(it) {
    return it.generateStyle_8be2vx$();
  }
  Root.prototype.stylesVNodes_0 = function () {
    var tmp$;
    if (this.isFirstRoot) {
      if (!Style$Companion_getInstance().styles_8be2vx$.isEmpty()) {
        var stylesDesc = joinToString(Style$Companion_getInstance().styles_8be2vx$, '\n', void 0, void 0, void 0, void 0, Root$stylesVNodes$lambda);
        tmp$ = [h('style', [stylesDesc])];
      } else {
        tmp$ = [];
      }
    } else {
      tmp$ = [];
    }
    return tmp$;
  };
  Root.prototype.modalsVNodes_0 = function () {
    var tmp$;
    if (this.isFirstRoot) {
      var $receiver = Root$Companion_getInstance().modals_0;
      var destination = ArrayList_init();
      var tmp$_0;
      tmp$_0 = $receiver.iterator();
      while (tmp$_0.hasNext()) {
        var element = tmp$_0.next();
        if (element.visible)
          destination.add_11rb$(element);
      }
      var destination_0 = ArrayList_init_0(collectionSizeOrDefault(destination, 10));
      var tmp$_1;
      tmp$_1 = destination.iterator();
      while (tmp$_1.hasNext()) {
        var item = tmp$_1.next();
        destination_0.add_11rb$(item.renderVNode());
      }
      tmp$ = copyToArray(destination_0);
    } else {
      tmp$ = [];
    }
    return tmp$;
  };
  Root.prototype.contextMenusVNodes_0 = function () {
    var $receiver = this.contextMenus_0;
    var destination = ArrayList_init();
    var tmp$;
    tmp$ = $receiver.iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      if (element.visible)
        destination.add_11rb$(element);
    }
    var destination_0 = ArrayList_init_0(collectionSizeOrDefault(destination, 10));
    var tmp$_0;
    tmp$_0 = destination.iterator();
    while (tmp$_0.hasNext()) {
      var item = tmp$_0.next();
      destination_0.add_11rb$(item.renderVNode());
    }
    return copyToArray(destination_0);
  };
  Root.prototype.buildClassSet_xutoed$ = function (classSetBuilder) {
    SimplePanel.prototype.buildClassSet_xutoed$.call(this, classSetBuilder);
    if (this.containerType_0 !== ContainerType$NONE_getInstance()) {
      classSetBuilder.add_61zpoe$(this.containerType_0.type_8be2vx$);
    }};
  Root.prototype.reRender_8be2vx$ = function () {
    if (!this.renderDisabled_8be2vx$ && this.rootVnode_0 != null) {
      this.rootVnode_0 = KVManager_getInstance().patch_aevwwv$(ensureNotNull(this.rootVnode_0), this.renderVNode());
    }return this;
  };
  Root.prototype.restart_8be2vx$ = function () {
    if (this.rootVnode_0 != null) {
      this.rootVnode_0 = KVManager_getInstance().patch_aevwwv$(ensureNotNull(this.rootVnode_0), h('div'));
      this.rootVnode_0 = KVManager_getInstance().patch_aevwwv$(ensureNotNull(this.rootVnode_0), this.renderVNode());
    }};
  Root.prototype.getRoot = function () {
    return this;
  };
  Root.prototype.dispose = function () {
    SimplePanel.prototype.dispose.call(this);
    Root$Companion_getInstance().roots_8be2vx$.remove_11rb$(this);
    if (this.isFirstRoot) {
      Style$Companion_getInstance().styles_8be2vx$.clear();
      Root$Companion_getInstance().modals_0.clear();
    }};
  function Root$Companion() {
    Root$Companion_instance = this;
    this.counter_8be2vx$ = 0;
    this.modals_0 = ArrayList_init();
    this.roots_8be2vx$ = ArrayList_init();
  }
  Root$Companion.prototype.disposeAllRoots = function () {
    var tmp$;
    tmp$ = this.roots_8be2vx$.iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      element.dispose();
    }
    this.roots_8be2vx$.clear();
  };
  Root$Companion.prototype.getFirstRoot = function () {
    return !this.roots_8be2vx$.isEmpty() ? this.roots_8be2vx$.get_za3lpa$(0) : null;
  };
  Root$Companion.prototype.getLastRoot = function () {
    return !this.roots_8be2vx$.isEmpty() ? this.roots_8be2vx$.get_za3lpa$(this.roots_8be2vx$.size - 1 | 0) : null;
  };
  Root$Companion.prototype.addModal_y7t574$ = function (modal) {
    this.modals_0.add_11rb$(modal);
  };
  Root$Companion.prototype.removeModal_y7t574$ = function (modal) {
    this.modals_0.remove_11rb$(modal);
  };
  Root$Companion.$metadata$ = {kind: Kind_OBJECT, simpleName: 'Companion', interfaces: []};
  var Root$Companion_instance = null;
  function Root$Companion_getInstance() {
    if (Root$Companion_instance === null) {
      new Root$Companion();
    }return Root$Companion_instance;
  }
  Root.$metadata$ = {kind: Kind_CLASS, simpleName: 'Root', interfaces: [SimplePanel]};
  function Root_init_0(element, containerType, addRow, init, $this) {
    if (containerType === void 0)
      containerType = ContainerType$FLUID_getInstance();
    if (addRow === void 0)
      addRow = containerType !== ContainerType$FIXED_getInstance();
    if (init === void 0)
      init = null;
    $this = $this || Object.create(Root.prototype);
    SimplePanel.call($this);
    Root.call($this);
    var tmp$;
    $this.containerType_0 = containerType;
    $this.addRow_0 = addRow;
    $this.rootVnode_0 = KVManager_getInstance().patch_8hysnl$(element, $this.renderVNode());
    $this.id = 'kv_root_' + (tmp$ = Root$Companion_getInstance().counter_8be2vx$, Root$Companion_getInstance().counter_8be2vx$ = tmp$ + 1 | 0, tmp$);
    init != null ? init($this) : null;
    return $this;
  }
  function SimplePanel(classes, init) {
    if (classes === void 0) {
      classes = emptySet();
    }if (init === void 0)
      init = null;
    BasicPanel.call(this, classes);
    init != null ? init(this) : null;
  }
  SimplePanel.$metadata$ = {kind: Kind_CLASS, simpleName: 'SimplePanel', interfaces: [BasicPanel]};
  var Direction$HORIZONTAL_instance;
  var Direction$VERTICAL_instance;
  var Splitter$Companion_instance = null;
  var StackPanel$activeIndex_metadata = new PropertyMetadata('activeIndex');
  var StackPanel$Companion_instance = null;
  var HttpMethod$GET_instance;
  var HttpMethod$POST_instance;
  var HttpMethod$PUT_instance;
  var HttpMethod$DELETE_instance;
  var HttpMethod$OPTIONS_instance;
  var HttpMethod$HEAD_instance;
  var HTTP_UNAUTHORIZED;
  var RoutingManager_instance = null;
  var ObservableValue$value_metadata = new PropertyMetadata('value');
  var Scope$ROW_instance;
  var Scope$COL_instance;
  var TableType$STRIPED_instance;
  var TableType$BORDERED_instance;
  var TableType$BORDERLESS_instance;
  var TableType$HOVER_instance;
  var TableType$SMALL_instance;
  var TableType$DARK_instance;
  var ResponsiveType$RESPONSIVE_instance;
  var ResponsiveType$RESPONSIVESM_instance;
  var ResponsiveType$RESPONSIVEMD_instance;
  var ResponsiveType$RESPONSIVELG_instance;
  var ResponsiveType$RESPONSIVEXL_instance;
  var TheadType$DARK_instance;
  var TheadType$LIGHT_instance;
  var Table$headerNames_metadata = new PropertyMetadata('headerNames');
  var Table$types_metadata = new PropertyMetadata('types');
  var Table$caption_metadata = new PropertyMetadata('caption');
  var Table$responsiveType_metadata = new PropertyMetadata('responsiveType');
  var DateSerializer_instance = null;
  function Cache(capacity) {
    if (capacity === void 0)
      capacity = 50;
    this.capacity_0 = capacity;
    this.cache_0 = HashMap_init();
    this.insertionOrder_0 = new LinkedList();
  }
  Cache.prototype.set_xwzc9p$ = function (key, value) {
    var evictedKey = null;
    if (this.cache_0.size >= this.capacity_0) {
      evictedKey = this.getKeyToEvict_0();
      var $receiver = this.cache_0;
      var key_0 = evictedKey;
      var tmp$;
      (Kotlin.isType(tmp$ = $receiver, MutableMap) ? tmp$ : throwCCE()).remove_11rb$(key_0);
    }this.cache_0.put_xwzc9p$(key, value);
    this.insertionOrder_0.append_11rb$(key);
    return evictedKey;
  };
  Cache.prototype.get_11rb$ = function (key) {
    return this.cache_0.get_11rb$(key);
  };
  Cache.prototype.getKeyToEvict_0 = function () {
    return this.insertionOrder_0.removeAtIndex_za3lpa$(0);
  };
  Cache.prototype.toString = function () {
    return this.cache_0.toString();
  };
  Cache.$metadata$ = {kind: Kind_CLASS, simpleName: 'Cache', interfaces: []};
  function Node(value) {
    this.value = value;
    this.next = null;
    this.previous = null;
  }
  Node.$metadata$ = {kind: Kind_CLASS, simpleName: 'Node', interfaces: []};
  function LinkedList() {
    this.head_0 = null;
    this.isEmpty = this.head_0 == null;
  }
  LinkedList.prototype.first = function () {
    return this.head_0;
  };
  LinkedList.prototype.last = function () {
    var tmp$;
    var node = this.head_0;
    if (node != null) {
      while ((node != null ? node.next : null) != null) {
        node = node.next;
      }
      tmp$ = node;
    } else {
      tmp$ = null;
    }
    return tmp$;
  };
  LinkedList.prototype.count = function () {
    var tmp$;
    var node = this.head_0;
    if (node != null) {
      var counter = 1;
      while ((node != null ? node.next : null) != null) {
        node = node.next;
        counter = counter + 1 | 0;
      }
      tmp$ = counter;
    } else {
      tmp$ = 0;
    }
    return tmp$;
  };
  LinkedList.prototype.nodeAtIndex_za3lpa$ = function (index) {
    if (index >= 0) {
      var node = this.head_0;
      var i = index;
      while (node != null) {
        if (i === 0)
          return node;
        i = i - 1 | 0;
        node = node.next;
      }
    }return null;
  };
  LinkedList.prototype.append_11rb$ = function (value) {
    var newNode = new Node(value);
    var lastNode = this.last();
    if (lastNode != null) {
      newNode.previous = lastNode;
      lastNode.next = newNode;
    } else {
      this.head_0 = newNode;
    }
  };
  LinkedList.prototype.removeAll = function () {
    this.head_0 = null;
  };
  LinkedList.prototype.removeNode_eq15td$ = function (node) {
    var prev = node.previous;
    var next = node.next;
    if (prev != null) {
      prev.next = next;
    } else {
      this.head_0 = next;
    }
    next != null ? (next.previous = prev) : null;
    node.previous = null;
    node.next = null;
    return node.value;
  };
  LinkedList.prototype.removeLast = function () {
    var tmp$;
    var last = this.last();
    if (last != null) {
      tmp$ = this.removeNode_eq15td$(last);
    } else {
      tmp$ = null;
    }
    return tmp$;
  };
  LinkedList.prototype.removeAtIndex_za3lpa$ = function (index) {
    var tmp$;
    var node = this.nodeAtIndex_za3lpa$(index);
    if (node != null) {
      tmp$ = this.removeNode_eq15td$(node);
    } else {
      tmp$ = null;
    }
    return tmp$;
  };
  LinkedList.prototype.toString = function () {
    var s = '[';
    var node = this.head_0;
    while (node != null) {
      s += node.value.toString();
      node = node.next;
      if (node != null) {
        s += ', ';
      }}
    return s + ']';
  };
  LinkedList.$metadata$ = {kind: Kind_CLASS, simpleName: 'LinkedList', interfaces: []};
  var JSON_instance = null;
  var ENTER_KEY;
  var ESC_KEY;
  function delete_0(thing, key) {
    delete thing[key];
  }
  function on(target) {
    var obj = {};
    obj['self'] = target;
    return obj;
  }
  function emptyOn() {
    return {};
  }
  var auto;
  var normal;
  function asString($receiver) {
    var tmp$;
    switch ($receiver.second.name) {
      case 'auto':
        tmp$ = 'auto';
        break;
      case 'normal':
        tmp$ = 'normal';
        break;
      default:tmp$ = $receiver.first.toString() + $receiver.second.unit_8be2vx$;
        break;
    }
    return tmp$;
  }
  var hex;
  function toHexString($receiver) {
    var result = '';
    var num = $receiver;
    for (var i = 0; i < 6; i++) {
      result = hex[num & 15] + result;
      num = num >> 4;
    }
    return result;
  }
  function get_set($receiver) {
    var tmp$, tmp$_0;
    return (tmp$_0 = (tmp$ = $receiver != null ? split($receiver, [' ']) : null) != null ? toSet_0(tmp$) : null) != null ? tmp$_0 : emptySet();
  }
  function toCamelCase($receiver) {
    var regex = Regex_init('(-\\w)');
    var replace_20wsma$result;
    replace_20wsma$break: do {
      var match = regex.find_905azu$($receiver);
      if (match == null) {
        replace_20wsma$result = $receiver.toString();
        break replace_20wsma$break;
      }var lastStart = 0;
      var length = $receiver.length;
      var sb = StringBuilder_init(length);
      do {
        var foundMatch = ensureNotNull(match);
        sb.append_ezbsdh$($receiver, lastStart, foundMatch.range.start);
        sb.append_gw00v9$(drop(foundMatch.value, 1).toUpperCase());
        lastStart = foundMatch.range.endInclusive + 1 | 0;
        match = foundMatch.next();
      }
       while (lastStart < length && match != null);
      if (lastStart < length) {
        sb.append_ezbsdh$($receiver, lastStart, length);
      }replace_20wsma$result = sb.toString();
    }
     while (false);
    return replace_20wsma$result;
  }
  var package$io = _.io || (_.io = {});
  var package$kvision = package$io.kvision || (package$io.kvision = {});
  Object.defineProperty(package$kvision, 'KVManager', {get: KVManager_getInstance});
  var package$core = package$kvision.core || (package$kvision.core = {});
  package$core.AttributeSetBuilder = AttributeSetBuilder;
  package$core.AttributeSetBuilderImpl = AttributeSetBuilderImpl;
  package$core.buildAttributeSet_t5lcc8$ = buildAttributeSet;
  package$core.ClassSetBuilder = ClassSetBuilder;
  package$core.ClassSetBuilderImpl = ClassSetBuilderImpl;
  package$core.buildClassSet_ycocgk$ = buildClassSet;
  package$core.Component = Component;
  package$core.Container = Container;
  Object.defineProperty(UNIT, 'px', {get: UNIT$px_getInstance});
  Object.defineProperty(UNIT, 'pt', {get: UNIT$pt_getInstance});
  Object.defineProperty(UNIT, 'em', {get: UNIT$em_getInstance});
  Object.defineProperty(UNIT, 'cm', {get: UNIT$cm_getInstance});
  Object.defineProperty(UNIT, 'mm', {get: UNIT$mm_getInstance});
  Object.defineProperty(UNIT, 'in', {get: UNIT$in_getInstance});
  Object.defineProperty(UNIT, 'pc', {get: UNIT$pc_getInstance});
  Object.defineProperty(UNIT, 'ch', {get: UNIT$ch_getInstance});
  Object.defineProperty(UNIT, 'rem', {get: UNIT$rem_getInstance});
  Object.defineProperty(UNIT, 'vw', {get: UNIT$vw_getInstance});
  Object.defineProperty(UNIT, 'vh', {get: UNIT$vh_getInstance});
  Object.defineProperty(UNIT, 'vmin', {get: UNIT$vmin_getInstance});
  Object.defineProperty(UNIT, 'vmax', {get: UNIT$vmax_getInstance});
  Object.defineProperty(UNIT, 'perc', {get: UNIT$perc_getInstance});
  Object.defineProperty(UNIT, 'auto', {get: UNIT$auto_getInstance});
  Object.defineProperty(UNIT, 'normal', {get: UNIT$normal_getInstance});
  package$core.UNIT = UNIT;
  Object.defineProperty(BorderStyle, 'NONE', {get: BorderStyle$NONE_getInstance});
  Object.defineProperty(BorderStyle, 'HIDDEN', {get: BorderStyle$HIDDEN_getInstance});
  Object.defineProperty(BorderStyle, 'DOTTED', {get: BorderStyle$DOTTED_getInstance});
  Object.defineProperty(BorderStyle, 'DASHED', {get: BorderStyle$DASHED_getInstance});
  Object.defineProperty(BorderStyle, 'SOLID', {get: BorderStyle$SOLID_getInstance});
  Object.defineProperty(BorderStyle, 'DOUBLE', {get: BorderStyle$DOUBLE_getInstance});
  Object.defineProperty(BorderStyle, 'GROOVE', {get: BorderStyle$GROOVE_getInstance});
  Object.defineProperty(BorderStyle, 'RIDGE', {get: BorderStyle$RIDGE_getInstance});
  Object.defineProperty(BorderStyle, 'INSET', {get: BorderStyle$INSET_getInstance});
  Object.defineProperty(BorderStyle, 'OUTSET', {get: BorderStyle$OUTSET_getInstance});
  Object.defineProperty(BorderStyle, 'INITIAL', {get: BorderStyle$INITIAL_getInstance});
  Object.defineProperty(BorderStyle, 'INHERIT', {get: BorderStyle$INHERIT_getInstance});
  package$core.BorderStyle = BorderStyle;
  Object.defineProperty(Display, 'INLINE', {get: Display$INLINE_getInstance});
  Object.defineProperty(Display, 'BLOCK', {get: Display$BLOCK_getInstance});
  Object.defineProperty(Display, 'FLEX', {get: Display$FLEX_getInstance});
  Object.defineProperty(Display, 'GRID', {get: Display$GRID_getInstance});
  Object.defineProperty(Display, 'INLINEBLOCK', {get: Display$INLINEBLOCK_getInstance});
  Object.defineProperty(Display, 'INLINEFLEX', {get: Display$INLINEFLEX_getInstance});
  Object.defineProperty(Display, 'INLINEGRID', {get: Display$INLINEGRID_getInstance});
  Object.defineProperty(Display, 'INLINETABLE', {get: Display$INLINETABLE_getInstance});
  Object.defineProperty(Display, 'LISTITEM', {get: Display$LISTITEM_getInstance});
  Object.defineProperty(Display, 'RUNIN', {get: Display$RUNIN_getInstance});
  Object.defineProperty(Display, 'TABLE', {get: Display$TABLE_getInstance});
  Object.defineProperty(Display, 'TABLECAPTION', {get: Display$TABLECAPTION_getInstance});
  Object.defineProperty(Display, 'TABLECOLUMNGROUP', {get: Display$TABLECOLUMNGROUP_getInstance});
  Object.defineProperty(Display, 'TABLEHEADERGROUP', {get: Display$TABLEHEADERGROUP_getInstance});
  Object.defineProperty(Display, 'TABLEFOOTERGROUP', {get: Display$TABLEFOOTERGROUP_getInstance});
  Object.defineProperty(Display, 'TABLEROWGROUP', {get: Display$TABLEROWGROUP_getInstance});
  Object.defineProperty(Display, 'TABLECELL', {get: Display$TABLECELL_getInstance});
  Object.defineProperty(Display, 'TABLECOLUMN', {get: Display$TABLECOLUMN_getInstance});
  Object.defineProperty(Display, 'TABLEROW', {get: Display$TABLEROW_getInstance});
  Object.defineProperty(Display, 'CONTENTS', {get: Display$CONTENTS_getInstance});
  Object.defineProperty(Display, 'NONE', {get: Display$NONE_getInstance});
  Object.defineProperty(Display, 'INITIAL', {get: Display$INITIAL_getInstance});
  Object.defineProperty(Display, 'INHERIT', {get: Display$INHERIT_getInstance});
  package$core.Display = Display;
  Object.defineProperty(Color, 'Companion', {get: Color$Companion_getInstance});
  package$core.Color = Color;
  package$core.TooltipOptions = TooltipOptions;
  package$core.toJs_p6ncg8$ = toJs;
  package$core.PopoverOptions = PopoverOptions;
  package$core.toJs_xvookq$ = toJs_0;
  package$core.SingleObjectCache = SingleObjectCache;
  package$core.LazyCache = LazyCache;
  Object.defineProperty(Style, 'Companion', {get: Style$Companion_getInstance});
  package$core.Style = Style;
  Object.defineProperty(StyledComponent, 'Companion', {get: StyledComponent$Companion_getInstance});
  package$core.StyledComponent = StyledComponent;
  Object.defineProperty(Easing, 'SWING', {get: Easing$SWING_getInstance});
  Object.defineProperty(Easing, 'LINEAR', {get: Easing$LINEAR_getInstance});
  package$core.Easing = Easing;
  Widget.RefreshDelegateProvider = Widget$RefreshDelegateProvider;
  Widget.RefreshDelegate = Widget$RefreshDelegate;
  Object.defineProperty(Widget, 'Companion', {get: Widget$Companion_getInstance});
  package$core.Widget = Widget;
  var package$form = package$kvision.form || (package$kvision.form = {});
  $$importsForInline$$['kotlinx-serialization-kotlinx-serialization-core-jsLegacy'] = $module$kotlinx_serialization_kotlinx_serialization_core_jsLegacy;
  package$form.FormInput = FormInput;
  package$form.FormControl = FormControl;
  package$form.StringFormControl = StringFormControl;
  package$form.NumberFormControl = NumberFormControl;
  package$form.BoolFormControl = BoolFormControl;
  package$form.DateFormControl = DateFormControl;
  package$form.KFilesFormControl = KFilesFormControl;
  package$form.GenericFormControl = GenericFormControl;
  var package$utils = package$kvision.utils || (package$kvision.utils = {});
  package$utils.get_set_5cw0du$ = get_set;
  var package$html = package$kvision.html || (package$kvision.html = {});
  Object.defineProperty(Canvas, 'Companion', {get: Canvas$Companion_getInstance});
  package$html.Canvas = Canvas;
  package$html.TextNode = TextNode;
  var package$i18n = package$kvision.i18n || (package$kvision.i18n = {});
  Object.defineProperty(package$i18n, 'I18n', {get: I18n_getInstance});
  package$i18n.I18nManager = I18nManager;
  package$i18n.SimpleI18nManager = SimpleI18nManager;
  var package$panel = package$kvision.panel || (package$kvision.panel = {});
  package$panel.BasicPanel = BasicPanel;
  Object.defineProperty(ContainerType, 'NONE', {get: ContainerType$NONE_getInstance});
  Object.defineProperty(ContainerType, 'FIXED', {get: ContainerType$FIXED_getInstance});
  Object.defineProperty(ContainerType, 'FLUID', {get: ContainerType$FLUID_getInstance});
  Object.defineProperty(ContainerType, 'SM', {get: ContainerType$SM_getInstance});
  Object.defineProperty(ContainerType, 'MD', {get: ContainerType$MD_getInstance});
  Object.defineProperty(ContainerType, 'LG', {get: ContainerType$LG_getInstance});
  Object.defineProperty(ContainerType, 'XL', {get: ContainerType$XL_getInstance});
  package$panel.ContainerType = ContainerType;
  Object.defineProperty(Root, 'Companion', {get: Root$Companion_getInstance});
  package$panel.Root_init_39w7fw$ = Root_init_0;
  package$panel.Root = Root;
  package$panel.SimplePanel = SimplePanel;
  package$utils.Cache = Cache;
  package$utils.Node = Node;
  package$utils.LinkedList = LinkedList;
  package$utils.delete_hwpqgh$ = delete_0;
  package$utils.on_pbzkfn$ = on;
  package$utils.emptyOn_8be2vx$ = emptyOn;
  package$utils.asString_ebgrb4$ = asString;
  package$utils.toHexString_s8ev3n$ = toHexString;
  package$utils.toCamelCase_pdl1vz$ = toCamelCase;
  AttributeSetBuilderImpl.prototype.add_lcqont$ = AttributeSetBuilder.prototype.add_lcqont$;
  AttributeSetBuilderImpl.prototype.addAll_y0zsll$ = AttributeSetBuilder.prototype.addAll_y0zsll$;
  AttributeSetBuilderImpl.prototype.add_puj7f4$ = AttributeSetBuilder.prototype.add_puj7f4$;
  ClassSetBuilderImpl.prototype.add_vqcfem$ = ClassSetBuilder.prototype.add_vqcfem$;
  Container.prototype.focus = Component.prototype.focus;
  Container.prototype.blur = Component.prototype.blur;
  LazyCache.prototype.clearOn_u332lz$ = SingleObjectCache.prototype.clearOn_u332lz$;
  Widget.prototype.focus = Component.prototype.focus;
  Widget.prototype.blur = Component.prototype.blur;
  BasicPanel.prototype.invoke_4h7hma$ = Container.prototype.invoke_4h7hma$;
  BasicPanel.prototype.unaryPlus_pdl1vz$ = Container.prototype.unaryPlus_pdl1vz$;
  FormInput.prototype.focus = Component.prototype.focus;
  FormInput.prototype.blur = Component.prototype.blur;
  FormControl.prototype.focus = Component.prototype.focus;
  FormControl.prototype.blur = Component.prototype.blur;
  StringFormControl.prototype.focus = FormControl.prototype.focus;
  StringFormControl.prototype.blur = FormControl.prototype.blur;
  NumberFormControl.prototype.focus = FormControl.prototype.focus;
  NumberFormControl.prototype.blur = FormControl.prototype.blur;
  BoolFormControl.prototype.focus = FormControl.prototype.focus;
  BoolFormControl.prototype.blur = FormControl.prototype.blur;
  DateFormControl.prototype.focus = FormControl.prototype.focus;
  DateFormControl.prototype.blur = FormControl.prototype.blur;
  KFilesFormControl.prototype.focus = FormControl.prototype.focus;
  KFilesFormControl.prototype.blur = FormControl.prototype.blur;
  GenericFormControl.prototype.focus = FormControl.prototype.focus;
  GenericFormControl.prototype.blur = FormControl.prototype.blur;
  I18n.prototype.tr_61zpoe$ = I18nManager.prototype.tr_61zpoe$;
  I18n.prototype.ntr_rjan26$ = I18nManager.prototype.ntr_rjan26$;
  I18n.prototype.trans_61zpoe$ = I18nManager.prototype.trans_61zpoe$;
  I18n.prototype.trans_pdl1vj$ = I18nManager.prototype.trans_pdl1vj$;
  SimpleI18nManager.prototype.tr_61zpoe$ = I18nManager.prototype.tr_61zpoe$;
  SimpleI18nManager.prototype.ntr_rjan26$ = I18nManager.prototype.ntr_rjan26$;
  SimpleI18nManager.prototype.trans_61zpoe$ = I18nManager.prototype.trans_61zpoe$;
  SimpleI18nManager.prototype.trans_pdl1vj$ = I18nManager.prototype.trans_pdl1vj$;
  DEFAULT_STEP = 1;
  KVNULL = '#kvnull';
  I18N_SINGLE_DELIMITER = '###KvI18nS###';
  I18N_PLURAL_DELIMITER = '###KvI18nP###';
  HTTP_UNAUTHORIZED = 401;
  ENTER_KEY = 13;
  ESC_KEY = 27;
  auto = new Pair(0, UNIT$auto_getInstance());
  normal = new Pair(0, UNIT$normal_getInstance());
  hex = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f'];
  return _;
}));

//# sourceMappingURL=kvision-jsLegacy.js.map
